 // Structured eligibility data for all scholarships
 import { EligibilityCriteria } from '@/types/eligibility';
 
 // Eligibility data keyed by scholarship ID
 export const scholarshipEligibility: Record<string, EligibilityCriteria> = {
   // ============================================
   // URGENT DEADLINES (1-30 days)
   // ============================================
   
   // Gates Scholarship
   "1": {
     minGPA: 3.3,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresPellGrant: true,
     requiresFinancialNeed: true,
     requiredActivities: ['leadership', 'community-service'],
     requiresFAFSA: true,
     targetEthnicities: ['african-american', 'hispanic-latino', 'asian', 'pacific-islander', 'native-american'],
   },
   
   // Coca-Cola Scholars
   "2": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiredActivities: ['leadership', 'community-service'],
   },
   
   // Elks Most Valuable Student
   "3": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen'],
     requiresFinancialNeed: true,
     requiredActivities: ['leadership', 'community-service'],
   },
   
   // Horatio Alger Scholarship
   "4": {
     minGPA: 2.0,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen'],
     requiresFinancialNeed: true,
   },
   
   // Burger King Scholars
   "5": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   
   // Dell Scholars Program
   "6": {
     minGPA: 2.4,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresFinancialNeed: true,
     requiresFAFSA: true,
   },
   
   // ============================================
   // AFRICAN AMERICAN SCHOLARSHIPS
   // ============================================
   
   // Ron Brown Scholar
   "7": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     targetEthnicities: ['african-american'],
     requiredActivities: ['leadership', 'community-service'],
   },
   
   // Jackie Robinson Foundation
   "8": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen'],
     requiresFinancialNeed: true,
     targetEthnicities: ['african-american', 'hispanic-latino', 'asian', 'pacific-islander', 'native-american'],
   },
   
   // UNCF General Scholarship
   "9": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresFinancialNeed: true,
     requiresFAFSA: true,
     targetEthnicities: ['african-american'],
   },
   
   // Thurgood Marshall College Fund
   "10": {
     minGPA: 3.0,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     targetEthnicities: ['african-american'],
   },
   
   // ============================================
   // HEALTHCARE SCHOLARSHIPS
   // ============================================
   
   // Kaiser Permanente
   "11": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['health'],
     targetStates: ['California'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   // HOSA Future Health Professionals
   "13": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-junior', 'high-school-senior'],
     requiredMajors: ['health'],
     requiresMembership: 'HOSA',
   },
   
   // ============================================
   // STEM SCHOLARSHIPS
   // ============================================
   
   // NSBE Scholarships
   "14": {
     minGPA: 3.0,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['stem'],
     targetEthnicities: ['african-american'],
     requiresMembership: 'NSBE',
   },
   
   // Google Lime Scholarship
   "15": {
     minGPA: 3.0,
     targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     requiredMajors: ['stem'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresDisability: true,
   },
   
   // Society of Women Engineers
   "16": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['stem'],
     targetGenders: ['female'],
   },
   // ============================================
   // LOS ANGELES LOCAL SCHOLARSHIPS
   // ============================================
   
   // LA Promise Fund
   "18": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
     residencyRequired: true,
   },
   
   // Edison Scholars
   "19": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     requiredMajors: ['stem'],
     targetStates: ['California'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   
   // LA County Medical Association
   "20": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
     requiredMajors: ['health'],
     targetStates: ['California'],
   },
   
   // Dodgers Foundation
   "21": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
     requiredActivities: ['athletics'],
   },
   
  // REMOVED: #22 Lakers Youth Foundation
   
   // ============================================
   // FIRST-GENERATION SCHOLARSHIPS
   // ============================================
   
   // QuestBridge National College Match (Juniors/Seniors only)
   "23": {
     minGPA: 3.5,
     targetGradeLevels: ['high-school-junior', 'high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresFirstGen: true,
     requiresFinancialNeed: true,
   },
   
   // I'm First Scholarship
   // REMOVED: #24 I'm First Scholarship — duplicate of ID 48
   
   // Posse Foundation
   "25": {
     targetGradeLevels: ['high-school-senior'],
     nominationRequired: true,
     requiredActivities: ['leadership'],
   },
   
   // ============================================
   // ARTS & WRITING SCHOLARSHIPS
   // ============================================
   
   // Scholastic Art & Writing Awards
   "26": {
     minAge: 13,
     maxAge: 18,
     targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     requiredMajors: ['arts'],
   },
   
   // YoungArts Foundation
   "27": {
     minAge: 15,
     maxAge: 18,
     targetGradeLevels: ['high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     requiredMajors: ['arts'],
   },
   
   // ============================================
   // COMMUNITY SERVICE SCHOLARSHIPS
   // ============================================
   
   // REMOVED: #28 Prudential Spirit of Community — discontinued in 2022, replaced by "Emerging Visionaries"
   
   // Bonner Scholars Program
   "29": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     requiresFinancialNeed: true,
     requiredActivities: ['community-service'],
   },
   
   // Regeneron Science Talent Search
   "30": {
     minGPA: 3.5,
     targetGradeLevels: ['high-school-senior'],
     requiredMajors: ['stem'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   
   // Jack Kent Cooke Foundation
   "31": {
     minGPA: 3.5,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresFinancialNeed: true,
   },
   
   // Foot Locker Scholar Athletes
   "32": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiredActivities: ['athletics', 'community-service'],
   },
   
   // ============================================
   // ROLLING/YEAR-ROUND SCHOLARSHIPS
   // ============================================
   
   // Niche $2,000 No Essay
   "33": {
     noEssayRequired: true,
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   
   // REMOVED: #34 Bold.org Scholarships — duplicate of ID 160
   
   // Cal Grant A
   "35": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
     requiresFAFSA: true,
     citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
   },
   
   // Cal Grant B
   "36": {
     minGPA: 2.0,
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
     requiresFAFSA: true,
     requiresFinancialNeed: true,
     citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
   },
   
   // Middle Class Scholarship
   "37": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     targetStates: ['California'],
     requiresFAFSA: true,
   },
   
   // Ayn Rand Atlas Shrugged Essay
   "38": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
   },
   
   // REMOVED: #39 JFK Profile in Courage Essay — duplicate of ID 139
   
   // Laws of Life Essay Contest
   "40": {
     targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
   },
   
   // REMOVED: #41 Scholarships360 — duplicate of ID 163
   
   // REMOVED: #42 Unigo $10K — duplicate of ID 168
   
   // Nitro College Scholarship
   "43": {
     noEssayRequired: true,
   },
   
   // National Merit Scholarship
   "44": {
     targetGradeLevels: ['high-school-junior'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   // NCAA Division I Athletic
   "46": {
     minGPA: 2.3,
     targetGradeLevels: ['high-school-senior'],
     requiredActivities: ['athletics'],
   },
   
   // Women's Sports Foundation
   "47": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     targetGenders: ['female'],
     requiredActivities: ['athletics'],
   },
   
   // I'm First! Scholarship
   "48": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     requiresFirstGen: true,
   },
   
   // First in Family Scholarship
   "49": {
     minGPA: 2.5,
     targetGradeLevels: ['high-school-senior'],
     requiresFirstGen: true,
     requiresFinancialNeed: true,
     requiresFAFSA: true,
   },
   
   // Society of Women Engineers (duplicate entry as 50)
 
   
   // NCWIT Aspirations in Computing
   "51": {
     targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     requiredMajors: ['stem'],
     targetGenders: ['female'],
   },
   
   // Hispanic Scholarship Fund
   "52": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     targetEthnicities: ['hispanic-latino'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresFAFSA: true,
   },
   // REMOVED: #54 Point Foundation Scholarship — duplicate of ID 184
   
   // PFLAG Scholarships
   "55": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
   },
   
   // Lime Connect Scholarship
   "56": {
     minGPA: 3.0,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresDisability: true,
   },
   
   // Anne Ford Scholarship
   "57": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     citizenshipRequired: ['us-citizen'],
     requiresDisability: true,
   },
   
   // Children of Fallen Patriots
   "58": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiresMilitaryConnection: true,
     requiresFAFSA: true,
   },
   
   // Pat Tillman Foundation
   "59": {
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     requiresMilitaryConnection: true,
   },
   
   // Science Olympiad Alumni Scholarship
   "60": {
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['stem'],
   },
   // Tylenol Future Care Scholarship
   "62": {
     minGPA: 3.0,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     requiredMajors: ['health'],
   },
   
   // NSNA Foundation Scholarship
   "63": {
     minGPA: 2.5,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['health'],
     requiresMembership: 'NSNA',
   },
   
   // NSHSS Business Scholarship
   "64": {
     targetGradeLevels: ['high-school-senior'],
     requiredMajors: ['business'],
     requiresMembership: 'NSHSS',
   },
   
   // NFTE Entrepreneurship Challenge
   "65": {
     targetGradeLevels: ['high-school-junior', 'high-school-senior'],
     requiredMajors: ['business'],
   },
   
   // Teach For America Corps
   // REMOVED: #66 Teach For America Corps — requires bachelor's degree, service program not scholarship
   
   // REMOVED: #67 TEACH Grant — federal grant for college students, not high school
   
   // National Trumpet Competition
   "68": {
     minAge: 13,
     maxAge: 29,
     requiredMajors: ['arts'],
   },
   
   // REMOVED: #69 National YoungArts Dance — duplicate of ID 27
   // Asian & Pacific Islander Scholarship
   "72": {
     minGPA: 2.7,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     targetEthnicities: ['asian', 'pacific-islander'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
     requiresFAFSA: true,
   },
   
   // American Indian College Fund
   "73": {
     minGPA: 2.0,
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     targetEthnicities: ['native-american'],
     requiresFinancialNeed: true,
   },
   
   // NABJ Student Scholarship
   "74": {
     minGPA: 2.5,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     targetEthnicities: ['african-american'],
   },
   
   // James Beard Foundation Scholarship
   "75": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['arts'],
     requiresFinancialNeed: true,
   },
   
   // SMART Scholarship (DoD)
   "76": {
     minGPA: 3.0,
     targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     requiredMajors: ['stem'],
     citizenshipRequired: ['us-citizen'],
   },
   // REMOVED: #78 Davis-UWC Scholars — only for graduates of 18 specific United World College schools
   
   // Los Angeles Urban League
   "79": {
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
     requiresFinancialNeed: true,
     requiredActivities: ['community-service'],
   },
   
   // LA County Office of Education
   "80": {
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
   },
   
   // Bezos Scholars Program
   "81": {
     targetGradeLevels: ['high-school-junior'],
     nominationRequired: true,
   },
   
   // REMOVED: #82 Echoing Green Fellowship — for social entrepreneurs age 18+, not educational scholarship
   
   // REMOVED: #83 AAUW Career Development Grant — for women seeking career advancement, not high school
   
   // Actuarial Diversity Scholarship
   "84": {
     minGPA: 3.0,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['business', 'stem'],
     targetEthnicities: ['african-american', 'hispanic-latino', 'native-american'],
   },
   
   // Cappex Easy Money
   "85": {
     noEssayRequired: true,
   },
   
   // Fastweb $1,000 Drawing
   "86": {
     noEssayRequired: true,
   },
   
   // Peterson's Scholarship
   "87": {
     noEssayRequired: true,
   },
   
   // Chegg $1,000 Monthly
   "88": {
     noEssayRequired: true,
   },
   
   // REMOVED: #89 Truman Scholarship — requires college junior status
   
   // REMOVED: #90 Marshall Scholarship — requires bachelor's degree, for UK graduate study
   
   // REMOVED: #91 Rhodes Scholarship — requires bachelor's degree, for Oxford graduate study
   
   // REMOVED: #92 Fulbright U.S. Student Program — requires bachelor's degree or near-completion
   
   // Dr Pepper Tuition Giveaway
   "93": {
     minAge: 18,
     maxAge: 24,
     videoRequired: true,
   },
   
   // Taco Bell Live Más Scholarship
   "94": {
     minAge: 16,
     maxAge: 24,
     videoRequired: true,
   },
   
   // Chick-fil-A Remarkable Futures
   "95": {
     targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiresEmployment: 'Chick-fil-A',
   },
   
   // Amazon Future Engineer Scholarship
   "96": {
     minGPA: 3.0,
     targetGradeLevels: ['high-school-senior'],
     requiredMajors: ['stem'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
   
   // Google Lime Scholarship (duplicate as 97)
 
   
   // REMOVED: #98 Microsoft Scholarship Program — duplicate of ID 17
   
   // Cal Grant C
   "99": {
     targetStates: ['California'],
     requiresFAFSA: true,
     citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
   },
   
   // California Chafee Grant
   "100": {
     maxAge: 26,
     targetStates: ['California'],
     requiresFAFSA: true,
     requiresFosterCare: true,
   },
   
   // Golden State Teacher Grant
   "101": {
     targetGradeLevels: ['college-junior', 'college-senior', 'graduate'],
     targetStates: ['California'],
     requiredMajors: ['education'],
   },
   
   // California Dream Act Application
   "102": {
     targetStates: ['California'],
     citizenshipRequired: ['daca', 'undocumented'],
   },
   
   // UC Regents Scholarship
   "103": {
     minGPA: 3.8,
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
   },
   
   // CSU Trustees Award
   "104": {
     minGPA: 3.5,
     targetGradeLevels: ['high-school-senior'],
     targetStates: ['California'],
     requiresFinancialNeed: true,
     requiresFAFSA: true,
   },
   // Johnson & Johnson Scholarship
   "109": {
     minGPA: 3.0,
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
     requiredMajors: ['health'],
   },
   
   // CVS Health Scholarship
   "110": {
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['health'],
   },
   
   // Walgreens Diversity Scholarship
   "111": {
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['health'],
     targetEthnicities: ['african-american', 'hispanic-latino', 'asian', 'native-american'],
   },
   
   // SEO Scholars
   "112": {
     targetGradeLevels: ['high-school-freshman'],
     targetStates: ['New York'],
     requiresFinancialNeed: true,
   },
   // Jumpstart Advisory Group
   "114": {
     targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
     requiredMajors: ['business'],
     targetEthnicities: ['african-american', 'hispanic-latino'],
   },
   
   // Princess Grace Awards
   "115": {
     targetGradeLevels: ['college-junior', 'college-senior', 'graduate'],
     requiredMajors: ['arts'],
     nominationRequired: true,
   },
   
   // REMOVED: #116 Jerome Foundation — artist grants for early-career professionals in MN/NYC, not student scholarships
   
   // REMOVED: Jefferson Awards (117) - recognition org, not scholarship
   
   // Points of Light Foundation
   "118": {
     targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     requiredActivities: ['community-service'],
   },
   
   // DoSomething.org Scholarships
   "119": {
     minAge: 13,
     maxAge: 25,
     requiredActivities: ['community-service'],
   },
  
   // ============================================
   // SOPHOMORE-SPECIFIC SCHOLARSHIPS (120-127)
   // ============================================
  
   // REMOVED: #120 Scholastic Art & Writing Awards — duplicate of ID 26
  
   // REMOVED: #121 Voice of Democracy — duplicate of ID 155
  
   // Carson Scholars (grades 4-11, we track 6+)
   "122": {
     minGPA: 3.75,
     targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior'],
     requiredActivities: ['community-service'],
     nominationRequired: true,
   },
  
   // Emerging Visionaries Award (formerly Prudential Spirit of Community)
   "123": {
     targetGradeLevels: ['middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     requiredActivities: ['community-service'],
     citizenshipRequired: ['us-citizen', 'permanent-resident'],
   },
  
   // NCWIT Award for Aspirations in Computing
   "124": {
     targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     targetGenders: ['female'],
     requiredMajors: ['stem'],
   },
  
   // Doodle for Google (K-12)
   "125": {
     targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
   },
  
   // REMOVED: National Geographic Young Explorers (126) - 18+ only
  
   // Stuck at Prom Scholarship
   "127": {
     targetGradeLevels: ['high-school-sophomore', 'high-school-junior', 'high-school-senior'],
     noEssayRequired: true,
     videoRequired: true,
   },
 
  // ============================================
  // JUNIOR-SPECIFIC SCHOLARSHIPS (128-137)
  // ============================================
 
  // QuestBridge College Prep Scholars
  "128": {
    targetGradeLevels: ['high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
    minGPA: 3.5,
  },
 
  // REMOVED: Jack Kent Cooke Young Scholars (129) - 7th graders only
 
  // Bank of America Student Leaders
  "130": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['leadership', 'community-service'],
  },
 
  // NSHSS Foundation Scholarships
  "131": {
    minGPA: 3.5,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiresMembership: 'NSHSS Member',
  },
 
  // Telluride Association Summer Program
  "132": {
    targetGradeLevels: ['high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'international'],
  },
 
  // Congress-Bundestag Youth Exchange
  "133": {
    minAge: 15,
    maxAge: 18,
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
 
  // REMOVED: #134 Regeneron STS — DUPLICATE of ID 30
 
  // REMOVED: #135 National Young Arts Foundation — duplicate of ID 27
 
  // Girls Who Code Summer Program
  "136": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    targetGenders: ['female', 'non-binary'],
    requiredMajors: ['stem'],
  },
 
  // REMOVED: #137 Posse Foundation Leadership — duplicate of ID 25
 
  // ============================================
  // SOPHOMORE-ELIGIBLE SCHOLARSHIPS (138-157)
  // ============================================
 
  // Optimist International Essay Contest (no minimum age, under 19)
  "138": {
    maxAge: 18,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
 
  // JFK Profile in Courage Essay Contest
  "139": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'international'],
  },
 
  // USIP National Peace Essay Contest
  "140": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'international'],
  },
 
  // Congressional Award
  // Rotary Club Scholarships
  "142": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service', 'leadership'],
  },
 
  // Lions Club Scholarships
  "143": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service'],
  },
 
  // DECA Emerging Leaders Scholarship
  "144": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['business'],
    requiresMembership: 'DECA',
  },
 
  // FBLA National Scholarships
  "145": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['business'],
    requiresMembership: 'FBLA',
  },
 
  // Key Club International Scholarships
  "146": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service', 'leadership'],
    requiresMembership: 'Key Club',
  },
 
  // 4-H Youth in Action Award
  "147": {
    minAge: 14,
    maxAge: 18,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiresMembership: '4-H',
  },
 
  // FFA Scholarships
  "148": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['stem'],
    requiresMembership: 'FFA',
  },
 
  // Science Olympiad Scholarships
  "149": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['stem'],
  },
 
  // Girl Scouts Gold Award Scholarships
  "150": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    targetGenders: ['female'],
    requiredActivities: ['community-service', 'leadership'],
    requiresMembership: 'Girl Scouts',
  },
 
  // Eagle Scout Scholarships
  "151": {
    minAge: 10,
    maxAge: 18,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service', 'leadership'],
    requiresMembership: 'Boy Scouts',
  },
 
  // REMOVED: #152 Scholastic Art & Writing Regional — duplicate of ID 26
 
  // REMOVED: #153 MATHCOUNTS State Competition — competition with prizes, not scholarship (same issue as removed ID 250)
 
  // Community Foundation Scholarships
  "154": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    residencyRequired: true,
  },
 
  // VFW Voice of Democracy
  "155": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
 
  // American Legion Oratorical Contest
  "156": {
    maxAge: 20,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
 
  // REMOVED: #157 Elks Hoop Shoot — basketball competition for ages 8-13, NOT a scholarship

  // ============================================
  // NO-ESSAY SCHOLARSHIPS (IDs 158-172)
  // ============================================
  
  // Niche $500 Sophomore Scholarship
  "158": {
    targetGradeLevels: ['high-school-sophomore'],
    noEssayRequired: true,
  },
  // Bold.org Be Bold
  "160": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    noEssayRequired: true,
  },
  // Scholarships360 $10K No-Essay
  "163": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    noEssayRequired: true,
  },
  // BigFuture College Board
  "165": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    noEssayRequired: true,
  },

  // CollegeXpress
  "166": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    noEssayRequired: true,
  },

  // Christian Connector
  "167": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    noEssayRequired: true,
  },

  // Unigo $10,000
  "168": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    noEssayRequired: true,
  },

  // Access Scholarships Quarterly
  "169": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca', 'undocumented'],
    noEssayRequired: true,
  },

  // March For Our Lives
  "170": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredActivities: ['community-service'],
    noEssayRequired: true,
  },

  // $1,000 Photo Scholarship
  "171": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    noEssayRequired: true,
  },
  // ============================================
  // STEM SCHOLARSHIPS (IDs 173-187)
  // ============================================
  
  // Davidson Fellows
  "173": {
    maxAge: 18,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['stem', 'arts'],
  },

  // Edison Scholars
  // REMOVED: #175 National STEM Excellence Award — misattributed to wrong org; STEM Education Coalition doesn't offer this

  // REMOVED: #176 SWE Women in STEM — DUPLICATE of ID 16/50

  // RevPart STEM
  "177": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
  },

  // AfterCollege STEM Inclusion
  "178": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
  },

  // NSHSS STEM
  "179": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    requiredMajors: ['stem'],
  },

  // REMOVED: #180 Regeneron STS — DUPLICATE of ID 30

  // Toshiba ExploraVision (K-12 competition)
  "181": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['stem'],
  },

  // REMOVED: #182 Society of Women Engineers — DUPLICATE of ID 16/50

  // Simon Scholars
  "183": {
    targetGradeLevels: ['high-school-sophomore'],
    targetStates: ['California'],
    requiresFinancialNeed: true,
  },

  // Point Foundation
  "184": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    requiredActivities: ['leadership'],
  },

  // Chevron ScholarSHPE
  "185": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['hispanic-latino'],
    requiredMajors: ['stem'],
  },
  // SNC Women in STEM
  // ============================================
  // HEALTHCARE/PRE-MED SCHOLARSHIPS (IDs 188-198)
  // ============================================
  
  // GMiS California Medical
  "188": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetStates: ['California'],
    requiredMajors: ['stem'],
  },

  // HealthArc Technology
  "189": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
  },

  // Pro-Care Medical
  "190": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
  },

  // Caretakers on the Climb Nursing
  // NJ Brain and Spine
  "192": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
  },
  // REMOVED: #194 HCAI Associate Nursing — duplicate of ID 193

  // AvaCare Medical
  "195": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
    requiredActivities: ['community-service'],
  },
  // REMOVED ID 197: UCI Young Scholars Fellowship - URL confirmed broken (404 error)

  // Dr. David Webb Future Doctors
  // ============================================
  // FIRST-GENERATION SCHOLARSHIPS (IDs 199-206)
  // ============================================
  
  // NSHSS First-Gen 2026
  "199": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    requiresFirstGen: true,
  },

  // TIAA First-Gen
  "200": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiresFirstGen: true,
    requiredActivities: ['leadership'],
  },

  // Clarkston Scholars
  // College JumpStart
  "202": {
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // Fontana Transport
  // Dorrance AZ
  "204": {
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['Arizona'],
    requiresFirstGen: true,
    requiresFinancialNeed: true,
  },

  // Kadzai Law Group First-Gen
  // Coca-Cola First Gen HBCU
  "206": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiresFirstGen: true,
    targetEthnicities: ['african-american'],
  },

  // ============================================
  // HISPANIC/LATINO SCHOLARSHIPS (IDs 207-216)
  // ============================================
  
  // REMOVED: #207 Hispanic Scholarship Fund — duplicate of ID 52

  // HSF Youth Leadership Institute
  "208": {
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    targetEthnicities: ['hispanic-latino'],
    requiredActivities: ['leadership'],
  },

  // SHPE Foundation Scholarships
  "209": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['hispanic-latino'],
    requiredMajors: ['stem'],
  },

  // HEEF Orange County
  "210": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetStates: ['California'],
    targetEthnicities: ['hispanic-latino'],
  },

  // Latinos in Technology
  "211": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['hispanic-latino'],
    requiredMajors: ['stem'],
  },

  // Haz La U
  // Moving Mountains
  "213": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['hispanic-latino'],
  },

  // CCNMA Latino Journalists CA
  "214": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetStates: ['California'],
    targetEthnicities: ['hispanic-latino'],
    requiredMajors: ['arts'],
  },

  // Cardenas Foundation
  "215": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetStates: ['California'],
    targetEthnicities: ['hispanic-latino'],
    requiredActivities: ['community-service'],
  },

  // Northern California Hispanic STEM
  // ============================================
  // AFRICAN AMERICAN/BLACK SCHOLARSHIPS (IDs 217-226)
  // ============================================
  
  // NAACP Scholarships
  "217": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    requiredActivities: ['community-service'],
  },

  // Hubertus Willems NAACP STEM
  "218": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    targetGenders: ['male'],
    requiredMajors: ['stem'],
  },

  // NAACP x Society Awards Arts
  "219": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    requiredMajors: ['arts'],
  },

  // Arnita Young Boswell
  "220": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    requiredActivities: ['community-service'],
  },

  // Anna V. Waters Legacy
  "221": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    requiredMajors: ['education'],
  },

  // REMOVED: #222 UNCF General Scholarships — duplicate of ID 9
  // Elaine M. Diggs
  "225": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    requiresFirstGen: true,
  },

  // Renee Powell Golf
  "226": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american'],
    targetGenders: ['female'],
    requiredActivities: ['athletics'],
  },

  // ============================================
  // COMMUNITY SERVICE SCHOLARSHIPS (IDs 227-234)
  // ============================================
  
  // Anidjar and Levine
  "227": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredActivities: ['community-service'],
  },

  // REMOVED: #228 National Parent Volunteer Award — doesn't exist under National PTA

  // Desert Financial AZ
  "229": {
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['Arizona'],
    requiredActivities: ['leadership', 'community-service'],
  },

  // Modern Woodmen
  "230": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service'],
  },
  // Spirit of Giving
  "232": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredActivities: ['community-service'],
  },

  // Susan Howard TX  // ============================================
  // ARTS AND WRITING SCHOLARSHIPS (IDs 235-238)
  // ============================================
  
  // REMOVED: #235 Scholastic Best-in-Grade Award — duplicate of ID 26

  // REMOVED: #236 American Voices and Visions Award — duplicate of ID 26

  // The Flaunt It Award
  "237": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['arts'],
  },

  // Ocean Awareness Contest
  "238": {
    minAge: 11,
    maxAge: 18,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['arts'],
    requiredActivities: ['environmental'],
  },

  // ============================================
  // MISCELLANEOUS SCHOLARSHIPS (IDs 239-243)
  // ============================================
  // Technology Addiction Awareness
  "240": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
  },

  // REMOVED: #241 NSHSS General Scholarship — duplicate of ID 131

  // REMOVED: #242 Jack Kent Cooke College — duplicate of ID 31

  // REMOVED: #243 National Eagle Scout Scholarship — duplicate of ID 151

  // ============================================
  // MIDDLE SCHOOL SCHOLARSHIPS (IDs 244-251)
  // ============================================
  
  // Jack Kent Cooke Young Scholars
  "244": {
    minGPA: 3.5,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
    maxHouseholdIncome: '$95,000',
  },

  // Gloria Barron Prize for Young Heroes (ages 8-18)
  "245": {
    minAge: 8,
    maxAge: 18,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service', 'leadership'],
  },

  // Doodle for Google


  // Christopher Columbus Awards
  "247": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th'],
    requiredMajors: ['stem'],
    requiredActivities: ['community-service'],
  },

  // REMOVED: #248 DoSomething.org Scholarships — duplicate of ID 119

  // DuPont Challenge Science Essay
  // REMOVED: #250 MATHCOUNTS Competition — competition with prizes, not a scholarship program

  // REMOVED: #251 Prudential Emerging Visionaries — duplicate of ID 123

  // Junior Duck Stamp Contest
  "252": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['arts'],
  },

  // FRA Americanism Essay Contest
  "253": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // Letters About Literature (grades 4-12, we track 6+)
  "254": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // REMOVED: #255 Davidson Fellows — duplicate of ID 173

  // ============================================
  // ADDITIONAL MIDDLE SCHOOL SCHOLARSHIPS (IDs 256-270)
  // ============================================

  // 3M Young Scientist Challenge
  "256": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['stem'],
  },

  // Thermo Fisher Junior Innovators Challenge
  "257": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['stem'],
  },

  // REMOVED: #258 Carson Scholars Fund — duplicate of ID 122

  // eCYBERMISSION STEM Competition
  "259": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman'],
    requiredMajors: ['stem'],
    requiredActivities: ['community-service'],
  },

  // Paradigm Challenge
  "260": {
    minAge: 9,
    maxAge: 13,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },

  // One Earth Young Filmmakers Contest
  "261": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiredMajors: ['arts'],
  },

  // Brighterly Math Equity Scholarship
  "262": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiresFinancialNeed: true,
    requiredMajors: ['stem'],
  },
  // Hum Sub Youth Achievement Award
  "265": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiredActivities: ['community-service'],
  },
  // EngineerGirl Writing & Design Contest
  "267": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiredMajors: ['stem', 'arts'],
  },

  // REMOVED: #268 Do Something Awards — duplicate of ID 119

  // Zaner-Bloser National Handwriting Contest
  "269": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },

  // REMOVED: #270 Stuck at Prom — duplicate of ID 127

  // ============================================
  // GAMING & ESPORTS
  // ============================================

  // High School Esports League (HSEL) Scholarship
  "271": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // REMOVED: #272 ESA Foundation Scholarship

  // Minecraft Scholarship (Apex Hosting)
  "273": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // Play! Pokemon Scholarship
  "274": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // REMOVED: #275 AIAS Foundation Game Scholarship

  // 1,000 Dreams Fund Twitch Scholarship
  "276": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetGenders: ['female', 'non-binary'],
  },

  // REMOVED: 277 (NVM - Texas-only), 278 (Imagine Cup - age 18+, not gaming scholarship), 279 (Gameheads - program not scholarship)

  // IGDA Foundation GDC Scholarship
  "280": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem', 'arts'],
  },

  // ============================================
  // MIDDLE SCHOOL SCHOLARSHIPS (additional batch)
  // ============================================

  // Carson Scholars Fund
  "314": {
    minGPA: 3.75,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['community-service'],
    nominationRequired: true,
  },

  // MATHCOUNTS Competition
  "315": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // Scholastic Art & Writing Awards


  // International Young Eco-Hero Award
  "317": {
    minAge: 8,
    maxAge: 16,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiredActivities: ['community-service'],
  },

  // Davidson Fellows Scholarship


  // National History Day
  "319": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },

  // Samsung Solve for Tomorrow
  "320": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen'],
  },

  // PTA Reflections Program
  "321": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiredActivities: ['arts-music'],
  },

  // Apprentice Ecologist Initiative
  "322": {
    minAge: 13,
    maxAge: 21,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service'],
  },

  // Junior Duck Stamp Conservation Design
  "323": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    requiredActivities: ['arts-music'],
  },

  // Breakthrough Junior Challenge
  "324": {
    minAge: 13,
    maxAge: 18,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // Science Without Borders Challenge
  "325": {
    minAge: 11,
    maxAge: 19,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['arts-music'],
  },

  // Foyle Young Poets of the Year
  "326": {
    minAge: 11,
    maxAge: 17,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior'],
  },

  // Paradigm Challenge


  // Young Reporters for the Environment
  "328": {
    minAge: 11,
    maxAge: 18,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // Stossel in the Classroom Essay Contest
  "329": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // We the Future Contest
  "330": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },

  // Leyla Beban Young Authors Foundation
  // Minds Underground Essay Competition
  "332": {
    minAge: 8,
    maxAge: 18,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // DoSomething Seasonal Scholarships
  "333": {
    minAge: 13,
    maxAge: 25,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    noEssayRequired: true,
  },

  // Curieux Academic Journal Scholarship
  // Earth Science Week Essay Contest
  "335": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman'],
  },

  // The Betty Award for Young Writers
  "336": {
    minAge: 8,
    maxAge: 12,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th'],
  },

  // Rubincam Youth Award
  "337": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },

  // Ranger Rick Photography Contest
  "338": {
    maxAge: 13,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },

  // ============================================
  // NEW SCHOLARSHIPS — Broad Diversification (339-368)
  // ============================================

  // LGBTQ+ Scholarships
  // Point Foundation Scholarship


  // PFLAG National Scholarship
  "340": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFirstGen: true,
  },

  // Gamma Mu Foundation Scholarship
  "341": {
    minGPA: 2.75,
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // International Scholarships
  // Davis-UWC Scholars Program
  "342": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['international'],
  },

  // Fund for Education Abroad Scholarship
  "343": {
    minGPA: 2.5,
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
  },

  // Tortuga Backpacks Study Abroad Scholarship
  "344": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'international'],
  },

  // Business Scholarships
  // National Black MBA Association Scholarship
  "345": {
    minGPA: 3.0,
    targetGradeLevels: ['college-junior', 'college-senior', 'graduate'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetEthnicities: ['african-american'],
    requiredMajors: ['business'],
  },

  // HSF Scholarship
  "346": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
    targetEthnicities: ['hispanic-latino'],
  },

  // NSHSS Business Scholarship


  // Future Business Leaders of America Scholarship
  "348": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    requiredMajors: ['business'],
    requiresMembership: 'FBLA',
    requiredActivities: ['leadership'],
  },

  // Leadership Scholarships
  // Horatio Alger Scholarship


  // Elks Most Valuable Student


  // JFK Profile in Courage Essay Contest


  // Prudential Spirit of Community Awards
  // Native American Scholarships
  // American Indian College Fund Full Circle Scholarship
  "353": {
    minGPA: 2.0,
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },

  // Cobell Scholarship
  "354": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
    requiresFAFSA: true,
  },

  // Catching the Dream Scholarship
  "355": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
  },

  // Military Scholarships
  // Pat Tillman Foundation Scholarship
  "356": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
  },

  // Children of Fallen Patriots Foundation
  "357": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
    requiresFAFSA: true,
  },

  // AMVETS National Scholarship
  "358": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
  },

  // Disabilities Scholarships
  // Google Lime Scholarship


  // NBCUniversal Tony Coelho Media Scholarship
  "360": {
    minGPA: 2.5,
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['communications'],
    requiresDisability: true,
  },

  // Women in STEM Scholarships
  // Society of Women Engineers Scholarship
  "361": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetGenders: ['female'],
    requiredMajors: ['engineering'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // AAUW Selected Professions Fellowship
  "362": {
    targetGradeLevels: ['graduate'],
    targetGenders: ['female'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['engineering', 'computer-science', 'mathematics'],
  },

  // Palantir Women in Technology Scholarship
  "363": {
    minGPA: 3.0,
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetGenders: ['female'],
    requiredMajors: ['computer-science', 'engineering'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'international'],
  },

  // Rolling Deadline Scholarships
  // Scholarships.com Free Scholarship
  "364": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    noEssayRequired: true,
  },

  // Niche No Essay Scholarship
  "365": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    noEssayRequired: true,
  },

  // Bold.org Scholarship
  "366": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // GoingMerry Scholarship
  "367": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    noEssayRequired: true,
  },

  // LA Promise Fund Scholarship
  "368": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
    targetStates: ['CA'],
    residencyRequired: true,
  },

  // ============================================
  // MILITARY
  // ============================================

  // Scholarships for Military Children
  "369": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
    minGPA: 3.0,
  },

  // Daughters of the Cincinnati Scholarship
  "370": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
    targetGenders: ['female'],
    requiresFinancialNeed: true,
  },

  // American Legion Legacy Scholarship
  "371": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
  },

  // Military Order of the Purple Heart Scholarship
  "372": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
    requiresMembership: 'Military Order of the Purple Heart',
  },

  // Army Scholarship Foundation
  "373": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: true,
  },

  // ============================================
  // DISABILITIES
  // ============================================

  // Anne Ford Scholarship


  // Allegra Ford Thomas Scholarship
  "375": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresDisability: true,
    minGPA: 3.0,
  },

  // Wells Fargo Stacey Milbern Scholarship
  "376": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresDisability: true,
  },

  // ACB Educational Scholarships
  "377": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresDisability: true,
  },

  // Lighthouse Guild Scholarships
  "378": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresDisability: true,
    minGPA: 3.0,
  },

  // ============================================
  // LGBTQ+
  // ============================================

  // Point Foundation Flagship Scholarship
  "379": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['leadership', 'community-service'],
  },

  // Pride Foundation Community Scholarships
  "380": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetStates: ['WA', 'OR', 'ID', 'MT', 'AK'],
    residencyRequired: true,
  },

  // Matthew Shepard Memorial Scholarship
  "381": {
    targetGradeLevels: ['high-school-senior', 'college-freshman'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['community-service'],
  },

  // PFLAG Denver Scholarship
  "382": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetStates: ['CO'],
    residencyRequired: true,
  },

  // ============================================
  // NATIVE AMERICAN
  // ============================================

  // Cobell Education Scholarship Fund
  "383": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
  },

  // AISES BNSF Foundation Scholarship
  "384": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
    requiredMajors: ['engineering', 'computer-science', 'mathematics', 'natural-sciences'],
    minGPA: 3.0,
    requiresMembership: 'AISES',
  },

  // Native Forward Scholars Fund
  "385": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
    minGPA: 2.5,
  },

  // American Indian College Fund Scholarships
  "386": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['native-american'],
  },

  // ============================================
  // WOMEN IN STEM
  // ============================================

  // Science Ambassador Scholarship


  // SWE Scholarships for Women in Engineering
  "388": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
    targetGenders: ['female'],
    requiredMajors: ['engineering'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'international'],
    minGPA: 3.0,
  },

  // ASME INSPIRE Scholarship
  "389": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    targetGenders: ['female'],
    requiredMajors: ['engineering'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // ============================================
  // BUSINESS
  // ============================================

  // Blacks at Microsoft (BAM) Scholarship
  "390": {
    targetGradeLevels: ['high-school-senior'],
    targetEthnicities: ['african-american'],
    requiredMajors: ['engineering', 'computer-science', 'mathematics', 'natural-sciences'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    minGPA: 3.3,
  },

  // ============================================
  // LEADERSHIP
  // ============================================

  // Elks Most Valuable Student Scholarship
  "391": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresFinancialNeed: true,
    requiredActivities: ['leadership', 'community-service'],
  },

  // Horatio Alger National Scholarship
  "392": {
    minGPA: 2.0,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresFinancialNeed: true,
  },

  // Coca-Cola Scholars Program
  "393": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['leadership', 'community-service'],
  },

  // Gloria Barron Prize for Young Heroes


  // ============================================
  // STEM
  // ============================================

  // Breakthrough Junior Challenge


  // Edison Scholars Program
  "396": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['engineering', 'computer-science', 'mathematics', 'natural-sciences'],
    minGPA: 3.0,
    targetStates: ['CA'],
    residencyRequired: true,
  },

  // ============================================
  // ARTS
  // ============================================

  // Scholastic Art & Writing Awards


  // ============================================
  // COMMUNITY SERVICE
  // ============================================

  // Prudential Emerging Visionaries


  // Chick-fil-A Community Scholars
  "399": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresEmployment: 'Chick-fil-A',
    requiredActivities: ['leadership', 'community-service'],
  },

  // ============================================
  // NO ESSAY
  // ============================================

  // Scholarships360 No-Essay Scholarship
  "400": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    noEssayRequired: true,
  },

  // Niche No-Essay Scholarship
  // SoFi Monthly No-Essay Scholarship
  "402": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    noEssayRequired: true,
  },

  // ===== BATCH 3: IDs 403–442 =====

  // Nurse Corps Scholarship Program
  "403": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
    requiredMajors: ['nursing'],
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  // Generation Google Scholarship
  "404": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['computer-science', 'engineering', 'technology'],
  },
  // APIA Scholars Scholarship
  "405": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['asian', 'pacific-islander'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFAFSA: true,
  },
  // Point Foundation Flagship Scholarship

  // Foster Care to Success Scholarship
  "407": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiresFosterCare: true,
    maxAge: 25,
  },
  // Café Bustelo El Café del Futuro Scholarship
  "408": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    targetEthnicities: ['hispanic'],
  },
  // Anne Ford Scholarship

  // The Neurodiversity Scholarship
  "410": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiresDisability: true,
    minAge: 16,
    maxAge: 26,
  },
  // Farm Credit Foundation Agricultural Scholarship
  "411": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['agriculture'],
  },
  // Blacks at Microsoft (BAM) Scholarship

  // LULAC National Scholarship Fund

  // Foundation for Rural Service Scholarship
  "414": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    residencyRequired: true,
  },
  // DEWALT Trades Scholarship
  "415": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore'],
  },
  // BigFuture Scholarships
  "416": {
    targetGradeLevels: ['high-school-senior'],
    noEssayRequired: true,
  },
  // Cody Renard Richard Scholarship
  "417": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['african-american', 'asian', 'hispanic', 'native-american'],
    requiredMajors: ['arts', 'theater'],
  },
  // Jeannette Rankin Women's Scholarship
  "418": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetGenders: ['female'],
    minAge: 25,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
  },
  // Allegra Ford Thomas Scholarship

  // Casey Family Scholarships
  "420": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiresFosterCare: true,
    maxAge: 25,
  },
  // HACU Scholarship Program
  "421": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    targetEthnicities: ['hispanic'],
  },
  // Scholarships360 No-Essay Scholarship

  // YoungArts National Arts Competition
  "423": {
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    minAge: 15,
    maxAge: 18,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Native Agriculture & Food Systems Scholarship
  "424": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['native-american'],
    requiredMajors: ['agriculture'],
  },
  // AAGEN Scholarship
  "425": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['asian'],
    minGPA: 3.3,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Sister Thea Bowman Black Catholic Scholarship
  "426": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore'],
    targetEthnicities: ['african-american'],
  },
  // Against the Grain Artistic Scholarship
  "427": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    targetEthnicities: ['asian', 'pacific-islander'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['arts'],
  },
  // Discover Student Loans Scholarship
  "428": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
  },
  // ScholarSHPE Scholarship
  "429": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['hispanic'],
    minGPA: 2.5,
    requiredMajors: ['engineering', 'computer-science', 'technology'],
    requiresMembership: true,
  },
  // ESUME Entrepreneurship Scholarship
  "430": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
  },
  // NAACP Earl Warren Scholarship
  "431": {
    targetGradeLevels: ['graduate'],
    requiredMajors: ['law'],
    requiresFinancialNeed: true,
  },
  // Beacon Scholarship for Rural America
  "432": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    minGPA: 3.0,
    requiresFinancialNeed: true,
    residencyRequired: true,
  },
  // Princess Grace Foundation Awards

  // AAUW International Fellowships
  "434": {
    targetGradeLevels: ['graduate'],
    targetGenders: ['female'],
  },
  // ScholarshipOwl No-Essay Scholarship
  "435": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    minAge: 16,
    noEssayRequired: true,
  },
  // Amazon Future Engineer Scholarship

  // Pride Foundation Community Scholarships

  // DoD SMART Scholarship-for-Service
  "438": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.0,
    requiredMajors: ['engineering', 'computer-science', 'technology'],
    requiresMilitaryConnection: true,
  },
  // Herbert Lehman Education Fund Scholarship
  "439": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    maxHouseholdIncome: 70000,
    requiresFAFSA: true,
    requiresFinancialNeed: true,
  },
  // FAITH Scholarship for Academic Excellence
  "440": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Paul & Daisy Soros Fellowships for New Americans
  "441": {
    targetGradeLevels: ['graduate'],
    maxAge: 31,
  },
  // Hertz Foundation Fellowship
  "442": {
    targetGradeLevels: ['graduate'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['engineering', 'computer-science', 'technology'],
  },

  // ============================================
  // MASSACHUSETTS-SPECIFIC SCHOLARSHIPS (443-462)
  // ============================================

  // John and Abigail Adams Scholarship
  "443": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    residencyRequired: ['MA'],
  },
  // MASSGrant
  "444": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
    requiresFAFSA: true,
    residencyRequired: ['MA'],
  },
  // Paul Tsongas Scholarship
  "445": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    minGPA: 3.75,
    requiresFAFSA: true,
    residencyRequired: ['MA'],
  },
  // Massachusetts High Demand Scholarship
  "446": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    minGPA: 3.0,
    requiresFAFSA: true,
    requiredMajors: ['engineering', 'computer-science', 'technology', 'nursing', 'healthcare', 'education', 'social-work', 'criminal-justice', 'business'],
    residencyRequired: ['MA'],
  },
  // City of Boston Scholarship Fund
  "447": {
    residencyRequired: ['MA'],
  },
  // Henry David Thoreau Scholarship
  "448": {
    targetGradeLevels: ['high-school-senior'],
    residencyRequired: ['MA'],
    requiredMajors: ['environmental-science'],
  },
  // Tomorrow's Teachers Scholarship
  "449": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFAFSA: true,
    requiredMajors: ['education'],
    residencyRequired: ['MA'],
  },
  // MassReconnect
  "450": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFAFSA: true,
    minAge: 25,
    residencyRequired: ['MA'],
  },
  // Community Foundation of Western MA Scholarships
  "451": {
    requiresFinancialNeed: true,
    residencyRequired: ['MA'],
  },
  // UMass Community College Advantage Scholarship
  "452": {
    residencyRequired: ['MA'],
  },
  // Massachusetts Public Service Grant
  "453": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFAFSA: true,
    residencyRequired: ['MA'],
  },
  // Early Childhood Educators Scholarship
  "454": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFAFSA: true,
    requiredMajors: ['education'],
    residencyRequired: ['MA'],
  },
  // Behavioral Health Workforce Scholarship
  "455": {
    targetGradeLevels: ['graduate'],
    requiredMajors: ['psychology', 'social-work', 'healthcare'],
    residencyRequired: ['MA'],
  },
  // Steel Root Cybersecurity Scholarship
  "456": {
    targetGradeLevels: ['high-school-junior'],
    minGPA: 2.5,
    requiresFinancialNeed: true,
    requiredMajors: ['computer-science', 'technology'],
    residencyRequired: ['MA'],
  },
  // Journalism Education Foundation of New England
  "457": {
    minGPA: 3.0,
    residencyRequired: ['MA', 'CT', 'ME', 'NH', 'RI', 'VT'],
  },
  // GFWC Massachusetts Memorial Education Scholarship
  "458": {
    targetGradeLevels: ['graduate'],
    targetGenders: ['female'],
    requiredMajors: ['healthcare', 'business'],
    residencyRequired: ['MA'],
  },
  // GFWC Success for Survivors Scholarship
  "459": {
    residencyRequired: ['MA'],
  },
  // Unitil STEM Scholarship
  "460": {
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['engineering', 'computer-science', 'technology', 'mathematics'],
    residencyRequired: ['MA', 'NH', 'ME'],
  },
  // Massachusetts Nurses Association Scholarship
  "461": {
    requiredMajors: ['nursing'],
    residencyRequired: ['MA'],
  },
  // Meet Boston Foundation Scholarship
  "462": {
    requiresFinancialNeed: true,
    residencyRequired: ['MA'],
  },

  // ============================================
  // BATCH 1: ADDITIONAL NATIONAL & STEM (483-512)
  // ============================================

  // Amazon Future Engineer Scholarship

  // Regeneron Science Talent Search

  // Foot Locker Scholar Athletes

  // Thurgood Marshall College Fund
  "486": {
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetEthnicities: ['african-american'],
    requiredActivities: ['community-service'],
  },
  // Point Foundation

  // UNCF Scholarships
  "488": {
    minGPA: 2.5,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetEthnicities: ['african-american'],
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  // RMHC Scholarship Program (replaced discontinued Siemens Competition)
  "489": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
    requiredActivities: ['community-service'],
  },
  // Hispanic Heritage Foundation Youth Awards
  "490": {
    targetGradeLevels: ['high-school-senior'],
    targetEthnicities: ['hispanic-latino'],
    requiredActivities: ['community-service'],
  },
  // DAR Scholarship
  "491": {
    citizenshipRequired: ['us-citizen'],
    requiresFinancialNeed: true,
  },
  // APIA Scholarship
  "492": {
    minGPA: 2.7,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetEthnicities: ['asian', 'pacific-islander'],
    requiresFinancialNeed: true,
  },
  // Davidson Fellows

  // LULAC National Scholarship

  // Tylenol Future Care

  // Voice of Democracy
  "496": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // NAACP Scholarships

  // National Merit

  // Jack Kent Cooke
  "499": {
    minGPA: 3.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
    maxHouseholdIncome: 95000,
  },
  // AISES Scholarship
  "500": {
    targetEthnicities: ['native-american', 'pacific-islander'],
    requiredMajors: ['engineering', 'computer-science', 'biology', 'chemistry', 'physics', 'mathematics', 'technology'],
    requiresMembership: 'AISES',
  },
  // Dream.US
  "501": {
    minGPA: 2.5,
    citizenshipRequired: ['daca', 'undocumented'],
    requiresFinancialNeed: true,
  },
  // Scholarship America Dream Award
  "502": {
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
    requiresFinancialNeed: true,
  },
  // SWE Scholarship  // NSBE Scholarships

  // Hertz Fellowship

  // Posse Foundation
  "506": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
    requiredActivities: ['leadership'],
    nominationRequired: true,
  },
  // SHPE Scholarships
  "507": {
    targetEthnicities: ['hispanic-latino'],
    requiredMajors: ['engineering', 'computer-science', 'technology', 'mathematics', 'physics', 'chemistry', 'biology'],
  },
  // Sallie Mae No Essay
  "508": {
    noEssayRequired: true,
  },
  // Goldwater Scholarship
  "509": {
    minGPA: 3.5,
    targetGradeLevels: ['college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredMajors: ['biology', 'chemistry', 'physics', 'mathematics', 'engineering', 'computer-science'],
    nominationRequired: true,
  },
  // Cobell Scholarship

  // Boren Scholarship
  "511": {
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen'],
  },
  // Courage to Grow
  "512": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
  },

  // ============================================
  // BATCH 2: COMMUNITY SERVICE, ARTS, BUSINESS & MORE (513-542)
  // ============================================

  // Prudential Spirit of Community Awards

  // YoungArts National Competition
  "514": {
    minAge: 15,
    maxAge: 18,
  },
  // NFIB Young Entrepreneur Award
  "515": {
    targetGradeLevels: ['high-school-senior'],
    requiredActivities: ['leadership'],
  },
  // Jackie Robinson Foundation
  "516": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    targetEthnicities: ['african-american', 'hispanic-latino', 'native-american', 'asian', 'pacific-islander'],
    requiresFinancialNeed: true,
    requiresFAFSA: true,
    requiredActivities: ['leadership', 'community-service'],
  },
  // National Scholastic Art & Writing Awards
  "517": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // DECA Scholarship Program
  "518": {
    requiredMajors: ['business'],
    requiresMembership: 'DECA',
  },
  // Cameron Impact Scholarship

  // ESA Foundation Scholarship  // Stamps Scholarship
  "521": {
    minGPA: 3.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['leadership'],
    nominationRequired: true,
  },
  // Elks Legacy Award
  "522": {
    targetGradeLevels: ['high-school-senior'],
    requiresMembership: 'Elks (parent/grandparent)',
  },
  // QuestBridge National Match
  "523": {
    minGPA: 3.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca', 'undocumented'],
    requiresFinancialNeed: true,
    maxHouseholdIncome: 65000,
  },
  // AFSA National High School Essay Contest (replaced discontinued USIP Peace Essay)
  "524": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // AFSA High School Scholarship Contest
  "525": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Toyota/TELACU Scholarship
  "526": {
    requiresFirstGen: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
    residencyRequired: ['CA'],
    targetEthnicities: ['hispanic-latino'],
  },
  // Horatio Alger CTE Scholarship
  "527": {
    requiresFinancialNeed: true,
    citizenshipRequired: ['us-citizen'],
  },
  // Mensa Foundation Scholarship
  "528": {
    noEssayRequired: false,
  },
  // Unigo $10K Scholarship
  "529": {
    noEssayRequired: true,
  },
  // HSF Scholar Program
  "530": {
    minGPA: 3.0,
    targetEthnicities: ['hispanic-latino'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
    requiresFAFSA: true,
  },
  // Udall Scholarship
  "531": {
    targetGradeLevels: ['college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    nominationRequired: true,
  },
  // Gen and Kelly Tanabe Scholarship
  "532": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
  },
  // AICPA Minority Accounting Scholarship
  "533": {
    minGPA: 3.0,
    requiredMajors: ['business'],
    targetEthnicities: ['african-american', 'hispanic-latino', 'native-american', 'asian'],
    requiresFAFSA: true,
  },
  // Foster Care to Success

  // FEEA Scholarship
  "535": {
    minGPA: 3.0,
    requiresEmployment: 'federal-civilian-employee (parent)',
    requiredActivities: ['community-service'],
  },
  // NIAF Scholarship
  "536": {
    minGPA: 3.0,
  },
  // ThinkSwiss Research Scholarship
  "537": {
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
  },
  // Patriot's Pen Essay Contest
  "538": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // GE-Reagan Foundation Scholarship
  "539": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    requiredActivities: ['leadership', 'community-service'],
  },
  // NAAS Native Achievement Scholarship
  "540": {
    targetEthnicities: ['native-american', 'pacific-islander'],
  },
  // ACLU Youth Activist Scholarship
  "541": {
    targetGradeLevels: ['high-school-senior'],
    requiredActivities: ['community-service', 'leadership'],
  },
  // HSF/Marathon Petroleum Scholarship
  "542": {
    minGPA: 3.0,
    targetEthnicities: ['hispanic-latino'],
    requiredMajors: ['engineering', 'chemistry', 'biology'],
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
  },

  // ============================================
  // BATCH 3 — IDs 543-572 (30 entries)
  // Added 2026-02-21, ALL URLs web-search verified
  // ============================================

  // Taco Bell Live Más Scholarship

  // Jeannette Rankin Women's Scholarship

  // Astronaut Scholarship
  "545": {
    targetGradeLevels: ['college-sophomore', 'college-junior'],
    requiredMajors: ['engineering', 'computer-science', 'biology', 'chemistry', 'physics', 'mathematics'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    nominationRequired: true,
  },
  // Chick-fil-A Remarkable Futures Scholarship
  "546": {
    requiresEmployment: true,
  },
  // Equitable Excellence Scholarship

  // NSHSS Foundation STEM Scholarship
  "548": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiresMembership: true,
    requiredMajors: ['engineering', 'computer-science', 'biology', 'chemistry', 'physics', 'mathematics', 'technology'],
  },
  // Coca-Cola Scholars Program

  // Elks National Foundation Most Valuable Student
  "550": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
  },
  // Horatio Alger National Scholarship

  // Jackie Robinson Foundation Scholarship

  // Dell Scholars Program

  // Burger King Scholars Program
  "554": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Ron Brown Scholar Program

  // UNCF/Merck Science Initiative
  "556": {
    minGPA: 3.3,
    targetEthnicities: ['african-american'],
    requiredMajors: ['biology', 'chemistry', 'physics', 'engineering', 'computer-science'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Kaiser Permanente Health Equity Scholarship
  "557": {
    requiredMajors: ['biology', 'nursing', 'public-health'],
    requiresFinancialNeed: true,
  },
  // Point Foundation Access Scholarship
  "558": {
    requiresFirstGen: true,
    requiresFinancialNeed: true,
  },
  // NSBE Technical Excellence Scholarship
  "559": {
    minGPA: 3.0,
    targetEthnicities: ['african-american'],
    requiredMajors: ['engineering', 'technology', 'computer-science'],
    requiresMembership: true,
  },
  // Google Lime Scholarship

  // Haz La U Scholarship

  // HOSA Future Health Professionals Scholarship
  "562": {
    requiredMajors: ['biology', 'nursing', 'public-health'],
    requiresMembership: true,
  },
  // National Merit Scholarship

  // HSF Scholar Program

  // AICPA Minority Accounting Scholarship

  // FEEA Scholarship

  // NIAF Scholarship

  // ThinkSwiss Research Scholarship

  // College JumpStart Scholarship

  // YoungArts National Competition

  // DECA Scholarship Program

  // Scholarship America Dream Award


  // ============================================
  // BATCH 4 — IDs 573-602 (30 entries)
  // Added 2026-02-21, ALL URLs web-search verified
  // ============================================

  // Daniels Scholarship Program
  "573": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['CO', 'NM', 'UT', 'WY'],
    residencyRequired: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    maxHouseholdIncome: 100000,
  },
  // AES Engineering Scholarship
  "574": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
  },
  // Cameron Impact Scholarship

  // Regeneron Science Talent Search

  // Gates Scholarship

  // QuestBridge National College Match

  // Posse Foundation Scholarship

  // Schwarzman Scholars
  "580": {
    minAge: 18,
    maxAge: 28,
    targetGradeLevels: ['college-senior', 'graduate'],
  },
  // Boren Scholarship

  // Cobell Undergraduate Scholarship
  "582": {
    targetEthnicities: ['native-american'],
    citizenshipRequired: ['us-citizen'],
  },
  // Mensa Foundation Scholarship

  // Davidson Fellows Scholarship

  // GE-Reagan Foundation Scholarship

  // Jack Kent Cooke College Scholarship
  "586": {
    targetGradeLevels: ['high-school-senior'],
    requiresFinancialNeed: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // TMCF/McDonald's Scholarship
  "587": {
    minGPA: 2.7,
    targetEthnicities: ['african-american'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: true,
  },
  // APIA Scholars Scholarship

  // Voice of Democracy Scholarship

  // DAR America 250! Scholarship
  "590": {
    minGPA: 3.5,
    citizenshipRequired: ['us-citizen'],
  },
  // LULAC National Scholastic Achievement Award
  "591": {
    minGPA: 3.5,
    citizenshipRequired: ['us-citizen', 'permanent-resident', 'daca'],
  },
  // Stamps Scholarship

  // NAACP Inspire Scholarship
  "593": {
    minGPA: 3.0,
    requiresMembership: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Herbert Lehman Education Fund

  // SWE Emerging First Year Scholarship
  "595": {
    targetGradeLevels: ['high-school-senior'],
    targetGenders: ['female'],
    requiredMajors: ['engineering', 'computer-science'],
  },
  // AISES Scholarship

  // Dream.US National Scholarship

  // Unigo $10K Scholarship

  // Hertz Foundation Fellowship

  // Gen and Kelly Tanabe Scholarship

  // Udall Undergraduate Scholarship
  "601": {
    targetGradeLevels: ['college-sophomore', 'college-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    nominationRequired: true,
  },
  // Elks Legacy Award


  // Batch 5 - IDs 603-632 (verified 2026-02-21)
  "603": { // Gilman International Scholarship
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
    requiresFinancialNeed: true,
    requiresPellGrant: true,
    citizenshipRequired: ['us-citizen'],
  },
  "604": { // Truman Scholarship
    targetGradeLevels: ['college-junior'],
    citizenshipRequired: ['us-citizen'],
    nominationRequired: true,
  },
  "605": { // Marshall Scholarship
    targetGradeLevels: ['college-senior'],
    minGPA: 3.7,
    citizenshipRequired: ['us-citizen'],
  },
  "606": { // Fulbright U.S. Student Program
    targetGradeLevels: ['college-senior'],
    citizenshipRequired: ['us-citizen'],
  },
  "607": { // Rhodes Scholarship
    targetGradeLevels: ['college-senior'],
    maxAge: 24,
    citizenshipRequired: ['us-citizen'],
  },
  "608": { // Luce Scholars Program
    targetGradeLevels: ['college-senior'],
    maxAge: 29,
    citizenshipRequired: ['us-citizen'],
    nominationRequired: true,
  },
  "609": { // CLS Program
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen'],
  },
  "610": { // NSLI-Y
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen'],
  },
  "611": { // Morehead-Cain
    targetGradeLevels: ['high-school-senior'],
    nominationRequired: true,
  },
  "612": { // Jefferson Scholarship
    targetGradeLevels: ['high-school-senior'],
    nominationRequired: true,
  },
  "613": { // Robertson Scholars
    targetGradeLevels: ['high-school-senior'],
  },
  "614": { // NACME
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['engineering'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american'],
  },

  "616": { // Coca-Cola Leaders of Promise
    targetGradeLevels: ['college-freshman', 'college-sophomore'],
    minGPA: 3.5,
    requiresMembership: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },  "618": { // Thiel Fellowship
    maxAge: 22,
  },
  "619": { // Emory Woodruff Scholars
    targetGradeLevels: ['high-school-senior'],
  },
  "620": { // Flinn Scholarship
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['AZ'],
    residencyRequired: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "621": { // Cooke Transfer Scholarship
    targetGradeLevels: ['college-sophomore'],
    minGPA: 3.5,
    requiresFinancialNeed: true,
    maxHouseholdIncome: 95000,
  },
  "622": { // Coca-Cola Academic Team
    targetGradeLevels: ['college-sophomore'],
    nominationRequired: true,
  },
  "623": { // Freeman-ASIA
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior'],
    minGPA: 2.8,
    requiresFinancialNeed: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "624": { // Davis-Putter Scholarship
    requiresFinancialNeed: true,
    requiredActivities: ['social-justice', 'community-service'],
  },
  "625": { // Phi Kappa Phi Study Abroad
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
    minGPA: 3.75,
  },
  "626": { // CHCI Scholarship
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    targetEthnicities: ['hispanic'],
    requiresFinancialNeed: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "627": { // AMS Scholarship
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['atmospheric-sciences', 'environmental-science'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "628": { // Fashion Scholarship Fund
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['fashion', 'design', 'merchandising'],
  },
  "629": { // CBYX Germany
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    minAge: 15,
    maxAge: 18,
    citizenshipRequired: ['us-citizen'],
  },

  "631": { // Obama-Chesky Voyager
    targetGradeLevels: ['college-sophomore'],
    requiresFinancialNeed: true,
    requiredActivities: ['community-service', 'public-service'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "632": { // National Space Club Keynote
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen'],
  },

  // Batch 6 - IDs 633-662 (verified 2026-02-21)
  "633": { // Knight-Hennessy Scholars
    targetGradeLevels: ['college-senior'],
  },
  "634": { // Churchill Scholarship
    targetGradeLevels: ['college-senior'],
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen'],
    nominationRequired: true,
  },
  "635": { // Beinecke Scholarship
    targetGradeLevels: ['college-junior'],
    requiresFinancialNeed: true,
    nominationRequired: true,
  },
  "636": { // Milken Scholars
    targetGradeLevels: ['high-school-senior'],
    minGPA: 3.6,
    requiresFinancialNeed: true,
    targetStates: ['CA', 'NY', 'DC'],
    nominationRequired: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "637": { // Comcast Leaders and Achievers
    targetGradeLevels: ['high-school-senior'],
    minGPA: 2.8,
    nominationRequired: true,
  },
  "638": { // Air Force ROTC
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore'],
    citizenshipRequired: ['us-citizen'],
    requiresMilitaryConnection: false,
  },
  "639": { // Navy ROTC
    targetGradeLevels: ['high-school-senior'],
    maxAge: 23,
    citizenshipRequired: ['us-citizen'],
  },
  "640": { // NHSC Scholarship
    targetGradeLevels: ['college-senior'],
    requiredMajors: ['medicine', 'nursing', 'pharmacy'],
    citizenshipRequired: ['us-citizen'],
  },
  "641": { // Fisher House Military Children
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    maxAge: 23,
    requiresMilitaryConnection: true,
    minGPA: 3.0,
  },
  "642": { // Yenching Academy
  },
  "643": { // Rotary Peace Fellowship
  },
  "644": { // NSF GRFP
    targetGradeLevels: ['college-senior'],
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "645": { // Soroptimist Live Your Dream
    targetGenders: ['female'],
    requiresFinancialNeed: true,
  },
  "646": { // Zonta Amelia Earhart
    targetGenders: ['female'],
    requiredMajors: ['engineering', 'stem'],
  },
  "647": { // AICPA Foundation Future CPAs
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['business'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "648": { // Lockheed Martin STEM
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior'],
    requiredMajors: ['engineering', 'stem'],
    minGPA: 2.5,
    requiresFinancialNeed: true,
    citizenshipRequired: ['us-citizen'],
  },
  "649": { // Starbucks College Achievement Plan
    requiresEmployment: true,
  },
  "650": { // GEM Fellowship
    targetGradeLevels: ['college-senior'],
    requiredMajors: ['engineering', 'stem'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "651": { // L'Oreal For Women in Science
    targetGenders: ['female'],
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "652": { // NFB Scholarship
    requiresDisability: true,
    minAge: 18,
  },
  "653": { // Boettcher Foundation
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['CO'],
    residencyRequired: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "654": { // Mandela Washington Fellowship
    minAge: 25,
    maxAge: 35,
  },
  "655": { // NESA Eagle Scout
    requiresMembership: true,
  },
  "656": { // DAAD Scholarship
  },
  "657": { // Chevening Scholarship
  },
  "658": { // PEO International Peace Scholarship
    targetGenders: ['female'],
  },
  "659": { // Elie Wiesel Prize in Ethics
    targetGradeLevels: ['college-junior', 'college-senior'],
  },
  "660": { // APS Minority Scholarship
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior'],
    requiredMajors: ['stem'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "661": { // KPMG Future Leaders
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['business'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american'],
    minGPA: 3.0,
  },
  "662": { // Deloitte Foundation
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    requiredMajors: ['business'],
  },
  // ============================================
  // BATCH 7 — IDs 663-692
  // ============================================
  "663": { // American Indian College Fund
    targetEthnicities: ['native-american'],
    minGPA: 2.0,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },


  "666": { // NAHJ Rubén Salazar Scholarship
    targetEthnicities: ['hispanic'],
    requiredMajors: ['communications'],
    minGPA: 2.8,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "667": { // NABJ Scholarship Program
    targetEthnicities: ['african-american'],
    requiredMajors: ['communications'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "668": { // USDA 1890 National Scholars
    targetGradeLevels: ['high-school-senior', 'college-sophomore', 'college-junior'],
    requiredMajors: ['stem'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen'],
  },

  "670": { // National FFA Scholarships
    requiresMembership: true,
    requiredMajors: ['stem'],
  },

  "672": { // TEACH Grant
    requiredMajors: ['education'],
    minGPA: 3.25,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFAFSA: true,
  },
  "673": { // Teach For America
    targetGradeLevels: ['college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "674": { // ABA Legal Opportunity Scholarship
    requiredMajors: ['other'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },


  "677": { // Casey Family Scholars
    requiresFosterCare: true,
    maxAge: 25,
  },


  "680": { // Mike Rowe Work Ethic Scholarship
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    videoRequired: true,
  },
  "681": { // UMHEF Scholarships
    requiresMembership: true,
  },
  "682": { // Presbyterian Church USA Study Grant
    requiresMembership: true,
  },
  "683": { // Hillel International Scholarships
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  "685": { // FNSNA/Johnson & Johnson Nursing
    requiredMajors: ['healthcare'],
  },
  "686": { // Association on American Indian Affairs
    targetEthnicities: ['native-american'],
    requiresFinancialNeed: true,
  },
  "687": { // SPJ New America Award
    requiredMajors: ['communications'],
  },

  "689": { // RSM US Foundation First Gen
    requiresFirstGen: true,
    requiredMajors: ['business'],
  },

  "691": { // Knights of Columbus
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  // ============================================
  // BATCH 8 — IDs 693-722
  // ============================================
  "693": { // Garden Club of America
    requiredMajors: ['stem'],
  },
  "694": { // National Garden Clubs
    targetGradeLevels: ['college-junior', 'college-senior'],
    requiredMajors: ['stem'],
  },
  "695": { // CAAP Arab American
    targetEthnicities: ['other'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "696": { // Shaheen Mass Communications
    targetEthnicities: ['other'],
    targetGradeLevels: ['college-junior', 'college-senior'],
    requiredMajors: ['communications'],
  },

  "698": { // Folds of Honor
    requiresMilitaryConnection: true,
  },
  "699": { // Fisher House Military Children
    requiresMilitaryConnection: true,
    minGPA: 3.0,
  },

  "701": { // Lime Connect BMO
    requiresDisability: true,
    requiredMajors: ['business'],
  },


  "704": { // Pride Foundation
    targetStates: ['AK', 'ID', 'MT', 'OR', 'WA'],
    residencyRequired: true,
  },
  "705": { // Segal AmeriCorps
    minAge: 17,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },

  "707": { // NFTE Babson
    requiresMembership: true,
    requiredMajors: ['business'],
  },
  "708": { // Strauss Scholarship
    targetStates: ['CA'],
    targetGradeLevels: ['college-sophomore', 'college-junior'],
  },






  "715": { // DAR STEM
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen'],
  },
  "716": { // APIAHF
    targetEthnicities: ['asian-american'],
    requiredMajors: ['healthcare'],
  },
  "717": { // NOAA Hollings
    targetGradeLevels: ['college-sophomore'],
    requiredMajors: ['stem'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen'],
  },

  "719": { // KASF
    targetEthnicities: ['asian-american'],
    minGPA: 3.0,
  },
  "720": { // JACL
    targetEthnicities: ['asian-american'],
  },

  "722": { // Sallie Mae Bridging the Dream
    requiresFinancialNeed: true,
  },
  // ============================================
  // BATCH 9 — IDs 723-752
  // ============================================
  "723": { // NASW Gosnell Scholarship
    requiredMajors: ['other'],
    requiresMembership: true,
  },
  "724": { // CSWE Minority Fellowship
    requiredMajors: ['other'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
  },
  "725": { // Banatao Filipino American
    targetEthnicities: ['asian-american'],
    targetStates: ['CA'],
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['stem'],
  },
  "726": { // Filipino American Scholarship Fund
    targetEthnicities: ['asian-american'],
  },
  "727": { // AAUW Selected Professions
    targetGenders: ['female'],
    requiredMajors: ['stem', 'business', 'other'],
  },
  "728": { // APA Minority Fellowship
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
    requiredMajors: ['other'],
  },  "730": { // YoungArts
    minAge: 15,
    maxAge: 18,
  },
  "731": { // Sphinx Music
    targetEthnicities: ['african-american', 'hispanic'],
  },
  "732": { // AIA Diversity Architecture
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['other'],
  },

  "734": { // NSBE
    targetEthnicities: ['african-american'],
    requiredMajors: ['stem'],
    requiresMembership: true,
  },

  "736": { // CyberCorps SFS
    requiredMajors: ['stem'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen'],
  },
  "737": { // Inlaks Scholarship
  },
  "738": { // Texas Exes
    targetStates: ['TX'],
  },
  "739": { // Florida Bright Futures
    targetStates: ['FL'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "740": { // Georgia HOPE
    targetStates: ['GA'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "741": { // Cal Grant
    targetStates: ['CA'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "742": { // NY TAP
    targetStates: ['NY'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "743": { // Excelsior NY
    targetStates: ['NY'],
    residencyRequired: true,
    maxHouseholdIncome: 125000,
  },

  "745": { // ORISE
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen'],
  },
  "746": { // FANHS
    targetEthnicities: ['asian-american'],
    targetGradeLevels: ['college-junior', 'college-senior'],
  },
  "747": { // SAJA
    targetEthnicities: ['asian-american'],
    requiredMajors: ['communications'],
  },



  "751": { // NIAF Italian American
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "752": { // DAAD Germany
  },
  // ============================================
  // BATCH 10 — IDs 753-782
  // ============================================
  "753": { // APhA-ASP/COSTCO Pharmacy
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "754": { // CVS/AACP Pharmacy
    requiredMajors: ['healthcare'],
    minGPA: 3.0,
  },
  "755": { // Hispanic Dental Association
    targetEthnicities: ['hispanic'],
    requiredMajors: ['healthcare'],
  },
  "756": { // ADEA/Colgate Dental
    requiredMajors: ['healthcare'],
  },
  "757": { // AHLF Hospitality
    requiredMajors: ['business'],
    minGPA: 2.5,
  },
  "758": { // ASCM Supply Chain
    requiredMajors: ['business'],
    requiresMembership: true,
  },

  "760": { // Golden Door Scholars
    targetGradeLevels: ['high-school-senior'],
  },
  "761": { // Becas Univision
    targetEthnicities: ['hispanic'],
  },

  "763": { // Nicholl Fellowships
    minAge: 18,
  },


  "766": { // Astronaut Scholarship Foundation
    targetGradeLevels: ['college-sophomore', 'college-junior'],
    requiredMajors: ['stem'],
    nominationRequired: true,
    citizenshipRequired: ['us-citizen'],
  },
  "767": { // Regeneron ISEF
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredMajors: ['stem'],
  },

  "769": { // JKC Young Artists
    maxAge: 17,
  },

  "771": { // TMCF
    targetEthnicities: ['african-american'],
    minGPA: 3.0,
  },
  "772": { // Illinois MAP Grant
    targetStates: ['IL'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "773": { // WA College Bound
    targetStates: ['WA'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    maxHouseholdIncome: 67000,
  },
  "774": { // Kentucky KEES
    targetStates: ['KY'],
    residencyRequired: true,
    minGPA: 2.5,
  },
  "775": { // A+ Adopted/Foster Scholars
    requiresFosterCare: true,
  },

  "777": { // Starbucks/ASU
    requiresEmployment: true,
  },

  "779": { // Walmart Associate
    requiresEmployment: true,
  },
  "780": { // Panda Express Cares
    requiresEmployment: true,
  },
  "781": { // Michigan Competitive
    targetStates: ['MI'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "782": { // Minnesota State Grant
    targetStates: ['MN'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  // ============================================
  // BATCH 11 — IDs 783-812
  // ============================================
  "783": { // APTA Minority Scholarship
    requiredMajors: ['healthcare'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
    requiresMembership: true,
  },
  "784": { // Foundation for PT Research PODS
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "785": { // AOPA Flight Training
    requiresMembership: true,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "786": { // Women in Aviation
    targetGenders: ['female'],
    requiresMembership: true,
  },

  "788": { // APA Planning Diversity
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "789": { // AIGA Worldstudio DxD
    minGPA: 3.0,
    requiresFinancialNeed: true,
  },
  "790": { // CFDA Design Scholar
    requiredMajors: ['other'],
  },

  "792": { // ALA Library Science
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "793": { // ALA Spectrum
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "794": { // NOAA Nancy Foster
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "795": { // Marine Technology Society
    requiredMajors: ['stem'],
    requiresMembership: true,
  },
  "796": { // GSA Graduate Research
    requiredMajors: ['stem'],
    requiresMembership: true,
  },
  "797": { // SEG Geophysics
    requiredMajors: ['stem'],
  },
  "798": { // AGC Construction Management
    requiredMajors: ['stem'],
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
  },

  "800": { // JKC Undergraduate Transfer
    requiresFinancialNeed: true,
    minGPA: 3.5,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "801": { // AIERF Real Estate
    requiredMajors: ['business'],
  },
  "802": { // NCAA Postgraduate
    minGPA: 3.2,
    requiredActivities: ['athletics'],
  },
  "803": { // GSA Lowell Field Camp
    requiredMajors: ['stem'],
    requiresFinancialNeed: true,
  },
  "804": { // Occupational Therapy Foundation
    requiredMajors: ['healthcare'],
  },
  "805": { // Judith McManus Price Planning
    targetGenders: ['female'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
    citizenshipRequired: ['us-citizen'],
  },
  "806": { // AGC Workforce Development
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "807": { // Virgil Abloh Post-Modern
    targetEthnicities: ['african-american'],
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
  },
  "808": { // REFORMA Library
  },
  "809": { // Captains Preferred Marine Science
    requiredMajors: ['stem'],
    minGPA: 3.0,
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "810": { // AIGA DC Design Continuum
    targetStates: ['DC'],
  },
  "811": { // EAA Flight Training
    requiresMembership: true,
  },
  "812": { // Pi Alpha Alpha
  },
  // ============================================
  // BATCH 12 — IDs 813-842
  // ============================================
  "813": { // NATA Foundation
    requiredMajors: ['healthcare'],
    minGPA: 3.2,
    requiresMembership: true,
  },
  "814": { // SOPHE Health Education
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "815": { // ASHA Minority
    requiredMajors: ['healthcare'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
  },
  "816": { // LSA Linguistics
    requiresMembership: true,
  },
  "817": { // SAF Forestry
    requiredMajors: ['stem'],
    requiresMembership: true,
  },

  "819": { // Academy of Nutrition
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "820": { // AICPA Accounting
    requiredMajors: ['business'],
    minGPA: 3.0,
  },
  "821": { // Spencer Insurance/RMI
    requiredMajors: ['business'],
    minGPA: 3.0,
  },
  "822": { // CSCMP Supply Chain
    requiredMajors: ['business'],
    requiresMembership: true,
  },
  "823": { // ADHA Dental Hygiene
    requiredMajors: ['healthcare'],
    minGPA: 3.0,
  },
  "824": { // AVMA Veterinary
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "825": { // NFFF Fire Service
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  "826": { // IACP Law Enforcement
    requiredMajors: ['other'],
  },
  "827": { // Phi Theta Kappa Transfer
    minGPA: 3.5,
    requiresMembership: true,
  },
  "828": { // AAPC Medical Coding
    requiresMembership: true,
    requiresFinancialNeed: true,
  },
  "829": { // AISES A.T. Anderson
    targetEthnicities: ['native-american'],
    requiredMajors: ['stem'],
    requiresMembership: true,
  },
  "830": { // NRPA Parks & Rec
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
  },
  "831": { // ASCE Civil Engineering
    requiredMajors: ['stem'],
    requiresMembership: true,
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
  },
  "832": { // APSA Political Science
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
  },
  "833": { // USDA/1994 Tribal Scholars
    targetEthnicities: ['native-american'],
    requiredMajors: ['stem'],
    citizenshipRequired: ['us-citizen'],
  },
  "834": { // NABJ Media
    targetEthnicities: ['african-american'],
    requiredMajors: ['communications'],
    requiresMembership: true,
  },
  "835": { // APTA Public Transit
    minGPA: 3.0,
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
  },  "837": { // NJ STARS
    targetStates: ['NJ'],
    residencyRequired: true,
  },
  "838": { // PA State Grant
    targetStates: ['PA'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "839": { // NC Education Lottery
    targetStates: ['NC'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "840": { // NALA Paralegal
    requiresMembership: true,
  },
  "841": { // OT Diversity
    requiredMajors: ['healthcare'],
    targetEthnicities: ['african-american', 'hispanic', 'native-american', 'asian-american'],
  },
  "842": { // IN 21st Century Scholars
    targetStates: ['IN'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  // ============================================
  // BATCH 13 — IDs 843-872
  // ============================================
  "843": { // Actuarial Foundation STEM Stars
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['stem'],
    minGPA: 3.0,
  },
  "844": { // CAS Trust
    requiredMajors: ['stem'],
    requiresMembership: true,
  },
  "845": { // ARCF Respiratory Therapy
    requiredMajors: ['healthcare'],
    minGPA: 3.0,
  },
  "846": { // ASRT Radiation Therapy
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "847": { // PRSSA Public Relations
    requiredMajors: ['communications'],
    requiresMembership: true,
  },
  "848": { // INFORMS Data Science
    requiredMajors: ['stem'],
  },
  "849": { // ISC2 Cybersecurity
    requiredMajors: ['stem'],
  },
  "850": { // AASHE Sustainability
    requiredMajors: ['stem'],
  },
  "851": { // AG Bell Deaf/HoH
    requiresDisability: true,
  },
  "852": { // MENA Arts & Culture
  },
  "853": { // Sikh Coalition
  },
  "854": { // NHPI Pacific Islander
    targetEthnicities: ['asian-american'],
    requiresFinancialNeed: true,
  },
  "855": { // Hmong American
  },
  "856": { // Luso-American
    requiresFinancialNeed: true,
  },
  "857": { // VA Tuition Assistance Grant
    targetStates: ['VA'],
    residencyRequired: true,
  },
  "858": { // MA MASSGrant
    targetStates: ['MA'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "859": { // MD Rawlings
    targetStates: ['MD'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "860": { // NAADAC Addiction Counseling
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "861": { // ASPA Public Administration
    requiresMembership: true,
  },
  "862": { // NFDA Mortuary Science
    requiredMajors: ['other'],
  },
  "863": { // FCLB Chiropractic
    requiredMajors: ['healthcare'],
  },
  "864": { // AOA Optometry
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "865": { // APMA Podiatry
    requiredMajors: ['healthcare'],
    requiresMembership: true,
  },
  "866": { // CO Student Grant
    targetStates: ['CO'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "867": { // CT Willis Scholarship
    targetStates: ['CT'],
    residencyRequired: true,
  },
  "868": { // SC LIFE
    targetStates: ['SC'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "869": { // TN HOPE
    targetStates: ['TN'],
    residencyRequired: true,
  },
  "870": { // MO A+ Schools
    targetStates: ['MO'],
    residencyRequired: true,
    minGPA: 2.5,
  },
  "871": { // WI Grant
    targetStates: ['WI'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "872": { // OR Oregon Promise
    targetStates: ['OR'],
    residencyRequired: true,
    minGPA: 2.5,
  },
  // ===== BATCH 14 (IDs 873-902) =====
  "873": { // Society of Illustrators
    requiredMajors: ['Illustration', 'Fine Arts', 'Visual Arts'],
  },
  "874": { // PGSF Print & Graphics
    requiredMajors: ['Graphic Communications', 'Printing Technology', 'Graphic Design'],
  },
  "875": { // NSSLHA Communication Disorders
    requiredMajors: ['Speech-Language Pathology', 'Audiology', 'Communication Sciences'],
    requiresMembership: true,
  },
  "876": { // NAAE Agriculture Education
    requiredMajors: ['Agricultural Education', 'Agriculture'],
    requiresMembership: true,
  },
  "877": { // ELI Environmental Law
    requiredMajors: ['Environmental Law', 'Environmental Policy', 'Law'],
    targetGradeLevels: ['graduate'],
  },
  "878": { // GSA Gerontology
    requiredMajors: ['Gerontology', 'Aging Studies', 'Social Work', 'Nursing'],
    targetGradeLevels: ['graduate'],
  },
  "879": { // SHRM Human Resources
    requiredMajors: ['Human Resources', 'Business Administration', 'Organizational Development'],
    requiresMembership: true,
  },
  "880": { // SOT Toxicology
    requiredMajors: ['Toxicology', 'Pharmacology', 'Environmental Health'],
    targetGradeLevels: ['graduate'],
  },
  "881": { // AAPA Physician Assistant
    requiredMajors: ['Physician Assistant Studies', 'Pre-PA'],
    requiresMembership: true,
  },
  "882": { // AANA Nurse Anesthesia
    requiredMajors: ['Nurse Anesthesia', 'Nursing'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "883": { // ACNM Midwifery
    requiredMajors: ['Nurse-Midwifery', 'Midwifery', 'Nursing'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "884": { // CBC Spouses Visual Arts
    requiredMajors: ['Fine Arts', 'Visual Arts', 'Art History'],
    targetEthnicities: ['Black or African American'],
  },
  "885": { // Gilman Study Abroad
    requiresFinancialNeed: true,
    requiresFAFSA: true,
    requiresPellGrant: true,
    citizenshipRequired: ['us-citizen'],
  },
  "886": { // Boren International
    citizenshipRequired: ['us-citizen'],
  },
  "887": { // FEA Study Abroad
    requiresFinancialNeed: true,
    minGPA: 2.5,
  },
  "888": { // Fulbright
    citizenshipRequired: ['us-citizen'],
    targetGradeLevels: ['college-senior', 'graduate'],
    minGPA: 3.0,
  },
  "889": { // HACU Hispanic HSI
    targetEthnicities: ['Hispanic or Latino'],
    minGPA: 3.0,
  },
  "890": { // AL Student Assistance
    targetStates: ['AL'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "891": { // IA Iowa Tuition Grant
    targetStates: ['IA'],
    residencyRequired: true,
    requiresFAFSA: true,
  },
  "892": { // NV Silver State Opportunity
    targetStates: ['NV'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "893": { // AZ Arizona Promise
    targetStates: ['AZ'],
    residencyRequired: true,
    requiresFAFSA: true,
  },
  "894": { // HI B Plus
    targetStates: ['HI'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "895": { // AK Performance
    targetStates: ['AK'],
    residencyRequired: true,
    minGPA: 2.5,
  },
  "896": { // ACHE Healthcare Admin
    requiredMajors: ['Healthcare Administration', 'Health Management', 'Public Health'],
    targetGradeLevels: ['graduate'],
  },
  "897": { // AAUW Career Development
    targetGenders: ['Female'],
    targetGradeLevels: ['graduate'],
  },
  "898": { // AISES Intel
    targetEthnicities: ['American Indian or Alaska Native'],
    requiredMajors: ['Computer Science', 'Engineering', 'STEM'],
    requiresMembership: true,
  },
  "899": { // AHIMA Health Informatics
    requiredMajors: ['Health Informatics', 'Health Information Management'],
    requiresMembership: true,
  },
  "900": { // AACN Nursing Leadership
    requiredMajors: ['Nursing'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "901": { // NH Granite State Grant
    targetStates: ['NH'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "902": { // MS HELP
    targetStates: ['MS'],
    residencyRequired: true,
    requiresFAFSA: true,
    minGPA: 2.5,
  },
  // ===== BATCH 15 (IDs 903-932) =====
  "903": { // Lambda Alpha Anthropology
    requiredMajors: ['Anthropology'],
    requiresMembership: true,
    nominationRequired: true,
  },
  "904": { // AAA Minority Fellowship
    requiredMajors: ['Anthropology'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "905": { // ASA Minority Fellowship
    requiredMajors: ['Sociology'],
    targetGradeLevels: ['graduate'],
  },
  "906": { // AMS Epsilon Fund
    requiredMajors: ['Mathematics', 'Applied Mathematics'],
  },
  "907": { // AWM Schafer Prize
    requiredMajors: ['Mathematics'],
    targetGenders: ['Female'],
    nominationRequired: true,
  },
  "908": { // APS Minority Physics
    requiredMajors: ['Physics'],
    targetEthnicities: ['Black or African American', 'Hispanic or Latino', 'American Indian or Alaska Native'],
    citizenshipRequired: ['us-citizen'],
  },
  "909": { // ACS Scholars
    requiredMajors: ['Chemistry', 'Biochemistry', 'Chemical Engineering'],
    targetEthnicities: ['Black or African American', 'Hispanic or Latino', 'American Indian or Alaska Native'],
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.0,
  },
  "910": { // AAS Chambliss Astronomy
    requiredMajors: ['Astronomy', 'Astrophysics', 'Physics'],
  },
  "911": { // AEA Summer Program
    requiredMajors: ['Economics'],
  },
  "912": { // BMES Diversity
    requiredMajors: ['Biomedical Engineering', 'Bioengineering'],
    requiresMembership: true,
  },
  "913": { // ANS Nuclear Engineering
    requiredMajors: ['Nuclear Engineering', 'Nuclear Science'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "914": { // ASM Materials Science
    requiredMajors: ['Materials Science', 'Materials Engineering', 'Metallurgy'],
    requiresMembership: true,
  },
  "915": { // YoungArts Theatre
    maxAge: 18,
    citizenshipRequired: ['us-citizen'],
  },
  "916": { // Andrew Lloyd Webber Theatre
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['Theatre', 'Drama', 'Performing Arts'],
  },
  "917": { // Princess Grace Dance
    requiredMajors: ['Dance', 'Performing Arts'],
    nominationRequired: true,
  },
  "918": { // Scholastic Writing Awards
    maxAge: 18,
  },  "920": { // NASSM Sports Management
    requiredMajors: ['Sport Management', 'Sports Administration'],
    requiresMembership: true,
  },
  "921": { // NSCA Exercise Science
    requiredMajors: ['Exercise Science', 'Kinesiology', 'Strength and Conditioning'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "922": { // DoD SMART
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.0,
  },
  "923": { // DE SEED
    targetStates: ['DE'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "924": { // NE Opportunity Grant
    targetStates: ['NE'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "925": { // SD Opportunity
    targetStates: ['SD'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "926": { // WV PROMISE
    targetStates: ['WV'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "927": { // ND Academic
    targetStates: ['ND'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "928": { // MT Governor's
    targetStates: ['MT'],
    residencyRequired: true,
  },
  "929": { // ID Opportunity
    targetStates: ['ID'],
    residencyRequired: true,
    requiresFAFSA: true,
    minGPA: 2.7,
  },
  "930": { // WY Hathaway
    targetStates: ['WY'],
    residencyRequired: true,
  },
  "931": { // RI Promise
    targetStates: ['RI'],
    residencyRequired: true,
    requiresFAFSA: true,
  },
  "932": { // ME State Grant
    targetStates: ['ME'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  // ===== BATCH 16 (IDs 933-962) =====
  "933": { // IDSA Industrial Design
    requiredMajors: ['Industrial Design', 'Product Design'],
    requiresMembership: true,
  },
  "934": { // IIDA Interior Design
    requiredMajors: ['Interior Design'],
  },
  "935": { // LAF Olmsted Landscape Architecture
    requiredMajors: ['Landscape Architecture'],
    targetGradeLevels: ['graduate'],
    nominationRequired: true,
  },
  "936": { // RTDNA Carole Simpson
    requiredMajors: ['Journalism', 'Communications', 'Broadcast Journalism'],
  },
  "937": { // BEA Broadcasting
    requiredMajors: ['Broadcasting', 'Media Production', 'Communications'],
  },
  "938": { // IAEM Quarantelli
    requiredMajors: ['Emergency Management', 'Homeland Security', 'Disaster Science'],
    requiresMembership: true,
  },
  "939": { // APA Planning Fellowship
    requiredMajors: ['Urban Planning', 'Regional Planning', 'City Planning'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "940": { // AHLA Hyatt Hospitality
    requiredMajors: ['Hospitality Management', 'Hotel Management', 'Tourism'],
    minGPA: 3.0,
  },
  "941": { // ASSP Safety
    requiredMajors: ['Occupational Safety', 'Environmental Health', 'Safety Engineering'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "942": { // AAM Museum Studies
    requiredMajors: ['Museum Studies', 'Art History', 'Curation'],
    targetGradeLevels: ['graduate'],
  },
  "943": { // AAR Religious Studies
    requiredMajors: ['Religious Studies', 'Theology', 'Divinity'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "944": { // SAA Archaeology
    requiredMajors: ['Archaeology', 'Anthropology'],
    requiresMembership: true,
  },
  "945": { // APA Philosophy
    requiredMajors: ['Philosophy'],
    targetGradeLevels: ['graduate'],
  },
  "946": { // IFT Food Science
    requiredMajors: ['Food Science', 'Food Technology', 'Nutrition Science'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "947": { // NGPA Aviation LGBTQ+
    requiredMajors: ['Aviation', 'Aerospace Engineering', 'Flight Training'],
    requiresMembership: true,
  },
  "948": { // Gallaudet Deaf/HoH
    requiresDisability: true,
  },
  "949": { // NFB Blind
    requiresDisability: true,
    citizenshipRequired: ['us-citizen'],
  },
  "950": { // AFAR Geriatrics
    requiredMajors: ['Medicine', 'Geriatric Medicine'],
    targetGradeLevels: ['graduate'],
  },
  "951": { // AWS Welding
    requiredMajors: ['Welding Engineering', 'Welding Technology'],
    requiresMembership: true,
    minGPA: 2.5,
  },
  "952": { // PHCC Plumbing/HVAC
    requiredMajors: ['Plumbing', 'HVAC', 'Mechanical Contracting'],
    minGPA: 2.0,
  },
  "953": { // IEC Electrical
    requiredMajors: ['Electrical Technology', 'Electrical Engineering'],
    requiresMembership: true,
  },
  "954": { // URISA GIS
    requiredMajors: ['GIS', 'Geography', 'Geospatial Science', 'Urban Planning'],
    requiresMembership: true,
  },
  "955": { // PR Pell Supplement
    targetStates: ['PR'],
    residencyRequired: true,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
  },
  "956": { // VI Board of Education
    targetStates: ['VI'],
    residencyRequired: true,
    requiresFAFSA: true,
  },
  "957": { // Guam Merit
    targetStates: ['GU'],
    residencyRequired: true,
    minGPA: 3.0,
  },
  "958": { // Osher Reentry
    minAge: 25,
  },
  "959": { // Patsy Mink Foundation
    targetGenders: ['Female'],
    requiresFinancialNeed: true,
  },  "961": { // HSLDA Homeschool
    requiresMembership: true,
  },
  "962": { // RAISE Student Parents
    minGPA: 2.5,
  },
  // ===== BATCH 17 (IDs 963-992) =====
  "963": { // ASA Gertrude Cox
    requiredMajors: ['Statistics', 'Biostatistics'],
    targetGenders: ['Female'],
    targetGradeLevels: ['graduate'],
  },
  "964": { // DOE CSGF
    requiredMajors: ['Computational Science', 'Data Science', 'Computer Science'],
    targetGradeLevels: ['graduate'],
    citizenshipRequired: ['us-citizen'],
  },
  "965": { // NVIDIA Graduate Fellowship
    requiredMajors: ['Computer Science', 'AI', 'Machine Learning'],
    targetGradeLevels: ['graduate'],
    nominationRequired: true,
  },
  "966": { // NSGC Genetic Counseling
    requiredMajors: ['Genetic Counseling'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "967": { // SER Epidemiology
    requiredMajors: ['Epidemiology', 'Public Health'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "968": { // NRCA Rehabilitation Counseling
    requiredMajors: ['Rehabilitation Counseling'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "969": { // SEIA Solar
    requiredMajors: ['Energy Engineering', 'Environmental Science', 'Renewable Energy'],
  },
  "970": { // WHOI Oceanography
    requiredMajors: ['Oceanography', 'Marine Science', 'Marine Biology', 'Environmental Science'],
    targetGradeLevels: ['college-junior', 'college-senior'],
  },
  "971": { // CyberCorps SFS
    requiredMajors: ['Cybersecurity', 'Computer Science', 'Information Security'],
    citizenshipRequired: ['us-citizen'],
  },
  "972": { // ARNOVA Nonprofit
    requiredMajors: ['Nonprofit Management', 'Public Administration', 'Philanthropy'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "973": { // ATA Translation
    requiredMajors: ['Translation', 'Interpretation', 'Languages'],
    requiresMembership: true,
  },
  "974": { // TechForce Automotive
    requiredMajors: ['Automotive Technology', 'Diesel Technology', 'Collision Repair'],
    minGPA: 2.0,
  },
  "975": { // IRE Investigative Journalism
    requiredMajors: ['Journalism', 'Communications'],
    requiresMembership: true,
  },
  "976": { // NAVTA Vet Tech
    requiredMajors: ['Veterinary Technology'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "977": { // NASPAA Public Admin
    requiredMajors: ['Public Administration', 'Public Policy', 'Public Affairs'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },

  "979": { // PBA Cosmetology
    requiredMajors: ['Cosmetology', 'Esthetics', 'Barbering'],
    requiresFinancialNeed: true,
  },
  "980": { // ASHP Pharmacy
    requiredMajors: ['Pharmacy'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "981": { // From the Top Music
    maxAge: 18,
    requiresFinancialNeed: true,
  },
  "982": { // SDMS Sonography
    requiredMajors: ['Diagnostic Medical Sonography', 'Vascular Technology'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "983": { // Caribbean American Heritage
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.0,
  },
  "984": { // RAD-AID Radiology
    requiredMajors: ['Radiology', 'Medical Imaging', 'Medicine'],
  },
  "985": { // AIHEC Tribal College
    targetEthnicities: ['American Indian or Alaska Native'],
    nominationRequired: true,
  },
  "986": { // NRHA Rural Health
    requiresMembership: true,
  },

  "988": { // SAMFund Cancer Survivors
    minAge: 17,
    maxAge: 39,
  },
  "989": { // NSF GRFP
    citizenshipRequired: ['us-citizen'],
    targetGradeLevels: ['graduate'],
  },



  // ===== BATCH 18 (IDs 993-1022) =====
  "993": { // EPA GRO Fellowship
    requiredMajors: ['Environmental Science', 'Environmental Engineering'],
    citizenshipRequired: ['us-citizen'],
  },
  "994": { // NOAA Hollings
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.0,
    targetGradeLevels: ['college-sophomore'],
  },
  "995": { // Garden Club Conservation
    requiredMajors: ['Conservation', 'Ecology', 'Horticulture', 'Environmental Studies'],
    citizenshipRequired: ['us-citizen'],
  },
  "996": { // Annie's Sustainable Ag
    requiredMajors: ['Agriculture', 'Food Science', 'Sustainability'],
  },

  "998": { // FIRST Robotics
    requiredActivities: ['FIRST Robotics'],
  },
  "999": { // PRINTING United
    requiredMajors: ['Graphic Communications', 'Print Technology'],
    minGPA: 3.0,
  },
  "1000": { // NSDA Speech & Debate
    requiresMembership: true,
  },
  "1001": { // Eagle Scout
    requiresMembership: true,
  },
  "1002": { // Twins Magazine
  },
  "1003": { // Beckley Left-Handed
  },

  "1005": { // Ripple UBRI Blockchain
    requiredMajors: ['Computer Science', 'Finance', 'Engineering'],
  },
  "1006": { // Tall Clubs International
    maxAge: 21,
  },
  "1007": { // VRG Vegetarian
    targetGradeLevels: ['high-school-senior'],
  },
  "1008": { // Duck Brand Stuck at Prom
    minAge: 14,
  },

  "1010": { // ADAA Dental Assisting
    requiredMajors: ['Dental Assisting'],
    requiresMembership: true,
  },
  "1011": { // AST Surgical Technology
    requiredMajors: ['Surgical Technology'],
    requiresMembership: true,
  },
  "1012": { // TCA Trucking
    requiresMembership: true,
  },
  "1013": { // ESA Entomology
    requiredMajors: ['Entomology', 'Biology'],
    requiresMembership: true,
  },
  "1014": { // AAA Audiology
    requiredMajors: ['Audiology'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
    minGPA: 3.0,
  },


  "1017": { // ABFSE Funeral Science
    requiredMajors: ['Funeral Service', 'Mortuary Science'],
  },
  "1018": { // NCIHC Healthcare Interpreting
    requiresMembership: true,
  },
  "1019": { // TRIO Transplant Recipients
  },
  "1020": { // Diabetes Scholars
  },
  "1021": { // UCB Epilepsy
  },
  "1022": { // AAFA Asthma/Allergy
  },


  // ===== BATCH 21 (IDs 281-313 and 463-482) - MISSING ENTRIES ADDED =====

  "281": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    targetEthnicities: ['african_american'],
    targetGradeLevels: ['high-school-senior']
  },
  "282": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['african_american'],
    targetGradeLevels: ['high-school-senior']
  },

  "284": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['african_american'],
    targetGradeLevels: ['high-school-senior']
  },
  "285": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['african_american'],
    targetGradeLevels: ['high-school-senior']
  },
  "286": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['hispanic'],
    targetGradeLevels: ['high-school-senior']
  },
  "287": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['hispanic'],
    targetGradeLevels: ['high-school-senior']
  },
  "288": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['hispanic'],
    targetGradeLevels: ['high-school-senior']
  },
  "289": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['hispanic'],
    targetGradeLevels: ['high-school-senior']
  },

  "291": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiresFAFSA: true,
    requiresFinancialNeed: true,
    requiresFirstGen: true,
    targetGradeLevels: ['high-school-senior']
  },
  "294": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    targetGradeLevels: ['high-school-senior']
  },

  "296": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    requiredMajors: ['arts', 'music', 'film'],
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['AZ', 'CA', 'FL', 'GA', 'LA', 'NC', 'TX']
  },

  "298": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['arts', 'music', 'film'],
    targetGradeLevels: ['high-school-senior']
  },
  "301": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['arts', 'music', 'film'],
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['CO']
  },

  // Eco-Hero Awards (ages 8-16)
  "303": {
    minAge: 8,
    maxAge: 16,
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore'],
    requiredActivities: ['community-service'],
  },
  // Bill of Rights Institute My Impact Challenge (ages 14-19)
  "304": {
    citizenshipRequired: ['us-citizen'],
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },



  "308": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['nursing', 'medicine'],
    requiresMilitaryConnection: true,
    targetGradeLevels: ['high-school-senior']
  },
  "309": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['engineering', 'computer_science', 'mathematics', 'physics'],
    targetGradeLevels: ['high-school-senior']
  },
  "310": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['engineering', 'computer_science', 'mathematics', 'physics'],
    targetGenders: ['female', 'non_binary'],
    targetGradeLevels: ['high-school-senior']
  },


  "313": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior']
  },
  "463": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    targetGradeLevels: ['high-school-senior']
  },
  "464": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetEthnicities: ['hispanic'],
    targetGradeLevels: ['high-school-senior']
  },
  "465": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    targetGenders: ['female', 'male', 'non_binary'],
    targetGradeLevels: ['high-school-senior']
  },
  "466": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetGenders: ['female', 'non_binary'],
    targetGradeLevels: ['high-school-senior']
  },
  "467": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    requiresFAFSA: true,
    requiresFinancialNeed: true,
    targetEthnicities: ['asian_american', 'pacific_islander'],
    targetGradeLevels: ['high-school-senior']
  },
  "468": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior']
  },
  "469": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['arts', 'music', 'film'],
    targetGradeLevels: ['high-school-senior']
  },
  "470": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
    targetStates: ['AL', 'AZ', 'AR', 'CO', 'GA', 'IN', 'KS', 'KY', 'LA', 'MS', 'MO', 'NM', 'OK', 'TN', 'TX', 'VA', 'WY']
  },
  "471": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    requiresFAFSA: true,
    requiresFinancialNeed: true,
    targetGradeLevels: ['high-school-senior']
  },
  "472": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    requiredMajors: ['agriculture'],
    requiresFAFSA: true,
    requiresFinancialNeed: true,
    targetGradeLevels: ['high-school-senior']
  },
  "473": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiresDisability: true,
    targetGradeLevels: ['high-school-senior']
  },
  "474": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior']
  },

  "476": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['engineering', 'computer_science', 'mathematics', 'physics'],
    targetGradeLevels: ['high-school-senior']
  },
  "477": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['arts', 'music', 'film'],
    targetGradeLevels: ['high-school-senior']
  },
  "478": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredMajors: ['arts', 'music', 'film'],
    targetGradeLevels: ['high-school-senior']
  },
  "479": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiresFAFSA: true,
    requiresFinancialNeed: true,
    targetGradeLevels: ['high-school-senior']
  },
  "480": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiredActivities: ['leadership', 'community_service'],
    requiresFirstGen: true,
    targetGradeLevels: ['high-school-senior']
  },
  "481": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    requiresMilitaryConnection: true,
    targetGradeLevels: ['high-school-senior']
  },
  "482": {
    citizenshipRequired: ['us-citizen'],
    minGPA: 2.5,
    targetGradeLevels: ['high-school-junior', 'high-school-senior']
  },

  // ===== BATCH 19 (IDs 1023-1052) =====
  "1023": { // NPPA Photojournalism
    requiredMajors: ['Photojournalism', 'Photography', 'Journalism'],
    targetGradeLevels: ['college-sophomore', 'college-junior', 'college-senior'],
  },
  "1024": { // ASIFA Animation
    requiredMajors: ['Animation', 'Film', 'Digital Media'],
  },
  "1025": { // Student Academy Award
    requiredMajors: ['Film', 'Animation', 'Documentary Film'],
  },
  "1026": { // Society of Illustrators
    requiredMajors: ['Illustration', 'Fine Arts', 'Graphic Design'],
  },
  "1027": { // UXPA UX Design
    requiredMajors: ['UX Design', 'Human-Computer Interaction', 'Information Design'],
  },
  "1028": { // STC Technical Writing
    requiredMajors: ['Technical Communication', 'English', 'Information Design'],
    requiresMembership: true,
  },
  "1029": { // CogSci Travel Award
    requiredMajors: ['Cognitive Science', 'Psychology', 'Neuroscience', 'Linguistics'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "1030": { // SfN Neuroscience Scholars
    requiredMajors: ['Neuroscience', 'Biology', 'Psychology'],
    targetGradeLevels: ['college-junior', 'college-senior', 'graduate'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american', 'pacific_islander'],
  },
  "1031": { // BIO Biotech Diversity
    requiredMajors: ['Biotechnology', 'Biology', 'Biochemistry', 'Biomedical Engineering'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american'],
  },
  "1032": { // AIAA Aerospace
    requiredMajors: ['Aerospace Engineering', 'Mechanical Engineering', 'Astronautical Engineering'],
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.3,
    requiresMembership: true,
  },
  "1033": { // MARAD Maritime
    requiredMajors: ['Maritime Studies', 'Marine Transportation', 'Marine Engineering'],
    citizenshipRequired: ['us-citizen'],
  },
  "1034": { // AATCC Textile Science
    requiredMajors: ['Textile Science', 'Textile Engineering', 'Fashion Technology'],
    requiresMembership: true,
  },

  "1036": { // Goldwater Scholarship
    targetGradeLevels: ['college-sophomore', 'college-junior'],
    requiredMajors: ['STEM'],
    citizenshipRequired: ['us-citizen'],
    minGPA: 3.5,
    nominationRequired: true,
  },


  "1039": { // Point Foundation LGBTQ+
    targetGradeLevels: ['college-freshman', 'college-sophomore', 'college-junior', 'college-senior', 'graduate'],
    requiresFinancialNeed: true,
  },
  "1040": { // MESA Middle Eastern Studies
    requiredMajors: ['Middle Eastern Studies', 'Arabic Studies', 'Islamic Studies'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "1041": { // LASA Latin American Studies
    requiredMajors: ['Latin American Studies', 'Hispanic Studies', 'International Relations'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "1042": { // AAS Asian Studies
    requiredMajors: ['East Asian Studies', 'Asian Studies', 'Asian Languages'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "1043": { // AHA History Equity
    requiredMajors: ['History'],
    targetGradeLevels: ['graduate'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american'],
  },
  "1044": { // PTCB Pharmacy Tech
    requiredMajors: ['Pharmacy Technology', 'Pharmaceutical Sciences'],
  },
  "1045": { // ATA TMC Diesel Tech
    requiredMajors: ['Diesel Technology', 'Automotive Technology', 'Heavy Equipment'],
  },
  "1046": { // Marine Corps Scholarship
    requiresMilitaryConnection: true,
    requiresFinancialNeed: true,
    minGPA: 2.0,
  },
  "1047": { // Children of Fallen Patriots
    requiresMilitaryConnection: true,
    requiresFinancialNeed: true,
  },

  "1049": { // NAIA Athletes
    requiredActivities: ['Athletics'],
  },
  "1050": { // Jewish Federation
    requiresMembership: true,
  },
  "1051": { // Shinnyo-en Foundation
  },
  "1052": { // ACLU Civil Liberties
    targetGradeLevels: ['college-junior', 'college-senior'],
  },

  // ===== BATCH 20 (IDs 1053-1092) =====
  "1053": { // AGC Construction Management
    requiredMajors: ['Construction Management', 'Construction Engineering', 'Civil Engineering'],
    minGPA: 2.5,
  },
  "1054": { // CMAA Foundation
    requiredMajors: ['Construction Management', 'Civil Engineering'],
  },
  "1055": { // Actuarial Foundation STEM Stars
    targetGradeLevels: ['high-school-senior'],
    requiredMajors: ['Actuarial Science', 'Mathematics', 'Statistics'],
  },

  "1057": { // NATA Foundation
    requiredMajors: ['Athletic Training', 'Sports Medicine'],
    requiresMembership: true,
    minGPA: 3.2,
  },
  "1058": { // CREW Network Foundation
    targetGenders: ['female'],
    requiredMajors: ['Real Estate', 'Business', 'Finance'],
  },
  "1059": { // NAIOP Inclusion in CRE
    requiredMajors: ['Real Estate', 'Business', 'Finance', 'Urban Planning'],
    minGPA: 3.0,
    targetEthnicities: ['african_american', 'hispanic', 'native_american', 'pacific_islander'],
  },
  "1060": { // Fashion Scholarship Fund
    requiredMajors: ['Fashion Design', 'Fashion Merchandising', 'Fashion Marketing', 'Fashion Business'],
  },

  "1062": { // SAF Future Forest Scholars
    requiredMajors: ['Forestry', 'Natural Resources', 'Environmental Science'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american'],
  },
  "1063": { // ITC Scholarship
    requiredMajors: ['Forestry', 'Fire Management', 'Natural Resources'],
    targetEthnicities: ['native_american'],
  },
  "1064": { // NAEMT Life Saver
    requiredMajors: ['Emergency Medical Services', 'Paramedicine'],
    requiresMembership: true,
  },
  "1065": { // FFCA Firefighter/EMT
    requiredMajors: ['Fire Science', 'Emergency Medical Services'],
    citizenshipRequired: ['us-citizen'],
  },

  "1067": { // AFAR Clarence Pearson Internship
    requiredMajors: ['Gerontology', 'Public Health'],
    targetGradeLevels: ['graduate'],
  },
  "1068": { // WTS Foundation Sharon D. Banks
    targetGenders: ['female'],
    requiredMajors: ['Transportation Engineering', 'Civil Engineering', 'Urban Planning', 'Logistics'],
  },
  "1069": { // ISM R. Gene Richter
    requiredMajors: ['Supply Chain Management', 'Procurement', 'Logistics', 'Operations Management'],
  },
  "1070": { // ASHA SPARC
    requiredMajors: ['Speech-Language Pathology', 'Audiology', 'Communication Sciences'],
    targetGradeLevels: ['graduate'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american', 'asian_american'],
  },
  "1071": { // ASCE Tapman
    requiredMajors: ['Civil Engineering'],
    requiresMembership: true,
    minGPA: 2.5,
  },
  "1072": { // ASME Scholarship
    requiredMajors: ['Mechanical Engineering'],
    requiresMembership: true,
  },
  "1073": { // IEEE PES Scholarship Plus
    requiredMajors: ['Electrical Engineering', 'Power Engineering'],
    minGPA: 3.0,
  },



  "1077": { // AIGA Worldstudio
    requiredMajors: ['Graphic Design', 'Illustration', 'Photography', 'Industrial Design'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american', 'asian_american'],
    requiresFinancialNeed: true,
  },
  "1078": { // SPJ Mark of Excellence
    requiredMajors: ['Journalism', 'Mass Communication', 'Digital Media'],
  },
  "1079": { // NACME Bridge
    requiredMajors: ['Engineering'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american'],
    minGPA: 2.8,
  },

  "1081": { // SASE Scholarship
    requiredMajors: ['STEM'],
    targetEthnicities: ['asian_american', 'pacific_islander'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "1082": { // NLBM Scholarship
    minGPA: 2.5,
  },
  "1083": { // ACF Culinary
    requiredMajors: ['Culinary Arts', 'Pastry Arts', 'Baking'],
    requiresMembership: true,
    minGPA: 2.5,
  },
  "1084": { // AWWA Abel Wolman Fellowship
    requiredMajors: ['Water Science', 'Environmental Engineering', 'Civil Engineering'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "1085": { // NACADA Student Advising
    requiredMajors: ['Higher Education', 'Counseling', 'Student Affairs'],
    targetGradeLevels: ['graduate'],
    requiresMembership: true,
  },
  "1086": { // ASLA Landscape Architecture
    requiredMajors: ['Landscape Architecture'],
  },
  "1087": { // Simpson Strong-Tie
    requiredMajors: ['Architecture', 'Structural Engineering', 'Construction Management'],
  },

  "1089": { // ADHA Institute
    requiredMajors: ['Dental Hygiene'],
    requiresMembership: true,
    minGPA: 3.0,
  },
  "1090": { // AFPE Pre-Doctoral Fellowship
    requiredMajors: ['Pharmaceutical Sciences'],
    targetGradeLevels: ['graduate'],
    citizenshipRequired: ['us-citizen'],
  },
  "1091": { // ACHE Albert W. Dent
    requiredMajors: ['Healthcare Administration', 'Health Services Management'],
    targetGradeLevels: ['graduate'],
    targetEthnicities: ['african_american', 'hispanic', 'native_american', 'asian_american'],
    requiresMembership: true,
  },
  "1092": { // Cooke Undergraduate Transfer
    requiresFinancialNeed: true,
  },

  // ============================================
  // NEW: MIDDLE & HIGH SCHOOL DIVERSIFICATION
  // ============================================

  // Princeton Prize in Race Relations
  "1093": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['community-service', 'leadership'],
  },
  // Maryknoll Essay Contest (Division I: 6-8, Division II: 9-12)
  "1094": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresMembership: 'Catholic school or religious education program',
    noEssayRequired: false,
  },
  // Real World Design Challenge (RWDC)  // Thermo Fisher Scientific Junior Innovators Challenge (formerly Broadcom MASTERS) — grades 6-8  // National Geographic Slingshot Challenge — ages 13-18, environmental
  "1097": {
    minAge: 13,
    maxAge: 18,
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service', 'environmental'],
  },
  // Poetry Out Loud — grades 9-12, national poetry recitation contest
  "1098": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // National History Day — grades 6-12, history research competition  // A) COLLEGE-SPECIFIC SCHOLARSHIPS (1100-1119)
  // Princeton University Financial Aid  // Harvard College Financial Aid Program  // MIT Scholarship for Admitted Students  // Stanford University Scholarship Initiative  // Yale University Need-Based Grant Program  // Columbia University Financial Aid  // Duke University Scholarship  // University of Pennsylvania Financial Aid  // Rice University Scholarship Program  // Vanderbilt University Financial Aid  // Emory University Need-Based Aid  // Georgetown University Financial Aid  // University of Southern California Scholarship  // UCLA Scholarship for Admitted Students  // University of Virginia Scholarships  // University of North Carolina Scholarships  // Georgia Institute of Technology Scholarships  // University of Texas at Austin Scholarships  // University of Michigan Scholarships  // Spelman College Scholarships  // B) STATE-SPECIFIC SCHOLARSHIPS (1120-1139)
  // California Cal Grant Program  // New York State TAP  // Texas TEXAS Grant  // Florida Bright Futures Scholarship Program  // Georgia HOPE Scholarship  // North Carolina Need-Based Grant  // Pennsylvania State Grant Program  // Illinois MAP Grant  // Massachusetts MASSGrant  // Virginia Student Financial Aid Program  // New Jersey TAG  // Ohio College Opportunity Grant  // Michigan Tuition Grant  // Connecticut Aid for Public College Students  // Maryland Howard P. Rawlings Grant  // Indiana Frank O'Bannon Grant  // Alabama PACT Grant  // Louisiana TOPS Scholarship  // Tennessee Education Lottery Scholarship  // South Carolina Palmetto Fellows Scholarship  // C) CATEGORY-EXPANDING SCHOLARSHIPS (1140-1159)
  // Catholic Daughters of the Americas Scholarship  // Jewish Federation Scholarship Program  // Muslim American Educational Trust Scholarship  // Presbyterian Church Scholarship Fund  // Hindu-Sikh Community Scholarship  // Walmart Opportunity Scholarship  // McDonald's HACER Scholarship  // Starbucks College Achievement Plan Scholarship  // Amazon Future Engineer Scholarship  // Chick-fil-A Scholar Program  // Santa Clara County Education Foundation Scholarship  // New York City Parks Foundation Scholarship  // Fulton County Education Fund Scholarship  // Orange County Community Foundation Scholarship  // Philadelphia Community Foundation Scholarship  // League of United Latin American Citizens (LULAC) Scholarship  // TikTok Creator Fund Scholarship  // Duct Tape Prom Scholarship  // Vegetarian & Vegan Students Scholarship  // Left-Handed Student Scholarship
  "1159": {
    targetGradeLevels: ['high-school-senior', 'college-freshman', 'college-sophomore', 'college-junior', 'college-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    specialRequirements: 'Left-handed individual',
  },

  // ============================================
  // BATCH 1: MIDDLE SCHOOL & CROSS-GRADE (1160-1169)
  // ============================================

  // World of 8 Billion Video Contest
  "1160": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // C-SPAN StudentCam Documentary Competition
  "1161": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Team America Rocketry Challenge (TARC)  // John Locke Institute Essay Competition
  "1163": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Ayn Rand Anthem Essay Contest
  "1164": {
    targetGradeLevels: ['middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // AFSA High School Essay Contest
  "1165": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // No Sweat Scholarship (ScholarshipOwl)
  "1166": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Coolidge Scholarship
  "1167": {
    targetGradeLevels: ['high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // United States Senate Youth Program
  "1168": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['leadership'],
  },
  // NHS Scholarship
  "1169": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['community-service', 'leadership'],
  },

  // ============================================
  // BATCH 2: MIDDLE SCHOOL SCHOLARSHIPS (1170-1179)
  // ============================================

  // Stephen J. Brady Stop Hunger Scholarship
  "1170": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service'],
  },
  // Rube Goldberg Machine Contest
  "1171": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
  },
  // National Young Composers Challenge
  "1172": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Invention Convention U.S. Nationals
  "1173": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Do the Write Thing Challenge
  "1174": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th'],
  },
  // MassMutual FutureSmart Scholarship
  "1175": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Caroline D. Bradley Scholarship
  "1176": {
    targetGradeLevels: ['middle-school-7th'],
    citizenshipRequired: ['us-citizen'],
  },
  // Future Problem Solving Program International
  "1177": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman'],
  },
  // The Blank Theatre Young Playwrights Festival
  "1178": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // YouthPLAYS New Voices One-Act Competition
  "1179": {
    targetGradeLevels: ['middle-school-6th', 'middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // ============================================
  // BATCH 3: 9TH-10TH GRADE SCHOLARSHIPS (1180-1189)
  // ============================================

  // Bennington Young Writers Awards
  "1180": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Patricia Grodd Poetry Prize for Young Writers
  "1181": {
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior'],
  },
  // NCTE Achievement Awards in Writing
  "1182": {
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Conrad Challenge
  "1183": {
    targetGradeLevels: ['middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Congressional App Challenge
  "1184": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // National Economics Challenge
  "1185": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Stockholm Junior Water Prize
  "1186": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Kaplun Foundation Essay Contest
  "1187": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Zero Robotics High School Tournament
  "1188": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // National History Bowl
  "1189": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // ============================================
  // BATCH 4: MORE 9TH-10TH GRADE SCHOLARSHIPS (1190-1199)
  // ============================================

  // NCF-Envirothon
  "1190": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // The Earth Prize
  "1191": {
    targetGradeLevels: ['middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Diamond Challenge
  "1192": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Blue Ocean Student Entrepreneur Competition
  "1193": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // National German Exam Study Abroad Scholarship
  "1194": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // National Spanish Exam Awards
  "1195": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // National Latin Exam Scholarships
  "1196": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // NFTE World Series of Innovation
  "1197": {
    targetGradeLevels: ['middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // All American High School Film Festival
  "1198": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // Jostens Photo Contest
  "1199": {
    targetGradeLevels: ['middle-school-7th', 'middle-school-8th', 'high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },

  // ============================================
  // BATCH 5: 11TH GRADE (JUNIOR) SCHOLARSHIPS (1200-1209)
  // ============================================

  // Research Science Institute (RSI)
  "1200": {
    targetGradeLevels: ['high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // MITES Summer at MIT
  "1201": {
    targetGradeLevels: ['high-school-junior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // National Youth Science Camp
  "1202": {
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen'],
  },
  // Alexander Hamilton Scholars
  "1203": {
    targetGradeLevels: ['high-school-junior'],
    requiresFinancialNeed: true,
  },
  // Rotary Youth Leadership Awards (RYLA)
  "1204": {
    targetGradeLevels: ['high-school-junior'],
  },
  // Jesse Brown Memorial Youth Scholarship
  "1205": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    requiredActivities: ['community-service'],
  },
  // William Faulkner Creative Writing Competition
  "1206": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
  },
  // AFS Global STEM Academies
  "1207": {
    targetGradeLevels: ['high-school-sophomore', 'high-school-junior'],
  },
  // Garcia Center Summer Research Program
  "1208": {
    minGPA: 3.8,
    targetGradeLevels: ['high-school-junior', 'high-school-senior'],
  },
  // U.S. National Chemistry Olympiad
  "1209": {
    targetGradeLevels: ['high-school-freshman', 'high-school-sophomore', 'high-school-junior', 'high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // ============================================
  // BATCH 6 — 12th Grade Scholarships (IDs 1210-1219)
  // ============================================
  // Project Yellow Light Scholarship
  "1210": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiresFinancialNeed: false,
  },
  // ScholarCHIPS Fund Scholarship
  "1211": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
    requiresFinancialNeed: true,
  },
  // Esperanza Education Fund Scholarship
  "1212": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
    requiresFinancialNeed: true,
  },
  // ISNA Dr. Abdulmunim A. Shakir Scholarship
  "1213": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
    requiredActivities: ['community-service'],
  },
  // P. Buckley Moss Endowed Scholarship
  "1214": {
    minGPA: 3.0,
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
  },
  // FleetNow Construct Your Future Scholarship
  "1215": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // Catholic Order of Foresters Scholarship
  "1216": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen'],
  },
  // Kaveny + Kroll Resilient Student Scholarship
  "1217": {
    targetGradeLevels: ['high-school-senior'],
  },
  // Redrick Leijon Nicholas Williams Scholarship
  "1218": {
    minGPA: 2.5,
    targetGradeLevels: ['high-school-senior'],
  },
  // Boom & Bucket Heavy Equipment Scholarship
  "1219": {
    targetGradeLevels: ['high-school-senior'],
    citizenshipRequired: ['us-citizen', 'permanent-resident'],
  },
  // --- Batch added by scholarship-agent 2026-03-21 ---
"1220": {
      "minGPA": 3,
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be a resident of Contra Costa County; current full-time community college student transferring in upcoming fall as a junior to a four-year college or university; demonstrate academic achievements, school activities, community involvement and employment; not be a chapter member, relative of a chapter member, or employee of Assistance League of Diablo Valley. Renewable with 2.8 GPA and maintenance of full-time status (at least 12 credits per term)."
  },
  "1221": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "Architecture"
      ],
      "specialRequirements": "Must attend an accredited New York university; seeking first architectural degree (with exceptions for M. Arch degree students); demonstrated academic excellence; not in final year of college; must be nominated by architectural program's coordinators; requires portfolio of 3 student projects, official letters of recommendation, and optional professional references"
  },
  "1222": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Connecticut"
      ],
      "specialRequirements": "Must be a resident of Connecticut. Must apply while in senior year of high school. Selection based on leadership, community service contributions, personal integrity, academic accomplishments, and written essay. Applicant must be college-bound."
  },
  "1223": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "specialRequirements": "Applicants must self-identify as Jewish. Must be attending or planning to attend accredited college or university in the United States or Canada, seeking a bachelor's degree or higher."
  },
  "1224": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Delaware"
      ],
      "specialRequirements": "Must be graduating from Newark, Delaware area. Selection based on grades, class rank, SAT scores, community and school service, extracurricular activities, and written essay. Must demonstrate exceptional character."
  },
  "1225": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "specialRequirements": "Must be resident of Imperial, Los Angeles, Orange, Riverside, San Bernardino, or Ventura County. Must be available for two-week (80 hours) internship with local planning agency, city/county council of governments, or SCAG. Priority given to students interested in urban planning, public policy and/or public service, environmental planning, engineering, and political science."
  },
  "1226": {
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "fire science",
          "paramedics",
          "nursing"
      ],
      "specialRequirements": "Must be a Minnesota resident enrolled in an accredited College or University. Selection based on personal statements and/or personal interviews, recommendations from instructors or program directors. Applicants must demonstrate initiative, leadership, service to community, commitment to completing program, and drive/energy/enthusiasm for their work. Open to both traditional and non-traditional students."
  },
  "1227": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFirstGen": true,
      "targetEthnicities": [
          "Chinese"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be Chinese student who is either first-generation in the U.S. or born overseas. Must be planning to attend a four-year college in the U.S. on a full-time basis. Must be actively involved in the Christian faith or Christian youth group for the last two years."
  },
  "1228": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "targetStates": [
          "Connecticut",
          "Massachusetts",
          "New Jersey",
          "Pennsylvania"
      ],
      "specialRequirements": "Must have Down Syndrome. Must be a graduating high school senior applying to attend college. Must demonstrate good character and kindness. Must submit a short essay sharing what they are looking forward to in college and how they will use the scholarship."
  },
  "1229": {
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "foodservice",
          "lodging",
          "tourism",
          "hospitality management"
      ],
      "specialRequirements": "Individual scholarship criteria varies; number of recipients and maximum dollar amounts vary"
  },
  "1230": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiredMajors": [
          "film",
          "television-production",
          "acting",
          "theater"
      ],
      "specialRequirements": "Must be Muslim or active member of Muslim community; must be enrolled full-time at accredited U.S. university by August OR employed full-time in ISF Supported Field and part-time student at accredited U.S. university; applications run from November until deadline"
  },
  "1231": {
      "minGPA": 3,
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiredMajors": [
          "law",
          "legal-studies",
          "human-rights"
      ],
      "specialRequirements": "Must be Muslim or active member of Muslim community; must be enrolled full-time at accredited U.S. university by August or employed full-time in ISF Supported Field and part-time student; applications run from November until deadline"
  },
  "1232": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiredMajors": [
          "media",
          "communications",
          "writing",
          "journalism"
      ],
      "specialRequirements": "Must be Muslim or an active member of the Muslim community. Must be enrolled full-time at an accredited U.S. university by August OR be a full-time employee in an ISF-supported field while studying part-time. Must submit video introduction, essay responses, work samples, official transcripts, and two letters of recommendation."
  },
  "1233": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiredMajors": [
          "political-science",
          "government",
          "public-policy",
          "international-relations",
          "public-administration"
      ],
      "specialRequirements": "Must be Muslim or active member of Muslim community; must be enrolled full-time at accredited U.S. university by August OR employed full-time in ISF Supported Field and part-time student; applications run from November until deadline"
  },
  "1234": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident",
          "daca"
      ],
      "requiredMajors": [
          "ISF supported fields"
      ],
      "specialRequirements": "Must be an active member of the Muslim community. Must be enrolled full-time at an accredited U.S. university by August 2026 or employed full-time in an ISF supported field while enrolled part-time. Ideal candidates demonstrate leadership, strong communication skills, and potential to impact public opinion."
  },
  "1235": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "transportation",
          "logistics",
          "supply chain management"
      ],
      "specialRequirements": "Must be enrolled in an accredited university. Rising high school seniors are not eligible. Applicants must submit transcripts, list of extracurricular activities, work history, personal statement, and recommendation letter. Selection based on merit on a competitive basis."
  },
  "1236": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiresDisability": true,
      "targetStates": [
          "Utah"
      ],
      "specialRequirements": "Must be legally blind. Must be a full-time student. High school seniors must plan to attend college full-time in the upcoming Fall. All finalists must attend the entire National Federation of the Blind of Utah convention. Supporting documents must be submitted in Word format."
  },
  "1237": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore"
      ],
      "specialRequirements": "Must be rising first or second-year undergraduate student. Must attend one of the participating institutions affiliated with the Christian Church (Disciples of Christ). Must be accepted and enrolled as full-time undergraduate. Must participate in Annual Leadership Conference and create a Volunteer Leadership Project. Scholarships are renewable annually."
  },
  "1238": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maryland"
      ],
      "requiredMajors": [
          "STEM",
          "Computer Science"
      ],
      "specialRequirements": "Must be resident of Prince George's County, Maryland. Must be graduating high school senior, matriculating undergraduate student, mentee, Collegiate 100 member, or PG County Public School graduate. Must plan to attend four-year, two-year, or vocational/trade school. Essay required (minimum 1500 words). Two letters of recommendation required (one academic, one character). Official transcript required. High-quality passport-sized photo required."
  },
  "1239": {
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "targetStates": [
          "Wisconsin"
      ],
      "requiredActivities": [
          "volunteer-service",
          "leadership"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Applicants must be ages 16-19, demonstrate commitment to volunteer service and leadership achievements, show dedication to empowering women through service and advocacy, and reside in the six-county greater Milwaukee metro area (Milwaukee, Waukesha, Washington, Ozaukee, Racine, and Kenosha counties) for local scholarship eligibility."
  },
  "1240": {
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "requiredMajors": [
          "architecture",
          "structural engineering",
          "civil engineering",
          "construction management"
      ],
      "specialRequirements": "Must be enrolled as junior (at least 60 semester hours or equivalent) or senior in full-time undergraduate course of study at an eligible four-year college or university for the entire upcoming academic year. Awards granted without regard to race, color, creed, religion, sexual orientation, gender, disability, or national origin."
  },
  "1241": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "southern-states"
      ],
      "requiredMajors": [
          "STEM-related fields supporting automotive industry careers"
      ],
      "requiredActivities": [
          "SAWF Mentoring Program participation"
      ],
      "specialRequirements": "Must attend accredited two-year technical program, four-year undergraduate program, or graduate program in a southern state. Recipients are encouraged but not required to attend the SAWF Annual Conference in late July. Recipients are expected to participate in the SAWF Mentoring Program."
  },
  "1242": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetEthnicities": [
          "african-american"
      ],
      "requiredMajors": [
          "biological-sciences",
          "physics",
          "chemistry",
          "computer-science",
          "engineering",
          "information-sciences",
          "mathematics"
      ],
      "specialRequirements": "Must be enrolled full-time as a degree-seeking first-year student at an accredited U.S. college or university. Must demonstrate readiness and commitment to major in a STEM field. Requires one letter of recommendation from a high school STEM teacher or STEM program mentor and submission of required essays addressing academic interests, career goals, and motivation to pursue a STEM degree."
  },
  "1243": {
      "requiresFinancialNeed": true,
      "specialRequirements": "Must be at least 18 years old and not currently enrolled in high school. Must be facing economic, social, or physical challenges. Must be pursuing an associate, bachelor's, or master's degree, or a technical/professional certification. Must apply through a participating Local Chapter."
  },
  "1244": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Georgia"
      ],
      "specialRequirements": "Must be a senior at Bradwell Institute or Liberty County High School in Hinesville, Georgia. Must be accepted to or currently enrolled in a technical college, community college, or university. Requires 500-word essay, letter of acceptance/enrollment, official transcript, and two letters of recommendation from educators, mentors, or community leaders."
  },
  "1245": {
      "minGPA": 3.25,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "requiredActivities": [
          "community-service",
          "civic-engagement"
      ],
      "specialRequirements": "Must be enrolled full-time at a U.S. accredited public or private high school (full-time home-schooling students not eligible). Must submit a video (30 seconds to 3 minutes) explaining how you are strengthening your community and why civic engagement is essential. Video must be in YouTube-compatible format. Must complete a phone interview with the Lampkin Foundation. Preference given to students interested in public service. Awards available: 3 per year. If junior is selected, award presented upon enrollment in college freshman semester/quarter."
  },
  "1246": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "targetStates": [
          "Washington",
          "Oregon"
      ],
      "requiredMajors": [
          "health"
      ],
      "specialRequirements": "Must be a resident of Cowlitz County, Washington, Wahkiakum County, Washington, or the City of Rainier, Oregon. Must be enrolled as a full-time student in an accredited college or university. Applicants may already be attending college."
  },
  "1247": {
      "requiresFinancialNeed": true,
      "specialRequirements": "Must attend a TMCF member school or other accredited institution. Eligibility varies by specific scholarship opportunity. Applicants must meet all eligibility requirements listed for each scholarship. Awards available: 2,000."
  },
  "1248": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Michigan"
      ],
      "specialRequirements": "Must live in BBB of Michigan's 80 County Service Area (all Michigan counties except Monroe, Lenawee, and Hillsdale). Selection based on written submission demonstrating understanding and display of Trust and Ethics."
  },
  "1249": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Mexico"
      ],
      "specialRequirements": "Must be high school senior, equivalent homeschool senior, or GED recipient planning to enroll in full-time undergraduate study for the entire upcoming academic year at an accredited two-year or four-year college, university, or vocational-technical school."
  },
  "1250": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Connecticut",
          "Maine",
          "Massachusetts",
          "New Hampshire",
          "Rhode Island",
          "Vermont"
      ],
      "specialRequirements": "Must be diagnosed with a Congenital Heart Defect (CHD), a recipient of a heart transplant, or a family member of someone diagnosed with CHD (sibling, child, parent, or close relative). Must be a resident of one of the New England states. Requires one letter of recommendation and a 1-2 page essay describing how CHD has affected applicant's life and how they promote CHD awareness."
  },
  "1251": {
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "African-American",
          "Black"
      ],
      "specialRequirements": "Must reside in a district represented by a Congressional Black Caucus Member. Essay submission required on a topic related to pressing community issues."
  },
  "1252": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "Black",
          "African American"
      ],
      "requiredMajors": [
          "performing-arts",
          "drama",
          "music",
          "dance",
          "opera"
      ],
      "specialRequirements": "Must be full-time student at accredited college or university. Application requires video personal statement (max 3 minutes), video work sample on YouTube (max 2 minutes), two letters of recommendation, official transcripts, resume, and professional-quality photograph."
  },
  "1253": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "environmental-science"
      ],
      "specialRequirements": "Applicants must maintain a 3.0 GPA in their first college semester to receive the award. Special consideration for applicants with immediate family members who are NHASH members or involved in septic system industry-related businesses/organizations meeting NHASH Associate member criteria. Applicants must email the provider directly to apply."
  },
  "1254": {
      "minGPA": 2.8,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetEthnicities": [
          "Asian"
      ],
      "targetStates": [
          "CA"
      ],
      "specialRequirements": "Must be at least 50% Asian heritage. Must be a resident of Fairfield or Suisun, CA, or a graduating senior from a high school in Fairfield or Suisun. Must be enrolled full-time at an accredited four-year college/university or a community college intending to transfer to a four-year institution."
  },
  "1255": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "environmental-studies",
          "environmental-engineering",
          "agriculture",
          "agricultural-business",
          "waste-management"
      ],
      "specialRequirements": "Must reside in Ontario County, New York. Must be accepted into a recognized college-level program leading to an associate or bachelor's degree. Must demonstrate dedication to a career supporting the environment, agriculture, or waste management."
  },
  "1256": {
      "minGPA": 2.25,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Michigan"
      ],
      "requiredActivities": [
          "leadership",
          "community-service"
      ],
      "specialRequirements": "Must be a current high school senior living in Detroit and attending a Detroit Public School Community District high school or a charter school within Detroit"
  },
  "1257": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "targetEthnicities": [
          "Black"
      ],
      "requiredMajors": [
          "Computer Science",
          "Information Technology",
          "Engineering"
      ],
      "specialRequirements": "Must attend or plan to attend an accredited two- or four-year college or university. Applicants must submit academic transcripts, complete online application form, and may need to submit essays or recommendation letters."
  },
  "1258": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-senior"
      ],
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "maritime-trades"
      ],
      "specialRequirements": "Applicants must live in Virginia or be willing to relocate to Virginia. Open to high school seniors or college seniors planning a maritime career, or individuals interested in transitioning into skilled maritime trades. Dependents of Virginia Ship Repair Association member company employees are encouraged to apply. Requires one-page personal statement and letter of recommendation."
  },
  "1259": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "African American"
      ],
      "specialRequirements": "Must submit a typed essay of no less than 300 words on the topic: 'Explain the Benefits You Have Gained through the Contributions of Two (2) Trailblazers of African Descent within the past twenty(20) years, and How It Has Benefited You as a Person.' GPA must be 3.0 or above on a 4.0 scale by February 1st of the graduation year."
  },
  "1260": {
      "minGPA": 2.7,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "california"
      ],
      "requiredMajors": [
          "criminal-justice",
          "law-enforcement"
      ],
      "specialRequirements": "Full-time enrollment at accredited college/university with completion of 24 semester or 36 quarter units (or graduating high school senior with proof of college enrollment). Commitment to pursuing degree for career in criminal justice or law enforcement. Official transcripts and proof of full-time enrollment required before award disbursement."
  },
  "1261": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "IL"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must reside in Morton, IL School District 709. Must plan to attend a trade school or junior college. Application requires two references (one academic, one personal), brief autobiography (250 words or less), and official high school transcript."
  },
  "1262": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Iowa"
      ],
      "requiredMajors": [
          "welding",
          "CNC machining",
          "industrial automation",
          "industrial maintenance",
          "robotics",
          "tool and die",
          "transportation and logistics"
      ],
      "specialRequirements": "Must be attending an Iowa Community College in the fall. Applicants must answer eligibility questions as part of the application."
  },
  "1263": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "specialRequirements": "Applicant must have hearing loss and be attending college or vocational school"
  },
  "1264": {
      "requiredMajors": [
          "product design",
          "industrial design",
          "design engineering",
          "manufacturing",
          "architecture"
      ],
      "specialRequirements": "Open to both students and professionals from around the world. Participants must incorporate at least one extruded aluminum component in their design. Divided into Student and Professional categories. Free entry for all participants."
  },
  "1265": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "black-or-african-american"
      ],
      "targetStates": [
          "arkansas"
      ],
      "specialRequirements": "Must be between 17-25 years old, economically disadvantaged, have completed high school diploma, have roots in Arkansas, and be planning to attend or currently enrolled in accredited university, college, or vocational school. Current recipients must submit updated application materials annually for renewal."
  },
  "1266": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresMilitaryConnection": true,
      "targetStates": [
          "Maryland",
          "North Carolina",
          "Louisiana",
          "Kansas",
          "Alabama",
          "Oklahoma"
      ],
      "specialRequirements": "Must be dependent of active-duty service member stationed at Aberdeen Proving Ground (MD), Fort Bragg (NC), Fort Meade (MD), Fort Polk (LA), Fort Riley (KS), Fort Rucker (AL), or Fort Sill (OK). Must provide DD1173 Form or equivalent military dependent identification, current Duty Station/PCS Orders, high school transcript, 1-2 letters of recommendation, and resume. Selection based on academic performance, community involvement, and financial need."
  },
  "1267": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredActivities": [
          "participation in activities and events at Del Mar Fairgrounds"
      ],
      "specialRequirements": "Must be San Diego area resident graduating from high school no later than July 31 or be a high school graduate. Must submit high school transcript. Scholarship must be used at a four-year institution or two-year college with vocational major/coursework in anticipation of transferring to four-year college. Must be used within four years or funds returned. Previous Don Diego Scholarship Foundation winners are ineligible."
  },
  "1268": {
      "minGPA": 2,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "requiredMajors": [
          "accounting"
      ],
      "specialRequirements": "Must attend an AACSB accredited college or university. Must be pursuing an accounting degree program (including double majors). Application period opens January 23 and closes March 30. For Horizons Scholarship specifically: must be primary source of support for family and within approximately 60 credit hours of completing degree. For renewal: must maintain minimum 2.0 GPA and show continued progress toward accounting degree."
  },
  "1269": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "accounting"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must demonstrate aptitude in accounting and business through prior coursework and/or work experience. Must show commitment to pursuing an accounting degree for career as accounting or finance professional. Must establish clear evidence of personal and professional goals with a plan for achieving them. Must be attending an accredited U.S. school."
  },
  "1270": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Louisiana",
          "Mississippi"
      ],
      "requiredMajors": [
          "STEM"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must have ACT score of 28 or higher. Must intend to pursue a research-based STEM graduate degree (Ph.D. or research-focused M.S.). Career goals must align with research-focused STEM fields such as laboratory science, engineering research, or academic research roles. Students pursuing clinical or professional healthcare careers (M.D., P.A., R.N., dentist, pharmacist, physical/occupational therapist, veterinarian) are not eligible."
  },
  "1271": {
      "targetStates": [
          "Massachusetts"
      ],
      "requiredActivities": [
          "youth volunteering or work"
      ],
      "specialRequirements": "Must be a resident of Fitchburg, age 21 or under, and continuing education in the coming year"
  },
  "1272": {
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "Engineering",
          "Math",
          "Metals",
          "Technology",
          "STEM (Trade School)",
          "Nursing"
      ],
      "specialRequirements": "Applications open in February. Three scholarship types: Trade School (STEM), Nursing School (2 & 4 year programs), and College/University (Engineering, Math, Metals, Technology). Deadlines vary by scholarship type."
  },
  "1273": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "trade-related fields in remodeling industry"
      ],
      "specialRequirements": "Must be high school graduating senior in Minnesota. Must be accepted as full-time or part-time student in accredited college, university, or vocational program. Special consideration for students with parents working at NARI of MN companies. Preference for students entering project management in construction. Essay required (250 words or less). Two letters of recommendation required (one teacher, one personal or employer). Letter of acceptance from program of study required."
  },
  "1274": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresDisability": true,
      "targetStates": [
          "Arkansas"
      ],
      "requiredActivities": [
          "school-community-participation"
      ],
      "specialRequirements": "Must be a current Arkansas resident. Must have documented learning disability (Dyslexia, Dysgraphia, or Dyscalculia). Must be enrolled in Fall Semester at university, two-year community college, or vocational/technical training program. Applicant should demonstrate self-advocacy skills, commitment to academic/career goals, and participation in school and community activities."
  },
  "1275": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Diagnosed with a rare genetic disease (Achondroplasia, Batten disease, Hemophilia A, Mucopolysaccharidosis (MPS), or Phenylketonuria (PKU)). Must be enrolled or plan to enroll at least part-time at an accredited institution. Official doctor's statement of diagnosis required. BioMarin employees and their children may not apply. Merit-based award."
  },
  "1276": {
      "minGPA": 3,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "architecture",
          "engineering"
      ],
      "specialRequirements": "Applicants must be either: (1) Fourth-year students in a NAAB accredited degree program, (2) Fourth-year students in a four-year pre-professional degree program in architecture accepted for direct entry to a two-year NAAB accredited M.Arch program, or (3) First-year students in a NAAB accredited M.Arch degree program with undergraduate degrees in another discipline."
  },
  "1277": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-freshman",
          "graduate"
      ],
      "requiresDisability": true,
      "targetStates": [
          "Ohio"
      ],
      "specialRequirements": "Applicant must be an Ohio resident or attend an Ohio postsecondary school. Must be blind, low vision, or studying a field that directly benefits the blind and low-vision community. Selected recipients must complete a short audio recording with a committee member for use during the ACBO state convention. Interview required via Zoom or phone call in April."
  },
  "1278": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "horticulture-related fields"
      ],
      "specialRequirements": "Preference given to residents of North Port, Port Charlotte, Englewood, or Venice, Florida. College sophomores eligible if entering junior year the following fall."
  },
  "1279": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresMilitaryConnection": true,
      "specialRequirements": "Must be a post-9/11 military veteran from the USA or Australia. Must be undertaking or planning to undertake full-time undergraduate or graduate study. Must have an offer or acceptance from an accredited institution in the USA or Australia. Application requires headshot, study field photo, 1-minute video, passport biographic page copy, offer/acceptance letter, academic transcripts (if applicable), one-page resume, detailed budget, and three referees."
  },
  "1280": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Arizona"
      ],
      "requiredMajors": [
          "wildlife science",
          "closely related field"
      ],
      "specialRequirements": "Must be enrolled full-time for fall semester/quarter. Arizona resident or attending college in Arizona. Two letters of recommendation from professional or educational references required. Preference given to students with conservation-related internships or volunteer experience. Required essays addressing degree choice, conservation interest, career goals, and scholarship merit. Descriptions and contact information for conservation-related internships or volunteer experiences must be included."
  },
  "1281": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresMilitaryConnection": true,
      "requiredMajors": [
          "nursing",
          "nurse anesthesia"
      ],
      "specialRequirements": "Must be currently enrolled in an accredited baccalaureate or advanced degree nursing or nurse anesthesia program. Must have military connection through: personal service in US Army (Active Army, Army National Guard, or Army Reserve) with Honorable Discharge if applicable, OR parent(s), spouse, or child(ren) with current or previous service in US Army. Cannot be currently receiving funding from a component of the US Army (e.g., ROTC scholarship or full GI Bill benefits). Eligible programs include: BSN, RN to BSN, Accelerated Nursing Degree, Graduate Certificate in Nursing, MSN, Anesthesia and Nursing Doctoral programs, or graduate degree in related healthcare fields in furtherance of nursing career."
  },
  "1282": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Arkansas"
      ],
      "requiredMajors": [
          "music"
      ],
      "requiredActivities": [
          "musical-talent"
      ],
      "specialRequirements": "Must be Arkansas high school graduate and resident. Must demonstrate musical talent in school or community activities. Must provide letters of recommendation. Must commit to serve the State of Arkansas for at least one year after college graduation. Must be present at annual scholarship benefit to receive award. Must provide proof of registration and enrollment in college/university for fall semester."
  },
  "1283": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "civil-engineering",
          "related-engineering-fields"
      ],
      "specialRequirements": "Must be enrolled full-time at senior level during the coming academic year at an accredited institution. Must submit three letters of recommendation, essay on engineering experience and post-graduation plans, and official transcript."
  },
  "1284": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore"
      ],
      "targetStates": [
          "georgia"
      ],
      "requiredMajors": [
          "architecture",
          "building science",
          "construction-related engineering",
          "interior design",
          "operations management",
          "project management",
          "construction technology",
          "construction management",
          "supply chain management",
          "drafting",
          "manufacturing engineering"
      ],
      "specialRequirements": "Academic scholarship applicants must be freshman or sophomore students. Membership service grants available to college students or professionals within their first three years in the A/E/C field. Other degree programs aligned with A/E/C space may be considered with prior approval."
  },
  "1285": {
      "targetStates": [
          "Texas"
      ],
      "specialRequirements": "Applicants must be attending or planning to attend accredited Texas institutions of higher education. Masonic connection not required. Race, creed, religion, color, sex, and national origin do not affect selection. Recipients selected after completing comprehensive written application."
  },
  "1286": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must reside in one of the following Northern Illinois counties: Boone, Carroll, Cook, DeKalb, DuPage, Grundy, JoDavies, Kane, Kankakee, Kendall, Lake, LaSalle, Lee, McHenry, Ogle, Stephenson, Whiteside, Will, or Winnebago. Must submit a video under 90 seconds addressing the scholarship prompt and a written statement explaining financial need."
  },
  "1287": {
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Jewish"
      ],
      "targetStates": [
          "Missouri"
      ],
      "requiredMajors": [
          "Business"
      ],
      "specialRequirements": "Must reside in or consider the St. Louis metropolitan area as permanent residence"
  },
  "1288": {
      "minGPA": 2.5,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "specialRequirements": "Must be a childhood cancer survivor under age 25, diagnosed with cancer or high grade/anaplastic brain tumor before age 18. Must be accepted into a post-secondary school for the fall semester of the upcoming academic year. Must be living in and attending school in the United States."
  },
  "1289": {
      "requiredActivities": [
          "leading or actively involved in an environmental project or campaign"
      ],
      "specialRequirements": "Must be between ages 13 and 22 as of the application deadline. Must reside in North America, including Mexico, Canada, and U.S. territories. Applicants must submit their own application (no third-party submissions). Semifinalists must participate in a video call interview and submit a letter of support from someone familiar with their environmental work (not a parent or guardian)."
  },
  "1290": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior"
      ],
      "requiredMajors": [
          "food science",
          "drug regulation",
          "quality control",
          "consumer product safety"
      ],
      "specialRequirements": "Must be in third year of college. Must submit official and complete college transcript. Must submit letters of recommendation from two faculty members."
  },
  "1291": {
      "minGPA": 2.5,
      "requiredMajors": [
          "environmental science",
          "fire protection",
          "health physics",
          "industrial engineering",
          "industrial hygiene",
          "occupational health",
          "safety"
      ],
      "specialRequirements": "Must be currently registered as a full-time student in North America (enrolled in 12 credit hours per semester, trimester, or quarter). Must write and submit an essay describing an occupational health, occupational safety, or campus environmental issue relevant to university/college or community with supporting information, facts, and data."
  },
  "1292": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman"
      ],
      "targetStates": [
          "states where Carl's Jr. operates (16 states)"
      ],
      "specialRequirements": "Must be age 26 or younger. Must be enrolling as full-time college freshman at accredited college or university. Must submit either 30-90 second video or 250-word written response explaining how higher education will help pursue passion. Must provide recommender contact information for recommendation submission."
  },
  "1293": {
      "minGPA": 2,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "Chicana",
          "Latina"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be enrolled in accredited college/university/community college in one of 13 specified Northern California counties (Alameda, Contra Costa, Marin, Monterey, Napa, Sacramento, San Mateo, Santa Clara, Santa Cruz, Solano, San Francisco, Sonoma, or Yolo). Must have lived at least 2 years in one of these counties at time of application. Community college/undergraduate students must be full-time and have completed 12 college units after high school. Graduate students must have cumulative GPA of 2.7. Recipients must attend all Leadership Institute sessions, participate in Annual Award Dinner, and serve as CLF Ambassador for 10 hours during next application cycle."
  },
  "1294": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredActivities": [
          "marksmanship-competition"
      ],
      "specialRequirements": "Good moral character; acceptance to university, college, or trade school; certified high school transcript; letter of nomination/recommendation from coach/instructor/adult leader; personal letter explaining reasons for applying and how scholarship will help goals; proof of marksmanship activity documentation"
  },
  "1295": {
      "minGPA": 2.5,
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "automotive service"
      ],
      "specialRequirements": "Must intend to pursue a career at a California franchised new car dealership; must be eligible for employment in California; must maintain part-time status of six units each term"
  },
  "1296": {
      "requiresFinancialNeed": true,
      "requiresPellGrant": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Ohio"
      ],
      "specialRequirements": "Age 19 or older; High school graduate or GED recipient; Education interrupted for at least two academic semesters; Resident of Ashtabula, Cuyahoga, Geauga, Lake, Lorain, Mahoning, Medina, Portage, Stark, Summit, Trumbull, or Wayne County in Northeast Ohio; Pursuing vocational/technical certificate, associate degree, or first bachelor's degree; Not previously completed a bachelor's degree; Attending public or private not-for-profit Pell-eligible institution; Must be enrolled at least half-time (6+ credit hours) for both fall and spring semesters; Renewable for up to five years or ten semesters"
  },
  "1297": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Resident of Contra Costa County, California. Enrolled full-time or accepted to a full-time educational program by Fall. Minimum GPA of 3.5 required for high school seniors. Must attend scholarship luncheon in June if selected."
  },
  "1298": {
      "minGPA": 3.5,
      "targetStates": [
          "Colorado"
      ],
      "specialRequirements": "Must be enrolled in or scheduled to enter accredited college/university as undergraduate (minimum 12 credit hours); Colorado resident for minimum 12 months prior to application; demonstrate active community service at school and in community; submit typed essay of 1,000 words or less covering: (1) need for scholarship, (2) college education goals, (3) community service involvement and importance; ineligible if family member of board, employee of Credit Union of Colorado Foundation, or scholarship committee member"
  },
  "1299": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maryland"
      ],
      "requiredMajors": [
          "engineering",
          "science",
          "environmental",
          "construction",
          "water-related fields"
      ],
      "specialRequirements": "College Scholarship restricted to Baltimore City/County high school or home-schooled seniors. High school scholarships open to graduating seniors including home-schooled students. Aaron Thomas Memorial Scholarship requires enrollment in college-level programs. Career focus on water, wastewater, or stormwater industries required."
  },
  "1300": {
      "minGPA": 3,
      "targetEthnicities": [
          "minority",
          "BIPOC"
      ],
      "requiredMajors": [
          "social work"
      ],
      "specialRequirements": "Must be graduating with a social work degree from a CSWE-accredited bachelor or master's degree program; expected graduation date no later than summer of the year the scholarship is offered; must be enrolled full-time during the period in which the grant is awarded; must demonstrate commitment to promoting equity and social justice; scholarships are targeted to but not limited to minority/BIPOC individuals"
  },
  "1301": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Colorado",
          "Kansas",
          "Louisiana",
          "Montana",
          "New Mexico",
          "Oklahoma",
          "Texas",
          "Wyoming"
      ],
      "requiredMajors": [
          "agriculture"
      ],
      "requiredActivities": [
          "FFA or 4-H dairy show participant"
      ],
      "specialRequirements": "Applicant must be either a child of a dairy farmer, a child of a dairy farm employee, or an FFA or 4-H dairy show participant in junior or senior year of high school. Must reside in geographic territory served by Dairy MAX (Colorado, southwest Kansas, Louisiana, Montana, New Mexico, western Oklahoma, Texas, and Wyoming). Must be currently enrolled in junior college or four-year college program."
  },
  "1302": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "sports sciences",
          "kinesiology",
          "conservation",
          "physical education",
          "recreation and tourism management"
      ],
      "specialRequirements": "High school seniors must be accepted to accredited college/university for minimum 12 hours enrollment and meet one of: minimum 2.5 GPA, top quarter class ranking, minimum 850 SAT, or minimum 21 ACT. College/university students must be enrolled in accredited Bachelor's, Master's, or Doctoral program, maintain minimum 12 hours per semester (full-time for graduate students), and have minimum 2.5 GPA. Preference given to applicants attending Texas college or university."
  },
  "1303": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Minnesota"
      ],
      "requiredActivities": [
          "volunteerism",
          "community-service"
      ],
      "specialRequirements": "Applicant must be a child of a first responder (parent/guardian employed as first responder). Must be a resident of Minneapolis, St. Paul, or surrounding suburbs. Must be from an accredited high school (home-schooled students eligible) or current college/trade school student. Application requires: completed application, 500-word maximum essay (typed, double-spaced), official transcript with GPA, proof of parent/guardian's first responder occupation (copy of ID or supervisory letter on station letterhead), resume with community/volunteer service, academic recognition, hobbies, extracurricular activities, and work history (with proof of service), and recommendation letter from high school counselor, teacher, or other character reference."
  },
  "1304": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresDisability": true,
      "specialRequirements": "Must be enrolled full-time or part-time (if due to disability) in an accredited 2 or 4-year institution in the U.S. Must demonstrate a disability as defined under the ADA. Requires proof of disability and matriculation from the college or university's Disability Student Services. Essay required (no more than 1,000 words)."
  },
  "1305": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "students of color"
      ],
      "requiredMajors": [
          "Agriculture"
      ],
      "specialRequirements": "Must be 17 years of age or older. Must be enrolled full-time or part-time in an Agriculture-focused program at an accredited two-year or four-year college or university for the coming school year."
  },
  "1306": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "Agriculture"
      ],
      "specialRequirements": "Must be 17 years of age or older. Must be enrolled full-time or part-time in an Agriculture-focused program at an accredited two-year or four-year college or university for the coming school year. Preference for students pursuing careers in AgTech or sustainable agriculture."
  },
  "1307": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Environmental Studies",
          "Natural Science",
          "Environmental Science"
      ],
      "specialRequirements": "Applicants must reside in or attend high school in Lake, McHenry, Kane, Cook, DuPage, Kendall, or Will County, Illinois. Entering College applicants must have minimum B average for first three years of high school and plan to attend accredited college/university. Continuing College applicants must be currently enrolled in accredited college/university with minimum B average and have graduated from high school in eligible counties with minimum B average. Career must be directly related to preserving the natural environment."
  },
  "1308": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "architecture",
          "civil engineering",
          "structural engineering",
          "construction management",
          "material science",
          "related fields"
      ],
      "specialRequirements": "Must be enrolled at an accredited college or university in North America for the coming academic year. Full-time or part-time enrollment accepted. High school students are not eligible. Requires original essay between 1,000-2,000 words in English on a topic related to galvanizing or its application in applicant's field. Two awards available annually."
  },
  "1309": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "automotive-technician"
      ],
      "specialRequirements": "Must be enrolled full-time as high school senior OR accepted/enrolled (full-time or part-time) at accredited college, university, or trade school in the U.S. Must submit recent transcripts, two letters of recommendation (non-family members), and either an essay (1,000 word limit) or video (3 minute limit) about themselves and career goals."
  },
  "1310": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Missouri"
      ],
      "requiredMajors": [
          "construction-related fields"
      ],
      "specialRequirements": "Must be enrolled full-time with at least one term remaining. Ineligible: immediate family members of NAWIC members (husband, son, daughter, father, mother, sister, brother). Student members of NAWIC are eligible unless an immediate family member is a NAWIC member. Open to all applicants regardless of race, color, sex, religion, handicap, age, or national origin."
  },
  "1311": {
      "specialRequirements": "Essay contest format. Winners invited to receive awards at luncheon during Annual GRHS Convention in Mandan, North Dakota. Page indicates eligibility criteria include: Ethnicity, State Selection, Current Year in School, and Citizenship (specific requirements not detailed)."
  },
  "1312": {
      "minGPA": 2.75,
      "requiresFinancialNeed": true,
      "specialRequirements": "Must be between 15-25 years of age as of March 31st. Must be a resident of a Hearthstone Housing Foundation property or a county where a Hearthstone property is located. Must be a full-time high school or undergraduate student during the upcoming academic year. High school students must maintain minimum 3.0 GPA; college students must maintain minimum 2.75 GPA. Must participate in phone interview in May or June. Funds cannot be used for graduate studies or studying abroad."
  },
  "1313": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Georgia"
      ],
      "requiredMajors": [
          "teaching",
          "education"
      ],
      "specialRequirements": "Must have graduated or will graduate from a Georgia public high school. Must plan to attend a college or university in Georgia."
  },
  "1314": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredActivities": [
          "community-service",
          "philanthropy"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must reside in Cook, DuPage, Kane, or Will County in Illinois. Must demonstrate leadership and commitment to community service and philanthropy."
  },
  "1315": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Michigan"
      ],
      "specialRequirements": "Age 17-19, demonstrates character and resilience, community involvement, planning to pursue college, trade school, entrepreneurship, or military service"
  },
  "1316": {
      "targetGradeLevels": [
          "graduate"
      ],
      "specialRequirements": "Must be an international student; must plan to enroll in undergraduate or graduate studies in the United States; must attend an accredited U.S. college or university; must submit either a 500-word essay or a 3-minute video response to a provided prompt"
  },
  "1317": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Indiana"
      ],
      "requiredMajors": [
          "engineering"
      ],
      "specialRequirements": "Applicant and parents/legal guardian must be Indiana residents. Applicant must attend an Indiana educational institution or commute daily to a school outside Indiana. Must be entering at least sophomore year in an EAC/ABET accredited engineering degree program. Applicant cannot be a legal dependent of any Scholarship Committee member. Selection based on academic standing in EAC/ABET accredited engineering program, extracurricular activities, and comments from teachers/administrators."
  },
  "1318": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Business",
          "Engineering"
      ],
      "specialRequirements": "Must be enrolled or intending to enroll as a full-time student at an accredited university in Canada or U.S. Essay required (750 words maximum) explaining personal story, why deserving of scholarship, and importance of business or engineering in Canada's/U.S. economy. Must submit unofficial transcript, invitation letter, or acceptance letter from institution. Citizenship documentation required."
  },
  "1319": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "African",
          "African-American"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must reside in San Mateo County, Santa Clara County, Alameda County, San Francisco City/County, or Contra Costa County. Must be graduating in Spring of the year the scholarship is awarded. Must be accepted to a two-year, four-year, or vocational college and show proof of enrollment before scholarship funds will be dispersed. Essay submission required."
  },
  "1320": {
      "minGPA": 3.8,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "business"
      ],
      "specialRequirements": "Must be a resident of Los Angeles, Riverside, Orange, or San Bernardino county. Must be pursuing higher education at a 4-year institution or accredited vocational school. Essay required reflecting personal experiences and goals. Finalists may be interviewed. Recipients' photos and essays may be featured on BCA website and social media."
  },
  "1321": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "conservation",
          "wildlife",
          "teaching"
      ],
      "specialRequirements": "Applicant must be accepted to a two or four year accredited college or university. Applicant must be a high school senior in good standing at school and in the community. Funds are paid after completion of the first semester."
  },
  "1322": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Residence in District 7 region (Edwardsville and Glen Carbon); must be planning to attend college upon high school graduation; merit-based; requires essay and letter of recommendation"
  },
  "1323": {
      "noEssayRequired": true,
      "specialRequirements": "Open to new and amateur artists worldwide who have not been professionally published and paid for more than three black-and-white story illustrations, or more than one process-color painting, in media distributed broadly to the general public. Entrants should provide means for written communication in English. No entry fee required. Entrants retain all publication rights. Quarterly deadlines: March, June, September, and December."
  },
  "1324": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "trade-or-technical-program"
      ],
      "specialRequirements": "Must be a graduating high school senior planning to enroll in a trade or technical program at an accredited trade school or two-year college in Florida. Program of study must be located within West Orange and South Lake Counties service area. Applicants must submit two letters of recommendation and a 500-word essay explaining why they want to pursue a career in the skilled trades and how they plan to serve their community."
  },
  "1325": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Missouri"
      ],
      "specialRequirements": "Permanent residence in St. Louis metropolitan area (graduating from area high school). Must be enrolling in full-time undergraduate degree programs or vocational programs at accredited nonprofit colleges or universities. Preference given to applicants of any faith with connection to Jewish community. First-generation college students are supported with special consideration."
  },
  "1326": {
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "culinary arts",
          "nutrition",
          "hospitality",
          "baking",
          "pastry"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Applicants must be enrolled in an accredited Chicago-area culinary school or hospitality program. Applicants must demonstrate a passion for culinary arts, nutrition, hospitality, or baking and pastry. Applicants must maintain satisfactory academic progress. Application requires personal statement, two letters of recommendation, and current academic transcript."
  },
  "1327": {
      "targetEthnicities": [
          "underrepresented-groups-in-mental-health"
      ],
      "requiredMajors": [
          "mental-health-related-field"
      ],
      "requiredActivities": [
          "mental-health-advocacy"
      ],
      "specialRequirements": "Changemaker: Must be incoming or currently enrolled student, engaged in mental health advocacy. Warrior: Must be 18+ years old, have faced barriers to accessing mental health services (financial, geographic, or other). Additional consideration for applicants under 26 or affiliated with Letters to Strangers Chapter or partner organization."
  },
  "1328": {
      "noEssayRequired": true,
      "specialRequirements": "Current high school student. Poem must be 20 lines or less, written in English, and previously unpublished. Only 1 poem per 90-day period permitted. Submission must include full name, mailing address, high school, year of graduation, and English teacher name."
  },
  "1329": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be a graduating senior from high school or homeschool in Volusia County, Florida. Must plan to attend an accredited two-year, four-year, or vocational program. Applicants must be ESE students pursuing further education or vocational training, or students pursuing a related field to support individuals with special needs. Must demonstrate dedication to serving or advocating for individuals with special needs."
  },
  "1330": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "African American"
      ],
      "requiredMajors": [
          "healthcare-related"
      ],
      "specialRequirements": "Must plan to attend a two- or four-year university or technical school. Open to students across the United States. Application requires: recent photo, cover letter, creative resume, one-page personal essay, two letters of recommendation, current transcripts, and college acceptance letter (if available). All documents must be submitted as a single PDF file through the online application system by 11:59 PM EST on deadline date."
  },
  "1331": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "mathematics",
          "physics"
      ],
      "specialRequirements": "Must be enrolled at one of the following institutions: University of Oregon, Oregon State University, Portland State University, Western Oregon University, Eastern Oregon University, Southern Oregon University, or The Oregon Institute of Technology"
  },
  "1332": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "hispanic"
      ],
      "targetStates": [
          "california"
      ],
      "specialRequirements": "Must be of Hispanic origin (minimum one Hispanic parent or two Hispanic grandparents). Must be graduating or have graduated from a high school in Southern California. Must be applying, accepted, or enrolled as a full-time undergraduate student at an accredited institution. Community college students must intend to enroll in and obtain a bachelor degree from a four-year accredited institution. Preference given to students with demonstrated leadership or mentoring qualities through civic involvement."
  },
  "1333": {
      "targetGradeLevels": [
          "college-freshman"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Nebraska"
      ],
      "specialRequirements": "Current Nebraska resident; must demonstrate passion for automotive in pursuit of a degree or certification at a college, university, or post-secondary career and technology school in the U.S."
  },
  "1334": {
      "minGPA": 2,
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "Horticulture",
          "Landscape"
      ],
      "specialRequirements": "Must be a resident of Massachusetts for at least one year prior to submitting application. Recipient is responsible for forwarding transcripts to scholarship committee. Scholarship paid in two installments (one per semester)."
  },
  "1335": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Jersey"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must have permanent address within Monk's service area in northern New Jersey. Must demonstrate strong commitment to community service and betterment. Special consideration given to applicants exhibiting leadership or entrepreneurial thinking in service endeavors. Must be available to participate in person for a group 'Pack and Donate' project supporting nourish.NJ in the Spring (maximum two-hour time commitment). Selection based on essay quality and content."
  },
  "1336": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Missouri"
      ],
      "requiredMajors": [
          "engineering"
      ],
      "specialRequirements": "Minimum ACT scores of 29 in Math and 25 in English (or equivalent SAT scores of 950 in Math and 750 in English). Must enroll in an ABET-EAC accredited engineering program at a named Missouri institution, approved transfer program, or approved out-of-state engineering school."
  },
  "1337": {
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Applicants must articulate their experiences and views on campus conservatism. Two awards available (one for college category, one for high school category). Winning essays may be published."
  },
  "1338": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresDisability": true,
      "specialRequirements": "Applicants must be legally blind in both eyes; be at least 18 by the beginning of July; be pursuing or planning to pursue a full-time, post-secondary degree program at a U.S. institution in the fall of the year of application; be a resident of the fifty states, the District of Columbia, or Puerto Rico; and be able to participate in the entire NFB National Convention and all scheduled scholarship program activities."
  },
  "1339": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "Nursing",
          "RN-to-BSN",
          "Advanced Nursing",
          "Nursing Certification"
      ],
      "specialRequirements": "Must attend accredited baccalaureate, associate degree, RN-to-BSN-completion, advanced nursing degree, or (re)-certification program in Pennsylvania. High school students must be matriculated undergraduates in fall. Baccalaureate students must be in sophomore or junior year by May. Associate degree students must be in final year. RN-to-BSN students must be accepted into degree-completion program. Non-RN applicants must be accepted into basic RN program at time of application."
  },
  "1340": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "nursing"
      ],
      "specialRequirements": "Must be enrolled in or planning to pursue BSN, RN-BSN, MSN, or doctorate in nursing at an accredited program in Pennsylvania. Must attest to financial need with documentation of federal/state grants and loans. Previous NFP scholarship recipients are ineligible."
  },
  "1341": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Black",
          "African-American"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "Nursing - LPN",
          "Nursing - RN-BSN",
          "Nursing - Baccalaureate"
      ],
      "specialRequirements": "Must attend accredited nursing program in Pennsylvania; must not be in final year of nursing program; PSNA membership required for currently licensed RNs; SNAP or NSNA membership highly encouraged for pre-licensure students; can only apply to one NFP scholarship per year (excluding Jack E. Barger, Sr. Memorial Nursing Scholarship); must submit official transcript, two letters of reference (at least one academic), required essays, professional headshot (300 dpi JPG), and documentation of financial need"
  },
  "1342": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "automotive-industry"
      ],
      "specialRequirements": "Must legally reside in the United States. Must desire to work in the automotive industry. Must provide official high school transcript. Application must be submitted to the NIADA Foundation for your specific region."
  },
  "1343": {
      "minGPA": 3.3,
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "biomedical-science",
          "behavioral-science",
          "social-science"
      ],
      "specialRequirements": "Must be enrolled or accepted as full-time undergraduate at accredited four-year college/university. Must rank in top 5% of class if GPA below 3.3. Includes 10-week summer internship at NIH and one year full-time work obligation post-graduation (may be deferred for advanced degree)."
  },
  "1344": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "energy engineering",
          "energy management",
          "environmental engineering",
          "sustainability"
      ],
      "specialRequirements": "Candidates from North Texas area and/or attending programs in North Texas area are advantaged. Student NTAEE members or students of NTAEE members receive added consideration. Applicants automatically considered for nomination to AEE Foundation Scholarship."
  },
  "1345": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "american-indian"
      ],
      "targetStates": [
          "montana"
      ],
      "requiredMajors": [
          "music"
      ],
      "specialRequirements": "Must be enrolled full-time at an accredited U.S. vocational, junior college, or four-year college/university. Applicants must be pursuing professional degrees in music."
  },
  "1346": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Oregon"
      ],
      "requiredActivities": [
          "community-service",
          "leadership"
      ],
      "specialRequirements": "Must plan to attend an Oregon trade school, college, or university. GED holders are eligible. Must demonstrate leadership and involvement in community activities. Must maintain full-time enrollment at an accredited Oregon institution for renewal. Must attend biannual mentorship gatherings. Renewable for four years with continued eligibility."
  },
  "1347": {
      "targetEthnicities": [
          "Latino"
      ],
      "specialRequirements": "Must identify as Latino. Must be enrolled or planning to enroll in a U.S. college or university for the upcoming academic year. Must demonstrate interest in pursuing a career in the actuarial profession. Named scholarship finalists must participate in an interview."
  },
  "1348": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Annual adjusted gross family income must be $65,500 or less. Residence in Illinois' Cook, DuPage, Kane, Lake, or Will counties for at least six months. Applicants must provide academic transcripts and income information for verification."
  },
  "1349": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a survivor of pediatric cancer. Must be enrolled full-time for the upcoming term. Must provide a note from treating doctor certifying treatment for pediatric cancer. Offered nationwide."
  },
  "1350": {
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must have experienced foster care at age 16 or older, or exited to adoption or legal custodianship after age 16; must be under age 26 by July 1 of the academic year; must be enrolled at least half-time at a Title IV eligible institution; must maintain satisfactory academic progress; must not be in default on federal student loans or owe repayment on Title IV aid; must have graduated high school or received a Commonwealth Secondary School Diploma; eligible for services under Pennsylvania's John H. Chafee Foster Care Program; maximum grant duration of 5 years (10 semesters or equivalent)"
  },
  "1351": {
      "requiresFAFSA": true,
      "requiresMilitaryConnection": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be age 25 or younger; Pennsylvania resident; child of public safety worker (police officer, firefighter, rescue/ambulance squad member, corrections facility employee, or National Guard member) who died in the line of duty after 1/1/1976, or died in the line of duty on 9/11/2001 (if National Guard member, sheriff, deputy sheriff, or on military duty); must be enrolled at a Pennsylvania public institution (private institutions ineligible); must complete FAFSA, Pennsylvania State Grant application, and PEGP Application; must provide certified birth certificate and letter of admission"
  },
  "1352": {
      "requiredMajors": [
          "packaging",
          "processing",
          "engineering",
          "food science",
          "mechatronics",
          "automation",
          "packaging design"
      ],
      "specialRequirements": "Must be enrolled in a two- or four-year institution in North America. Strong academic performance and leadership qualities are considered. Applicants connected to the industry through a PMMI member company may be eligible for specific scholarships. Special awards honor women leaders, industry trailblazers, and mentors."
  },
  "1353": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "Polish",
          "Polish-American"
      ],
      "targetStates": [
          "DC",
          "Maryland",
          "Virginia"
      ],
      "requiredActivities": [
          "Polish community involvement"
      ],
      "specialRequirements": "Must be full-time college student currently enrolled at accredited US institution with confirmed future attendance in summer/fall. Must be legal resident of DC, Maryland, or Virginia or full-time student at institution in these jurisdictions. Must demonstrate Polish or Polish-American descent with family tree. Green card permanent residents must have 10+ years residency and be seeking citizenship. Current high school seniors ineligible."
  },
  "1354": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Alabama",
          "Arkansas",
          "Florida",
          "Georgia",
          "Iowa",
          "Illinois",
          "Indiana",
          "Kentucky",
          "Louisiana",
          "Mississippi",
          "Missouri",
          "North Carolina",
          "South Carolina",
          "Tennessee",
          "Texas"
      ],
      "specialRequirements": "Age 16 or older; Must have at least 1 year (or 18 semester hours) remaining before college graduation; If not yet in college, must begin freshman year either the semester following application or the year after; Must be in good academic standing; Essay or video submission required (AI use prohibited); Written essay must be under 500 words; Video essay must be under 3 minutes and under 1 GB file size; No music in video submissions; Awards may not be applied to graduate school expenses; Previous winners of Regions Riding Forward Quarterly Contest are ineligible"
  },
  "1355": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "visual-art"
      ],
      "specialRequirements": "Must reside in Glenview attending any high school or be a student in District 225. Must submit two letters of recommendation (at least one from art teacher), digital portfolio with minimum 10 images, and proof of college acceptance as visual arts major by April 15. Application must be postmarked by March 30. May be required to interview with Scholarship Committee."
  },
  "1356": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "DC"
      ],
      "requiredMajors": [
          "architecture",
          "engineering",
          "environmental-science"
      ],
      "specialRequirements": "Must be enrolled full-time as an undergraduate at an accredited college or university. Must be of good character and demonstrate academic achievement. Preference given to students active in Washington DC Post or affiliated Student Chapters. Recipients are matched with mentors in their field of study."
  },
  "1357": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Chinese"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be at least one-quarter Chinese descent; must be graduating high school senior in San Diego County; must be attending college in the fall"
  },
  "1358": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "veterinary medicine",
          "biomedical sciences"
      ],
      "specialRequirements": "Undergraduates must have completed at least 2 years (60 semester hours or 90 quarter hours) of a 4-year pre-veterinary medicine or biomedical science curriculum and are expected to proceed to a D.V.M. program upon graduation. Graduate applicants must show proof of acceptance to an accredited veterinary school."
  },
  "1359": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresDisability": true,
      "specialRequirements": "Minimum 40dB bilateral hearing loss as evidenced on audiogram by SRT & PTA of 40dB or greater in both ears. Must be pursuing a bachelor's degree on a full-time basis at a college or university in the United States. Graduate degrees, associate degrees, community colleges, and vocational programs do not qualify. Funds may be used for tuition, books, supplies, and any semester including summer during the awarded academic school year."
  },
  "1360": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Minnesota",
          "Iowa"
      ],
      "specialRequirements": "Applicant must be natural, adopted, step-child or full dependent of a worker injured or killed in work-related accident during course and scope of employment with Minnesota or Iowa employer, entitled to benefits under Minnesota Workers' Compensation Act, Iowa Workers' Compensation Act or comparable work-related injury benefit program. Age 16-27. Must have high school diploma, GED, or be high school student in good standing. Pursuing bachelor's, associate's, or master's degree from accredited school, or vocational education/training (certificate or license)."
  },
  "1361": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Michigan"
      ],
      "requiredActivities": [
          "horse-community-involvement"
      ],
      "specialRequirements": "Must reside in Saginaw, Midland, or Bay Counties or within 35 miles of Saginaw Valley Equine Clinic facility. Must be pursuing higher education (college, trade school, etc.). Must submit cover letter with contact information and 250-500 word essay about involvement with horses and how it has influenced applicant's life."
  },
  "1362": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "environmental science",
          "environmental studies",
          "engineering",
          "solid waste management related fields"
      ],
      "specialRequirements": "Graduating student with minimum 20 credit hours or graduating GED student; resident of SWACO's District or attending accredited college/university within SWACO's District; must be accepted for enrollment at accredited community college, four-year college, or university. $2,500 awarded annually, renewable for up to four years with $10,000 maximum total. Application portal opens February 2nd."
  },
  "1363": {
      "minGPA": 3,
      "requiresDisability": true,
      "requiredActivities": [
          "collegiate athletics"
      ],
      "specialRequirements": "Must be living with type 1 diabetes; must be enrolled at an accredited NAIA or NCAA college or university; must play a sanctioned sport for their school; must demonstrate commitment to using sport as a platform to inspire others with diabetes; must attend an online Team Type 1 Global Ambassador Training; awards are renewable for up to four years"
  },
  "1364": {
      "minGPA": 2.5,
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must be blind or visually impaired. Must attend the scholarship ceremony held in summer to receive the award. Requires personal essay, financial statement of need, eye report form completed by medical professional, two letters of recommendation, and official transcripts."
  },
  "1365": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Carpentry",
          "Electrical",
          "HVAC",
          "Plumbing",
          "Construction Management"
      ],
      "specialRequirements": "Must plan to enroll or be enrolled in an approved trade-related program at an accredited two-year school in the U.S. GED equivalent holders eligible. Excludes employees and dependents of employees of The Home Depot. Multiple application deadlines: March 31, June 30, September 30, or December 31."
  },
  "1366": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "graduate"
      ],
      "specialRequirements": "Must be enrolled full-time at an accredited two- or four-year university, community college, junior college, or graduate degree program. Applicant or immediate family member/close friend must have battled or be currently fighting cancer. Required documents: unofficial transcript, proof of enrollment, recommendation letter, and list of honors and volunteer work."
  },
  "1367": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Washington"
      ],
      "requiredActivities": [
          "leadership",
          "community-involvement"
      ],
      "specialRequirements": "Must be a resident of Washington state, attending an NWCCU-accredited four-year college or university in Washington, enrolled full-time for the full academic year"
  },
  "1368": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredActivities": [
          "community-service",
          "environmental-action"
      ],
      "specialRequirements": "Must be 13 to 25 years old. Must host a Street Sweep or complete the Ripple Effect campaign. Must create and share a PSA promoting safe trash disposal in community."
  },
  "1369": {
      "targetStates": [
          "Rhode Island"
      ],
      "specialRequirements": "Must be attending school in Rhode Island. Not a previous recipient of the award. Merit-based only with no consideration to financial need. Individual submissions only (no groups). Pitch must be in video (under 3 minutes), essay (under 1,000 words), or multimedia format. Winning entries must establish new solutions for aiding underserved Rhode Island communities, not donations or investments to existing organizations."
  },
  "1370": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be a resident of the City of Tukwila (proof of residency required). Must demonstrate leadership qualities through involvement in extracurricular activities. Must have completed a minimum of 15 hours of community service. Must have applied to an undergraduate program at a community college, trade school, or university."
  },
  "1371": {
      "requiredMajors": [
          "Selected Major(s)"
      ],
      "specialRequirements": "Current Year in School and Age criteria apply (specific details not provided on page)"
  },
  "1372": {
      "requiredMajors": [
          "Selected Major(s) - specific majors not detailed on page"
      ],
      "specialRequirements": "Current Year in School specified as eligibility criterion but specific year not detailed on page"
  },
  "1373": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "specialRequirements": "AI-written essays are not permitted and will result in disqualification. Previous first-place winners are ineligible for the following year's award. Non-student applicants cannot be first place winners two years in a row. Two separate award categories: National Metric Scholarship Award (high school seniors) and National Metric Award (non-student U.S. residents). Winners and top finalists receive free USMA membership for one year."
  },
  "1374": {
      "targetGradeLevels": [
          "graduate"
      ],
      "specialRequirements": "Must have an interest in AI, cybersecurity, and threat detection. Must demonstrate passion for cybersecurity research and innovation. Must exhibit strong problem-solving skills and desire to advance AI-driven security solutions."
  },
  "1375": {
      "minGPA": 2,
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetStates": [
          "New Jersey"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Applicant must be at least 25 years old; resident of West Essex area (Caldwell, West Caldwell, North Caldwell, Essex Fells, Fairfield, Roseland); pursuing non-traditional education path; enrolled or will be enrolled in degree-granting program at accredited college/university; must provide official transcript and one letter of recommendation (not from relatives, must include contact information)"
  },
  "1376": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Maryland"
      ],
      "requiredMajors": [
          "Education"
      ],
      "specialRequirements": "Must be graduating from or have graduated from Washington County Maryland Public Schools under the Washington County Board of Education. Must be aspiring to become a teacher. Must submit college letter of admission, completed cover sheet, letter explaining eligibility (including leadership roles and community involvement), valid transcript, and two letters of recommendation from non-related persons. Must be available for interview if selected as finalist."
  },
  "1377": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresPellGrant": true,
      "targetStates": [
          "Missouri"
      ],
      "specialRequirements": "Must reside within the 1st Congressional District of Missouri and maintain residency while receiving the award. Must plan to enroll full-time (minimum 12 credit hours). Must provide three letters of recommendation from counselor, advisor, teacher, principal, or others familiar with character and academic ability. Must be available for personal interview with Scholarship Review Committee."
  },
  "1378": {
      "targetGradeLevels": [
          "college-freshman"
      ],
      "requiresDisability": true,
      "requiredActivities": [
          "tennis"
      ],
      "specialRequirements": "Must be affected by diabetes, must have excelled in academics and tennis, must display leadership and community involvement, must be entering a four-year college or university program"
  },
  "1379": {
      "targetGradeLevels": [
          "high-school-sophomore",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "New Jersey"
      ],
      "specialRequirements": "Official residence in Morris County, New Jersey required. Must have completed sophomore year at an accredited college or university, or be matriculated in a Master's program by June of the year the scholarship is awarded. At least one scholarship reserved for a mature woman returning to college to complete her degree."
  },
  "1380": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "specialRequirements": "Must be a current high school senior; must be attending a U.S. college/university in the fall following graduation; must live in the United States; must have been impacted by Alzheimer's disease or dementia-related illness; applications open in November"
  },
  "1381": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Afghan-American"
      ],
      "specialRequirements": "Must be enrolled or plan to be enrolled during the upcoming academic year pursuing any level of degree. Must submit: proof of enrollment, transcript, financial aid award letter, detailed resume, and essay responses detailing academic and career goals and demonstrating commitment to empowering the Afghan-American community."
  },
  "1382": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "requiresFAFSA": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "communications",
          "marketing",
          "advertising"
      ],
      "specialRequirements": "Must reside in Allegheny, Armstrong, Beaver, Butler, Fayette, Indiana, Lawrence, Mercer, Washington, or Westmoreland County in Pennsylvania. Must be attending a 4-year college/university as junior/senior or 2-year college/technical/trade school in final year. Applicants should demonstrate academic interest or creative talent in advertising, art, business, communications, graphic design, marketing, public relations, or writing."
  },
  "1383": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "atmospheric science",
          "oceanic science",
          "hydrologic science"
      ],
      "specialRequirements": "Must be enrolled full-time in an accredited U.S. institution. Must be entering final undergraduate year in the upcoming fall semester. Financial need required for Schroeder scholarship if sponsored that year."
  },
  "1384": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Arkansas"
      ],
      "requiredMajors": [
          "music - choral performance",
          "music - vocal performance"
      ],
      "requiredActivities": [
          "choral music program enrollment at high school"
      ],
      "specialRequirements": "Must attend audition and interview at St. James United Methodist Church. Must perform two contrasting selections from classical genre. Must be graduating senior from public or private high school in Arkansas. Must enroll at accredited Arkansas four-year institution. High school transcript required to document GPA. Scholarship paid upon verification of college enrollment."
  },
  "1385": {
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "natural resources",
          "environmental sciences"
      ],
      "specialRequirements": "Must be pursuing higher education in natural resources and environmental sciences (including natural resources management, natural resources law enforcement, and natural resources aviation). Selection based on achievement, extracurricular activities, community involvement, leadership service and legacy."
  },
  "1386": {
      "targetStates": [
          "Oregon",
          "Washington"
      ],
      "specialRequirements": "Must be pursuing post-secondary undergraduate education at an accredited institution during the coming school year. Must be lesbian, gay, bisexual, transgender, Queer, Intersex, or have an LGBTQI parent. Must have been a resident for at least one year in the State of Oregon or in Clark, Cowlitz, Skamania, or Wahkiakum Counties in Washington."
  },
  "1387": {
      "minGPA": 2.5,
      "targetStates": [
          "Minnesota"
      ],
      "requiredActivities": [
          "community service",
          "volunteer experience"
      ],
      "specialRequirements": "Must be enrolled at a Minnesota State college or university for at least one semester prior to applying"
  },
  "1388": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Indiana"
      ],
      "requiredMajors": [
          "theatre",
          "performing arts"
      ],
      "requiredActivities": [
          "theatre participation",
          "performing arts participation"
      ],
      "specialRequirements": "Must be a senior at a Hamilton County Indiana High School. Must have participated in theatre and/or performing arts while in high school. Must demonstrate scholastic achievement, character, and leadership. Required application materials: transcripts, letters of recommendation, high-resolution headshot photo, and letter to scholarship committee describing reasons for applying."
  },
  "1389": {
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredActivities": [
          "community service"
      ],
      "specialRequirements": "Must be at least 18 years old. Must reside in Cook, DuPage, Will, Lake, McHenry or Kane counties in Illinois. Must have visual impairment. Required documents: completed application, transcript, state ID, two recommendation letters, autobiographical essay, and recent eye report."
  },
  "1390": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "specialRequirements": "Must be accepted by a four-year college; must submit FAFSA Expected Family Contribution Report; must obtain letter of recommendation from school counselor stating applicant meets requirements, has financial need, possesses leadership qualities, and has attainable goals; school counselor must mail complete transcript with SAT/ACT test scores and letter of recommendation to scholarship chairperson; applicant cannot be a child of a Bedford BPW member"
  },
  "1391": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "North Carolina"
      ],
      "specialRequirements": "Must intend to enroll at a four-year college or university located in North Carolina. Must complete and submit official scholarship application and meet all additional requirements outlined in scholarship guidelines."
  },
  "1392": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "South Carolina"
      ],
      "requiredMajors": [
          "engineering",
          "technology"
      ],
      "specialRequirements": "Must be from the Lowcountry region. Applicant consents to use of photos/images for media publication and recognition on scholarship web page and/or social media."
  },
  "1393": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "NJ"
      ],
      "requiredActivities": [
          "LGBTQIA+ advocacy"
      ],
      "specialRequirements": "Must demonstrate advocacy for LGBTQIA+ issues. Must have personal experience with mental health challenges or through someone close to them. Volunteer or work experience in mental health or LGBTQIA+ organizations is preferred but not required. Application requires cover letter and 1-2 page essay or 2-4 minute video. Submit via email to CharlieSchulzFund@gmail.com. Two awards available annually."
  },
  "1394": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "engineering"
      ],
      "specialRequirements": "Must be a graduating high school senior within the city of Chicago. Must be accepted to an ABET accredited, 4-year undergraduate engineering program. Renewable awards contingent on meeting annual eligibility requirements."
  },
  "1395": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "Must be graduating from a Chicago Public or Charter school; must be enrolled full-time in a four-year degree program at a U.S. accredited nonprofit college or university; household income must not exceed $75,000; participation in CASL programs is considered but not required"
  },
  "1396": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "aviation-management"
      ],
      "specialRequirements": "Scholarship monies must be used for tuition, books, and/or tools only. Cannot be used for flight training or air traffic control programs."
  },
  "1397": {
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "specialRequirements": "Academic excellence required for merit-based aid; 300-word essay required for merit-based aid; Some awards available to siblings of CIEE alumni; More eligibility criteria vary widely based on specific award"
  },
  "1398": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "STEM",
          "education",
          "healthcare",
          "business",
          "fire science"
      ],
      "specialRequirements": "Must be Illinois resident of Boone, Ogle, Stephenson, or Winnebago County. Academic achievements considered (GPA, class rank, standardized test scores). Opportunities available for non-traditional students with high school diploma or GED. Three application cycles with different deadlines and timelines."
  },
  "1399": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Jersey"
      ],
      "requiredActivities": [
          "arts"
      ],
      "specialRequirements": "Must be a Monmouth County high school senior graduating in the current academic school year and continuing education after graduation. Must have experience with any art form (acting, photography, dance, vocals, music, graphic design, filmmaking, etc.) at any level of study. Award recipients notified by beginning of May. Documentation required to support submitted data."
  },
  "1400": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Accounting"
      ],
      "specialRequirements": "GPA, Current Year in School, and Citizenship are listed as eligibility criteria but specific requirements are not detailed. Multiple awards available with varying criteria."
  },
  "1401": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFAFSA": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must attend a Crawford County, Pennsylvania high school. Must submit Federal Student Aid Report. Application requires scholastic honors, extracurricular activities, transcript, work history, and personal essay."
  },
  "1402": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "avionics",
          "aircraft-maintenance"
      ],
      "specialRequirements": "Must attend or plan to attend accredited avionics or aircraft maintenance program. Funds cannot be used for flight training or air traffic control programs."
  },
  "1403": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Colorado"
      ],
      "specialRequirements": "Must be from Weld County or Brighton, OR from Adams, Arapahoe, Boulder, Broomfield, Denver, Douglas, Elbert, Jefferson, Larimer, Logan, Morgan, Phillips, Sedgwick, Washington, or Yuma counties with a parent working in the DJ Basin. Must be accepted to an accredited post-secondary institution. Application must be postmarked by April 1 (no email submissions). Required documents: applicant letter, one letter of recommendation, resume, and two-page typewritten essay titled 'How the Oil and Gas Industry Impacts My Life'."
  },
  "1404": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "legal-field"
      ],
      "specialRequirements": "Must be legal resident of California and legal US resident. Must be attending school within California during scholarship year. Must be enrolled in a program of no less than six months in duration. Not for students planning to enter law school."
  },
  "1405": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be resident of one of the listed PA counties. Eligibility and criteria vary by specific scholarship within the program. Scholarships awarded based on pre-determined criteria reflective of personal values and interests of fund donors."
  },
  "1406": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "requiredMajors": [
          "Chemistry",
          "Biology",
          "Natural Sciences"
      ],
      "specialRequirements": "Must be enrolled as at least a ½ time student (6 semester hours) with intent to seek a career in Forensic Sciences. Cannot be related to SWAFS Board Members and/or Scholarship/Grant Committee Members."
  },
  "1407": {
      "targetGradeLevels": [
          "high-school-freshman",
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "noEssayRequired": true,
      "targetStates": [
          "Maine"
      ],
      "requiredActivities": [
          "music-performance"
      ],
      "specialRequirements": "Must be a musician in grades 9-12 as of January 1st. Primary residence must be in Maine. Cannot be awarded to children of active FOKO board members or employees. Previous year winners are not eligible but may apply in alternating years. Requires video audition (no more than 10 minutes, recorded within 12 months of deadline) and live performance audition before a panel of judges. Must submit 2-3 musical selections in varying styles with PDF scores."
  },
  "1408": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a current high school senior or active student at an accredited higher learning institution. Must submit either a video (less than 5 minutes) or typewritten essay (not to exceed 2 pages, 12 pt, single-spaced) discussing efforts to combat bullying or personal experience with bullying. Must provide two written recommendations: one from school faculty/staff/administration and either one from an educator or one from a peer. Previous recipients may reapply if eligibility criteria continue to be met."
  },
  "1409": {
      "minGPA": 2.5,
      "citizenshipRequired": [
          "us-citizen",
          "daca"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Louisiana"
      ],
      "specialRequirements": "Must be a teen parent (pregnant/expecting by age 19) and 25 or younger at time of application; must be attending or planning to attend college in Greater New Orleans for Fall semester; must be seeking an associates or bachelors degree; must submit Student Aid Report (SAR), proof of FAFSA submission, or DACA supplement; renewable with minimum 6 credits per semester"
  },
  "1410": {
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "targetStates": [
          "North Dakota"
      ],
      "specialRequirements": "Must be from a North Dakota farm family. First priority for students from Burke County, North Dakota."
  },
  "1411": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Rhode Island"
      ],
      "specialRequirements": "Must be a woman aged 20 or older at time of application with a high school diploma or GED. Must be a resident of Washington County, Rhode Island. Must be enrolled in or accepted into a career/vocational training program, certificate program, or first degree program (associate or bachelor's). Must demonstrate motivation to achieve educational and career goals."
  },
  "1412": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "Visual and Performing Arts"
      ],
      "specialRequirements": "Must attend a public high school in Dallas, Collin, or Denton counties. Applicants evaluated based on school and community involvement, leadership potential, artistic dedication, and financial need. Requires two letters of recommendation and essay outlining artistic aspirations and career goals."
  },
  "1413": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "daca"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "teaching"
      ],
      "specialRequirements": "Must attend a partner university; must obtain Illinois teaching certification; must teach for at least 5 years in an approved Illinois school within 7 years of college graduation; must comply with ISAC program requirements and code of conduct"
  },
  "1414": {
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "targetStates": [
          "Idaho"
      ],
      "specialRequirements": "Must be hearing impaired, reside in Ada County, Idaho, and be accepted into a four-year college or technical school program. Selection based on scholastic ability, leadership ability, and extracurricular activities (arts, athletics, journalism, school or community service)."
  },
  "1415": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "Engineering",
          "Math",
          "Physical Sciences",
          "Biological Sciences"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be entering sophomore, junior, or senior year at a 4-year accredited college. Cannot already hold a bachelor's degree. Must submit 500-1,000 word essay on one of six provided Heinlein-related topics. One scholarship (Virginia Heinlein Memorial) reserved for female candidates; three scholarships open to any gender."
  },
  "1416": {
      "targetGradeLevels": [
          "high-school-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Iowa"
      ],
      "specialRequirements": "Must be a junior in an Iowa high school or homeschooled program in the upcoming spring with a high school graduating date the following year. Must be motivated and community-minded. Children or grandchildren of staff members or trustees of the Hoover Presidential Foundation, Hoover Presidential Library and Museum, or National Historic Site are ineligible. Grades, test scores, essays, and financial need are not evaluated."
  },
  "1417": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "African American"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "accounting"
      ],
      "specialRequirements": "Must be enrolled in an Illinois college or university; must plan to sit for the CPA exam in Illinois within three years of application date; must demonstrate progress in a course of study in accounting"
  },
  "1418": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredActivities": [
          "volunteer-commitment"
      ],
      "specialRequirements": "Must plan to enroll full-time in a two or four year degree program at a U.S. college or university. Volunteer commitment preferred in fishing or conservation. Must submit five paragraph essay responding to fishing and outdoors prompt. Must obtain at least one letter of recommendation from current teacher, coach, or administrator. Must provide unofficial transcript and written acceptance from chosen college or university."
  },
  "1419": {
      "minGPA": 3,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Accounting"
      ],
      "specialRequirements": "Must be enrolled in an Illinois college or university. Must plan to sit for the CPA exam in Illinois within three years of the application date. Must demonstrate progress in accounting courses."
  },
  "1420": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "Jewish Studies"
      ],
      "specialRequirements": "Must be a graduating high school senior accepted to post-secondary education; must be actively engaged in post B'nai Mitzvah formal Jewish learning; must demonstrate commitment to continuing Jewish studies at collegiate or university level; religious affiliation and state/county selection criteria apply"
  },
  "1421": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "specialRequirements": "Must be a high school senior who will attend a four-year university starting in the fall. Must have a signed letter from an accredited sleep specialist or neurologist with confirmed narcolepsy diagnosis."
  },
  "1422": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Jersey"
      ],
      "requiredActivities": [
          "extracurricular-activity"
      ],
      "specialRequirements": "Must have worked an average of 30 hours per week during summers since age 16 (paid positions only). Must actively participate in at least one extracurricular activity. Must enroll full-time in an accredited U.S. institution. To continue receiving annual disbursement, must maintain proof of employment (30+ hours/week during summer) and submit yearly grade transcript while maintaining full-time enrollment with minimum 2.5 GPA."
  },
  "1423": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "music"
      ],
      "specialRequirements": "Must be a resident of Tri-County area (Bristol, Plymouth, Barnstable counties in Massachusetts). College applicants must submit: letter of introduction (max 250 words), resume, three letters of reference, and college acceptance letter (or list of applications with attendance plans). High school students applying for summer grants must demonstrate interest in advanced musical training. Previous applicants/recipients may reapply. Awards made following successful completion of fall semester of musical studies."
  },
  "1424": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "nursing"
      ],
      "specialRequirements": "Permanent address in area served by Blanchard Valley Health System; enrolled in coursework for academic credit counting toward nursing degree; must exhibit good moral character; renewable annually upon application receipt"
  },
  "1425": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be graduate of private/public high school or accredited home/cyber school. Must reside in Clinton, Columbia, Lycoming, Montour, Northumberland, Tioga, Snyder, Sullivan, or Union County, PA. Must be accepted or enrolled in full-time accredited undergraduate degree program or accredited technical/trade school. Preference for careers in aviation (A&P mechanic, avionics technician, pilot training, air traffic controller, or aeronautical engineer). Must demonstrate well-rounded character and work ethic through school/community participation."
  },
  "1426": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "college-senior"
      ],
      "targetStates": [
          "Nevada"
      ],
      "requiredMajors": [
          "elementary-education",
          "secondary-education"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be entering senior year at an eligible Nevada institution (University of Nevada, Reno; University of Nevada Las Vegas; Great Basin College; Nevada State College; Western Governor's University; or Touro University). Must have declared major in elementary or secondary education. Must be committed to teaching in Nevada upon graduation. Must have record of community service."
  },
  "1427": {
      "minGPA": 3.3,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "New Jersey"
      ],
      "requiredMajors": [
          "environmental science",
          "natural resource management",
          "conservation",
          "park administration"
      ],
      "specialRequirements": "Must be New Jersey resident; must have completed at least 15 undergraduate credits; must be currently enrolled in an accredited college or university (not necessarily in New Jersey)"
  },
  "1428": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must attend school in or reside in Laurel/Jones County (public, private, or homeschool programs). Must submit original art portfolio demonstrating artistic ability. Must obtain letters of recommendation. All submitted work must be original in both concept and creation."
  },
  "1429": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Alabama",
          "Florida",
          "Georgia",
          "Louisiana",
          "Mississippi",
          "North Carolina",
          "South Carolina",
          "Tennessee",
          "Virginia"
      ],
      "requiredMajors": [
          "health-related fields",
          "medicine",
          "nursing",
          "allied health"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a Christian woman. Must be enrolled at one of the participating accredited institutions (200+ institutions). Contact your educational institution to verify participation and follow their application guidelines."
  },
  "1430": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Utah"
      ],
      "requiredMajors": [
          "medical field"
      ],
      "specialRequirements": "Must be accepted into a post-secondary institution (college, university, technical or vocational school). Must complete the Livelikemak Scholarship application and submit a personal essay."
  },
  "1431": {
      "targetEthnicities": [
          "African American"
      ],
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Primary residence in underserved communities within Chicagoland area. Applicants must be seeking to obtain a real estate license or attend an HBCU. Applications must be submitted before completion of the relevant course. Excludes Chicago Association of REALTORS® Officers, Directors, employees, and Foundation Officers and Trustees. For real estate license applicants: must meet current minimum Illinois licensing standards and be enrolled in a REALTORS® Real Estate School (RRES) pre-licensing program (classroom or self-study)."
  },
  "1432": {
      "minGPA": 3.25,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "radio",
          "television",
          "film",
          "public relations",
          "advertising",
          "communications",
          "broadcasting"
      ],
      "specialRequirements": "Must have at least one full-time semester remaining. Must have completed 75 hours of coursework. Attending Texas public or private university OR from Greater Houston Area. Must submit resume, official transcript, two faculty recommendation letters, and personal statement (either 250-word essay on future of media industry or 30-second video explaining choice of media major)."
  },
  "1433": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Michigan"
      ],
      "requiredMajors": [
          "health care fields"
      ],
      "specialRequirements": "Must be accepted into an accredited health career program. Must be a resident or have immediate family living in mid-Michigan counties. Selection based on merit and established criteria determined by overseer committee."
  },
  "1434": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredActivities": [
          "music-performance"
      ],
      "specialRequirements": "Instrumentalists: Must be age 16+ or graduating high school senior, and under age 24 at final audition. Vocalists: Must be age 18+ or graduating high school senior, and under age 32 at final audition. Must be resident of San Diego County, Imperial County, or Baja California del Norte for minimum one year at time of preliminary audition, OR full-time registered student (12+ semester units) in college/university in above geographic area since preceding September. Competition includes auditions in strings, keyboard, winds, brass, and voice."
  },
  "1435": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Connecticut",
          "Maine",
          "Massachusetts",
          "New Hampshire",
          "Rhode Island",
          "Vermont"
      ],
      "requiredMajors": [
          "Human Resources",
          "Employee Benefits",
          "Total Rewards"
      ],
      "specialRequirements": "Must be currently enrolled part-time or full-time in an accredited New England public or private college or university; must have completed at least one semester of college as of April 1; interest in Human Resources, Employee Benefits, and/or Total Rewards may encompass compensation, underwriting, consulting, retirement planning through course of study and/or work experience"
  },
  "1436": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "forestry",
          "forestry-related-sciences"
      ],
      "specialRequirements": "Must be planning to enroll in or currently enrolled in a forestry or related science program at the post-secondary level. Proof of acceptance into a relevant post-secondary program required."
  },
  "1437": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "law-enforcement"
      ],
      "specialRequirements": "Must submit OSSA Scholarship Application Form, original essay (max 3 pages) on 'What challenges do you see in the field of law enforcement, and what are your views on meeting these challenges?', SAT/ACT scores (if required by school), high school or college transcripts, and Letter of Acceptance to community college or four-year institution (high school seniors only). Finalists may be interviewed by Scholarship Committee."
  },
  "1438": {
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "students of color"
      ],
      "targetStates": [
          "Minnesota"
      ],
      "requiredActivities": [
          "volunteer tutoring"
      ],
      "specialRequirements": "Must be enrolled full-time at an accredited post-secondary institution in Minnesota in the upcoming academic year. Must maintain full-time status throughout the academic year. Must be willing to complete a minimum of 50 volunteer hours tutoring children in grades K-8th per academic year. Age requirement: 18-35 years old."
  },
  "1439": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Texas"
      ],
      "specialRequirements": "Parent or guardian must be a certified peace officer or detention officer in Texas at time of application or at time of parent's death. Applicant must be a full-time student enrolled with minimum 12 college credit hours or applied to be full-time. Attendance must be at accredited junior college, community college, or four-year college/university. CLEAT membership not required."
  },
  "1440": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresDisability": true,
      "targetStates": [
          "Maine"
      ],
      "specialRequirements": "Must have documented disability as defined by WHO; must be current or former high school student from Maine; must have B average GPA or equivalent; must have received acceptance to post-secondary institution; open to individuals of any age; essay required (500-1000 words); letter of recommendation required; unofficial high school transcript required"
  },
  "1441": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Greek heritage"
      ],
      "specialRequirements": "Must be of Greek heritage or actively involved with the Eastern Orthodox faith. Must be enrolled or enrolling in an accredited post-secondary institution for the fall of the year the scholarship is awarded. Must demonstrate financial need through household income, single parent household status, student loan debt, significant medical expenses, or other extenuating circumstances."
  },
  "1442": {
      "targetStates": [
          "Massachusetts",
          "Connecticut"
      ],
      "requiredMajors": [
          "occupational therapy",
          "physical therapy",
          "adaptive technology"
      ],
      "specialRequirements": "Must be enrolled in a degree or certificate program in occupational therapy, physical therapy, adaptive technology, or similar field. Applicants from Massachusetts or Connecticut given preference."
  },
  "1443": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Maine"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be entering first year of post-secondary education. Must be enrolled in or planning to enroll in an accredited two-year or four-year degree-granting college or university. Must maintain 2.5 GPA once enrolled."
  },
  "1444": {
      "minGPA": 2.5,
      "requiresFinancialNeed": true,
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "precision machining",
          "manufacturing processes"
      ],
      "specialRequirements": "Must attend NCSC (North Central State College). Must reside in Richland County. Previous scholarship recipients must maintain minimum 2.0 GPA. Scholarship available for up to 18 months. Must attend accredited school on part- or full-time basis."
  },
  "1445": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "targetStates": [
          "Ohio"
      ],
      "specialRequirements": "Visual impairment/handicap that adversely affects educational performance. Previous scholarship recipients must maintain minimum 2.0 GPA. Priority given to Mansfield City Schools visually impaired program graduates."
  },
  "1446": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Ohio"
      ],
      "specialRequirements": "Must maintain primary residency in Richland County, Ohio. Must attend accredited college or university on full-time basis. Returning students must maintain minimum 2.0 GPA."
  },
  "1447": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "communications",
          "graphic design",
          "journalism",
          "marketing",
          "public relations"
      ],
      "specialRequirements": "Must be member of a historically underrepresented group. Must be graduating high school senior planning to enroll or current undergraduate at a four-year college. Partnership with Leadership Greater Washington."
  },
  "1448": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be graduating senior from public or private high school; must plan to attend two-year or four-year college, vocational, or technical school in the U.S.; must submit 60-90 second video explaining how you've been a cancer fighter and what you've learned, including the phrase 'Peace out, cancer' at the end; video must be in .mov, .mp4, .mpg, .mpeg, .avi, or .mwv format and no more than 50 MB; must complete online application with contact information, high school details, GPA, college plans, and extracurricular activities"
  },
  "1449": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "targetStates": [
          "Washington"
      ],
      "specialRequirements": "Must be a descendant of a person establishing residence in: Washington State during or prior to 1870, Oregon State during or prior to 1853, Idaho State during or prior to 1863, or Montana State (west of Rocky Mountains crest) during or prior to 1863. Must be a resident of Washington State. Must be a full-time student in an accredited college or university in Washington State. Preference given to students majoring in history, education, or English."
  },
  "1450": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "specialRequirements": "Must submit completed application form, Student Aid Report from FAFSA, typed composition (up to 500 words) describing creative vision and impact on world, unofficial SAT/ACT scores, unofficial academic transcript, and three letters of recommendation (one from school official, one from church or community acquaintance, one from either source). Must enroll in an accredited institution or award may be rescinded."
  },
  "1451": {
      "targetStates": [
          "New York",
          "New Jersey",
          "Florida",
          "Georgia"
      ],
      "specialRequirements": "Must have had a cancer diagnosis prior to age 21. Must be enrolled or planning to enroll full-time in an accredited college or university. Must be a permanent resident of New York City, select counties in New Jersey, select counties of North Florida, or select counties of South Georgia."
  },
  "1452": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "targetStates": [
          "California",
          "Arizona",
          "Colorado",
          "Nevada",
          "Oregon",
          "Washington"
      ],
      "specialRequirements": "Must have Tourette's syndrome. Must be qualified for admission to an accredited college (junior college or four-year college) or trade school at mid-term or end of current school year. Open to gap year students after high school."
  },
  "1453": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "civil engineering",
          "operational business (TxDOT-approved)"
      ],
      "specialRequirements": "Must be economically disadvantaged per Federal Poverty Guidelines; Texas resident; minimum SAT score of 900 or ACT score of 21; plan to attend accredited four-year Texas public or private institution as full-time student; agree to work at TxDOT for two years immediately following graduation; not more than 30 days delinquent in child support obligations"
  },
  "1454": {
      "minGPA": 2.7,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "us"
      ],
      "requiredMajors": [
          "Engineering",
          "Mathematics",
          "Science"
      ],
      "specialRequirements": "Must be a current full-time undergraduate at a two-year community college in the United States, planning to transfer to full-time enrollment at an accredited four-year college or university for the next academic year. Must be pursuing a Bachelor of Science degree in Engineering, Mathematics, or Science (excluding agriculture, health, or other life sciences). Students who have received two Western Digital Scholarships in the past are ineligible."
  },
  "1455": {
      "targetGradeLevels": [
          "graduate"
      ],
      "specialRequirements": "Must be an active, full member of The United Methodist Church, African Methodist Episcopal Church, AME Zion Church, or Christian Methodist Episcopal Church for at least one year prior to applying. Must be a non-doctoral student. Preference given to students enrolled or planning to enroll full-time at regionally accredited United Methodist-related college, university, or seminary in the United States. Students may receive only one UMHEF scholarship per year."
  },
  "1456": {
      "requiresMilitaryConnection": true,
      "specialRequirements": "Applicant must be the grandchild of a deceased Chief Petty Officer (E7, E8, E9) of the US Navy or Coast Guard. Must be attending or have been accepted to an accredited two or four-year college, university, or vocational/trade school. Intended for undergraduate degree programs or vocational/trade credentials only. Must provide documented proof of relationship to deceased grandparent and proof of grandparent's service and rank."
  },
  "1457": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Occupational Therapy",
          "Physical Therapy",
          "Speech Therapy",
          "Recreational Therapy",
          "Social Work",
          "Psychology"
      ],
      "specialRequirements": "Applicants must be pursuing junior college, undergraduate, or graduate degrees (or job training for Katie MacDonald Memorial). Three separate scholarships with specific criteria: (1) Katie MacDonald - individual with Down syndrome or pursuing education/job training; (2) Sibling Scholarship - sibling of individual with Down syndrome; (3) Tiffany Diamond - pursuing degree in therapeutic field."
  },
  "1458": {
      "requiresMilitaryConnection": true,
      "targetStates": [
          "Virginia"
      ],
      "specialRequirements": "Applicant must be spouse or child of qualifying veteran or service member. Veteran must be rated by USDVA as totally and permanently disabled or at least 90% permanently disabled due to military service, OR be killed in action, missing in action, taken prisoner, or disabled as a result of covered military combat. Service must include duty in U.S. Armed Forces, Armed Forces Reserves, or Virginia National Guard. Must meet Virginia residency requirements."
  },
  "1459": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Virginia",
          "Maryland",
          "Delaware"
      ],
      "specialRequirements": "Applicant's primary residence must receive electric power from one of the 15 member electric cooperatives served by VMDAEC. Must be a high school or home-school senior entering first semester at college or technical/trade school in the fall. Proof of admission required if selected."
  },
  "1460": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "structural pest management"
      ],
      "specialRequirements": "Must be enrolled full-time at a Virginia college or university at time of award. High school seniors may apply but must be enrolled in a Virginia institution to receive the scholarship. Must be pursuing a program with technical focus on structural pest control. Requires one-page double-spaced essay and two letters of recommendation from faculty or industry professionals."
  },
  "1461": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be currently enrolled at an accredited U.S. university or college (full-time or part-time). Must identify as female. Applicants must be undergraduate juniors or seniors or enrolled in graduate studies. Offered twice per year with deadlines of April 1st and November 1st."
  },
  "1462": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must be graduating high school senior from Illinois high school. Must submit official high school transcripts (grades 9-present) and SAT or ACT scores if available. Must attend award ceremony on April 26th if selected. Digital photo required for press release if awarded."
  },
  "1463": {
      "targetStates": [
          "Wisconsin"
      ],
      "requiredMajors": [
          "Culinary",
          "Baking",
          "Hospitality",
          "Food Science",
          "Family and Consumer Science Education"
      ],
      "specialRequirements": "Must be Wisconsin resident, enrolled in at least 6 credits, must submit school transcripts and employer or instructor recommendations"
  },
  "1464": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Ohio",
          "Pennsylvania"
      ],
      "requiredMajors": [
          "journalism",
          "public relations",
          "marketing",
          "broadcasting",
          "communications"
      ],
      "specialRequirements": "Must live in one of the following counties: Mahoning, Trumbull, or Columbiana in Ohio, or Mercer or Lawrence in Pennsylvania (applicants may be enrolled in schools outside these counties). Must submit minimum of two writing or broadcast samples. Should provide examples of community involvement. Must submit proof of GPA."
  },
  "1465": {
      "minGPA": 3,
      "requiresFinancialNeed": true,
      "targetStates": [
          "Montana"
      ],
      "specialRequirements": "Must be enrolled in a degree program at an accredited 2-year or 4-year college or university. Must not have previously received the Salute to Student Scholarship. YWCA Billings Board Members, staff members, and their family members are not eligible. Scholarship is non-renewable. Recipients must be enrolled in the fall."
  },
  "1466": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "pre-medicine"
      ],
      "specialRequirements": "Must reside in Alameda, Contra Costa, San Mateo, Santa Clara, or Santa Cruz counties. Must plan to attend a four-year college and anticipate a career as a medical doctor. Must submit a 1,000-word personal statement detailing interest in medicine, background, life experiences, and financial need."
  },
  "1467": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "architecture",
          "construction",
          "building sciences",
          "engineering"
      ],
      "specialRequirements": "Must be current undergraduate or graduate student who has completed minimum 24 credit hours; must plan to enroll full-time at accredited college, university, or vocational-technical school for entire academic year in accredited program leading to career in construction or building envelope industry. Non-renewable but recipients may re-apply up to four times in four years if eligible."
  },
  "1468": {
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "engineering",
          "architecture",
          "construction sciences"
      ],
      "specialRequirements": "RCI-IIBEC Foundation employees and their family members are not eligible. Undergraduate study only."
  },
  "1469": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "engineering",
          "mathematics",
          "physical sciences"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be graduating from a Pittsburgh area school in the spring of the award year. Must intend to pursue a bachelor's degree at an accredited college or university."
  },
  "1470": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "specialRequirements": "Must plan to attend a nonprofit or public education institute, or a nonprofit technical school, part- or full-time. Must include up to two references from teachers and/or counselors. Disability must be language learning, reading disability, learning barrier or related disability."
  },
  "1471": {
      "minGPA": 3.8,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Mexico"
      ],
      "requiredMajors": [
          "science",
          "math"
      ],
      "specialRequirements": "Must be graduating senior from Albuquerque metro area (Bernalillo, Sandoval, Valencia, or Torrance Counties). Must plan to enroll full-time at college/university. Must have strong math and/or science credentials. Must submit personal statement outlining career goals and letter of reference indicating good standing and community service. 2-3 scholarships awarded. Scholarships payable over four years."
  },
  "1472": {
      "targetGradeLevels": [
          "high-school-freshman",
          "high-school-sophomore",
          "high-school-junior"
      ],
      "specialRequirements": "Must demonstrate leadership potential. Program held in Hobart, Oklahoma, July 19-24. No cost for selected students; airfare provided."
  },
  "1473": {
      "requiredMajors": [
          "nursing",
          "nutrition",
          "healthcare technology",
          "radiologic technology",
          "healthcare and wellness"
      ],
      "specialRequirements": "State selection and county selection required (Hancock County). Current year in school and age are selection criteria. Specific scholarships include: Edith Zike Nursing Scholarship, John F. Strickford Nursing Scholarship, Jill Carr Memorial Scholarship, School of Radiologic Technology Scholarship, and Healthcare and Wellness Scholarship. Dollar amounts and deadlines vary by individual scholarship."
  },
  "1474": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Greek"
      ],
      "targetStates": [
          "Delaware",
          "New Jersey",
          "Pennsylvania"
      ],
      "requiredMajors": [
          "Greek Studies"
      ],
      "specialRequirements": "Applicants must be of Greek descent OR declared majors in Greek Studies. Graduate students may use school address as permanent address if they file taxes independently. Eleftheria applicants have no residency requirements."
  },
  "1475": {
      "targetGradeLevels": [
          "high-school-freshman",
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "noEssayRequired": true,
      "targetStates": [
          "Iowa"
      ],
      "specialRequirements": "Must have a College Savings Iowa account or be a parent/guardian/adult with a College Savings Iowa account for an eligible student. Applicants must be Iowa residents."
  },
  "1476": {
      "specialRequirements": "Applicant must be the son, daughter, or legally adopted child of a highway or transportation construction worker who was killed or permanently disabled in the line of duty. Applicant must be attending or planning to attend a post-secondary institution (4-year college, 2-year college, or vocational-technical institution) requiring a high school diploma or G.E.D. for admission."
  },
  "1477": {
      "requiredMajors": [
          "nutrition",
          "dietetics",
          "food service management"
      ],
      "specialRequirements": "Must be enrolled in the College of Education and Human Sciences at the University of Nebraska-Lincoln. Must complete and submit the Lucile E. Wright Memorial Scholarship Application Form to the UNL College of Education and Human Sciences office by the deadline."
  },
  "1478": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "CA"
      ],
      "specialRequirements": "Must be a current graduating senior of Westmoor High School in Daly City, CA. Must plan to enroll full-time in a two- or four-year college/university or in a vocational program leading to a certificate. Must have demonstrated desire to serve the wider community and demonstrated financial need or hardship."
  },
  "1479": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "journalism",
          "communications"
      ],
      "specialRequirements": "Must be a high school senior in Northern Illinois region. Must demonstrate intent to attend college as a journalism or communications major with emphasis on print and/or online journalism. Must show standards of honesty, integrity, attention to detail, hard work, creativity and understanding of quality community journalism."
  },
  "1480": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "New Mexico"
      ],
      "specialRequirements": "High school seniors must have minimum 3.5 GPA; current undergraduates must have minimum 3.0 GPA. Must plan to attend college or university full-time."
  },
  "1481": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresDisability": true,
      "targetEthnicities": [
          "Jewish"
      ],
      "requiredActivities": [
          "Jewish community engagement"
      ],
      "specialRequirements": "Must be legally blind or have low vision with central visual acuity of 20/70 or worse in the better eye with correction or visual field no greater than 20 degrees. Must provide medical documentation from qualified professional. Must demonstrate strong academic record. Must be enrolled in degree-granting program at accredited college or university. May be full-time or part-time. Students in approved short-term programs may qualify."
  },
  "1482": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "requiresFAFSA": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Bachelor of Architecture"
      ],
      "specialRequirements": "Must be entering 3rd or 4th year of a 5-year program in the fall. Must attend Illinois Institute of Technology, University of Illinois Chicago, or School of the Art Institute. Requires 750-word diversity statement, three portfolio images with descriptions, and two letters of recommendation (at least one from professor or employer in architecture field)."
  },
  "1483": {
      "minGPA": 2,
      "targetEthnicities": [
          "Native American",
          "American Indian"
      ],
      "specialRequirements": "Must provide documentation of tribal enrollment for self or parent. Must be enrolled full-time at an accredited technical school, college, or university (online institutions not funded). Must submit grades each semester to maintain scholarship."
  },
  "1484": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "Horticulture",
          "Floriculture",
          "Landscape Design",
          "Botany",
          "Plant Pathology",
          "Forestry",
          "Agronomy",
          "Environmental Concerns",
          "City Planning",
          "Land Management"
      ],
      "specialRequirements": "Residents of Antioch Township or neighboring communities. Must submit recommendation letter from non-relative source, official transcript, and personal statement essay (500 words or less) on background, future goals, and commitment to chosen career. Essay must be typed or computer-generated using 12-point double-spaced type."
  },
  "1485": {
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "Architecture",
          "Landscape Architecture",
          "Urban Design",
          "Land Planning",
          "Interior Design",
          "Historic Preservation",
          "Environmental Design"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a female resident of California or attending a California school. Must have completed a minimum of 18 units in major by application deadline, or minimum of 10 units if current community college student."
  },
  "1486": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Tennessee"
      ],
      "specialRequirements": "Must be graduating senior from public school in City of Memphis and Shelby County School District. Must have proof of acceptance and enrollment to college, university, or technical school. Must submit: one teacher recommendation letter, one non-relative recommendation letter, official transcript with GPA/class rank/class size, ACT and/or SAT scores, completed application with essays, graduation photo, and acceptance letter from HBCU or technical school. Four-year scholarship awardees must desire full-time enrollment at Lincoln University. Awards are non-repeating and non-transferable."
  },  "1488": {
      "targetStates": [
          "Maryland",
          "Virginia"
      ],
      "requiredMajors": [
          "environmental sciences",
          "stream restoration",
          "natural resource preservation"
      ],
      "specialRequirements": "Must be enrolled in a degree-seeking or training program related to environmental sciences, stream restoration, or natural resource preservation. Must demonstrate passion for the natural environment and stream restoration. Preference given to disadvantaged students and those with diverse perspectives. Preference given to applicants from Maryland and Virginia. Recipients receive complimentary 1-year MSRA membership including networking opportunities, webinar access, and field trips."
  },
  "1489": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "international relations",
          "development",
          "trade",
          "economics",
          "business"
      ],
      "specialRequirements": "Must be attending a Tampa Bay college/university or have personal connection to greater Tampa Bay community. Must be full-time student at accredited institution (excluding incoming freshmen). Must provide detailed description of confirmed use for award (e.g., acceptance at study abroad program or field research). Funds must be used for tuition, books, and expenses related to international-related major or field of study, including study abroad programs."
  },
  "1490": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "journalism"
      ],
      "specialRequirements": "Must be from one of the four counties in western Massachusetts. Must have applied to an accredited college or university. Must plan to major or minor in journalism with areas of focus including news, sports, investigative, photojournalism, social media, features, health, and entertainment."
  },
  "1491": {
      "minGPA": 3,
      "targetStates": [
          "California",
          "Nevada",
          "Arizona",
          "Oregon",
          "Washington"
      ],
      "requiredMajors": [
          "equine-related fields"
      ],
      "specialRequirements": "Limited to West Coast students (CA, NV, AZ, OR, WA). Selection based on academic and extracurricular activities with emphasis on hard working individuals with desire to work in equine industry. 7 awards available."
  },
  "1492": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "water resources"
      ],
      "specialRequirements": "Must reside within the Delaware River Basin watershed. Must be accepted into an accredited junior college, college, or university for Fall 2025 semester. Must demonstrate strong interest in water resources and environmental issues. Immediate family members of WRA's Board of Directors are not eligible. Requires submission of application form, 700-word summary, two letters of reference, and official transcript from last three years."
  },
  "1493": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "Real Estate Brokerage",
          "Real Estate Finance",
          "Real Estate Management",
          "Real Estate Development",
          "Real Estate Appraisal",
          "Real Estate Planning",
          "Real Estate Law",
          "Commercial Real Estate"
      ],
      "specialRequirements": "Must be enrolled in California two-year or four-year college/university; taking at least 6 units; enrolled in at least one real estate or real estate-related course; completed at least 12 college units within last 4 years; completed at least 2 real estate or real estate-related courses; legal California resident for at least 1 year; willing to complete interview with Scholarship Foundation Trustee; willing to provide video testimonial and written report if selected; must submit 300-word essay on career objectives; must provide two letters of recommendation (one from faculty member, one from REALTOR®)"
  },
  "1494": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Oregon",
          "Washington"
      ],
      "specialRequirements": "Must reside in Clackamas, Multnomah, or Washington counties in Oregon, or Clark County in Washington. Must submit parental permission and school transcripts. Essay must be 750-1,200 words on announced Humanism topic. Must submit proof of post-secondary plans prior to receiving funds."
  },
  "1495": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Italian"
      ],
      "targetStates": [
          "Illinois"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a resident of Illinois; must have at least one parent of Italian descent; must be present to accept the award; must submit transcript, two recommendation letters, ACT or SAT scores, a small photo, and an essay describing Italian ancestry and pride in heritage; must enroll full-time in a 2 or 4 year accredited college/university or accredited vocational/technical school"
  },
  "1496": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiredMajors": [
          "geospatial intelligence",
          "geospatial sciences"
      ],
      "specialRequirements": "Two letters of recommendation required; most recent school transcript required; short essay questions and essay writing component required. Sponsored scholarships may have additional criteria."
  },
  "1497": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "noEssayRequired": true,
      "requiredActivities": [
          "oratorical-competition"
      ],
      "specialRequirements": "Must be under age 20 on the date of the national contest. Must be enrolled in a high school or junior high school with coursework at a high school level. Must be domiciled within or attending a school in the department where entering competition. Early graduates may compete if not enrolled in a postsecondary institution at the time of department finals. Prepared oration must be 8-10 minutes. Assigned topic discourse must be 3-5 minutes. All quotations over ten words must include proper written and oral attribution."
  },
  "1498": {
      "minGPA": 2,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "information management"
      ],
      "specialRequirements": "Must be currently enrolled in an accredited educational program; must have completed at least one semester/term of coursework; must have a C average or higher (or Pass if Pass/Fail); must not have received an AIEF-funded scholarship within the past five years. Application requires current transcript, resume, and one-page double-spaced 12-point font essay discussing interest in information management and plans to contribute to the field."
  },
  "1499": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetEthnicities": [
          "jewish"
      ],
      "targetStates": [
          "pennsylvania"
      ],
      "specialRequirements": "Bona fide resident of Allegheny, Beaver, Butler, Washington, or Westmoreland counties for 2+ years (or Clarion, Crawford, Erie, Lawrence, Mercer, or Venango counties for Sarah and Tena Goldstein Memorial Scholarship only). Dependent students' residency determined by parents' residency. Independent students must live in area for 2+ years. All first-time applicants must be interviewed by JSS staff. Must complete FAFSA and provide household financial information."
  },
  "1500": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Colorado"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must identify as a Jewish woman; be at least 16 years old; be a Colorado resident; have applied to and plan to attend a college, junior college, community college, vocational or technical school in the year the scholarship is awarded; must submit FAFSA Student Aid Report (SAR) or CASFA and Financial Aid Award letter from post-secondary institution"
  },
  "1501": {
      "requiredMajors": [
          "Accounting",
          "Banking",
          "Finance",
          "business-related"
      ],
      "specialRequirements": "Must submit 500-1,000 word essay in Word or PDF format explaining choice of career in Accounting, Banking, Finance, or business-related fields. Winner must submit official school transcript reflecting most recently completed semester."
  },
  "1502": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Delaware"
      ],
      "requiredMajors": [
          "Food & Nutrition"
      ],
      "specialRequirements": "Must submit acceptance letter from accredited 2-year or 4-year college/university, recommendation letter, and essay (maximum 500 words) on assigned topic. 3 awards available."
  },
  "1503": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a Morristown High School senior. State selection and county selection criteria apply. Requirements and dollar amounts vary by individual scholarship. Applicants may apply for multiple scholarships."
  },
  "1504": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be a current high school senior graduating by August 1st; resident of Miami-Dade County; must be accepted and plan to enroll at an accredited college or university in the coming Fall; must be directly or indirectly impacted by gun violence; only one scholarship application accepted per applicant"
  },
  "1505": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresDisability": true,
      "requiredMajors": [
          "business",
          "commerce",
          "computer science",
          "engineering",
          "math",
          "physics",
          "statistics"
      ],
      "specialRequirements": "Must be current student in US or Canada; must maintain full-time enrollment with at least 40% course load; must have interest in financial services career, ideally capital markets; must submit essay on career goals and scholarship fit; must provide letter of reference from professor, advisor, or supervisor; must join Lime Community platform and become Network Member"
  },
  "1506": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "specialRequirements": "Must be enrolled in or accepted to an accredited U.S. college or university. Must aspire to a career in the cybersecurity industry. Application requires: personal and educational details, unofficial transcript or acceptance letter, one signed letter of recommendation, and a 500-700 word personal essay in English or Spanish on motivation for STEM career and how companies like ESET can inspire women in these fields."
  },
  "1507": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Black"
      ],
      "requiredActivities": [
          "leadership",
          "community-engagement"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Demonstrated leadership through school, community, or extracurricular involvement. Commitment to service, empowerment, or advocacy within the community. One letter of recommendation required. 500-750 word personal essay required."
  },
  "1508": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Native American - Haudenosaunee heritage (Seneca, Cayuga, Onondaga, Oneida, Mohawk, Tuscarora)"
      ],
      "requiredActivities": [
          "lacrosse"
      ],
      "targetGenders": [
          "male",
          "female"
      ],
      "specialRequirements": "Must be a high school senior in 12th grade in good academic standing. Must be a lacrosse player of Haudenosaunee heritage. Selection based on academic achievement, athletic performance, ambition, potential to succeed, and understanding of how lacrosse has prepared applicant for future success. Payments made directly to college/university, so recipient must be preparing to attend college."
  },
  "1509": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFAFSA": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must have experienced homelessness (verified by homeless school liaison or service/shelter provider); must be admitted to or enrolled in accredited 2-year or 4-year college/university for upcoming academic year; must be high school senior graduating from Chicago or suburban high school OR youth leader active with CCH or former CCH Law Project client no older than age 24. Must submit transcript, two letters of recommendation (one from teacher/school personnel), and documentation of other scholarships/financial aid received."
  },
  "1510": {
      "targetStates": [
          "Colorado"
      ],
      "requiredMajors": [
          "Hospitality",
          "Tourism"
      ],
      "specialRequirements": "Must be pursuing a degree at an accredited four-year university, college, or trade school. Must be working in a hotel. Individual scholarship criteria varies. GPA and current year in school are evaluation factors."
  },
  "1511": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "geology",
          "chemical engineering",
          "petroleum engineering"
      ],
      "specialRequirements": "Must have completed at least two years or be currently enrolled in the second year of undergraduate study at an accredited college or university. Must plan a career in petroleum, energy, allied industries, or research and development of alternative fuels (coal, electric, solar, wind, hydroelectric, nuclear, ethanol). GPA requirement is 80% and above for Canadian applicants."
  },
  "1512": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Georgia"
      ],
      "requiredActivities": [
          "junior-golf-program"
      ],
      "specialRequirements": "Graduate of public or private Georgia high school; legal resident of Georgia; accepted as full-time student at accredited two- or four-year college/university; ACT/SAT score at or above national average; demonstrates exemplary personal character; registered with Selective Service if required; relatives of Scholarship Committee members are not eligible"
  },
  "1513": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "specialRequirements": "Must attend or be accepted to a UNCF member college or university for the coming academic year. Must not be an officer/director of Foot Locker or UNCF, or a family member of such individuals. Renewable for prior recipients who reapply. Award amounts vary based on need."
  },
  "1514": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Georgia"
      ],
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "Must be a graduating high school senior and Georgia resident. Interest in pursuing a career in a STEM-related field is preferred. Application requires transcript, personal statement describing interest in STEM and how applicant plans to contribute to the field, and supporting materials (letters of recommendation, volunteer work, etc.)."
  },
  "1515": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "specialRequirements": "Must intend full-time enrollment in a collegiate program at an accredited two- or four-year college, university, or vocational-technical school for the upcoming academic year. Individuals residing in the state of New York are not eligible."
  },
  "1516": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must reside and have attended high school in District 7 region (Edwardsville, Illinois). Must be college-bound high school senior or full-time college student. Extracurricular involvement required. Renewable for up to 5 years. Funds awarded only upon receipt of winners' college course schedules confirming full-time enrollment."
  },
  "1517": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "creative-arts",
          "performing-arts"
      ],
      "specialRequirements": "Must be a graduating U.S. high school senior (including home schooled students) intending to enroll in an accredited two-year or four-year U.S. college or university. Must demonstrate interest in and commitment to creative or performing arts. Must pursue higher education in the academic year following application. Only one application per student permitted. Requires scholarship essay (PDF), official high school transcript, letter of recommendation (PDF), and college/university letter of acceptance (PDF)."
  },
  "1518": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Kansas"
      ],
      "requiredMajors": [
          "Architecture"
      ],
      "specialRequirements": "Must be from Kansas City Metro area. Must be pursuing architectural degree from accredited school of architecture. Previous award recipients must reapply for next school year. Special circumstances considered at committee discretion."
  },
  "1519": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "industrial finishing",
          "coatings technology"
      ],
      "specialRequirements": "Enrolled in a program relevant to industrial finishing/coatings industry careers. Essay required detailing career objectives and interest in finishing. Must provide grade verification, extra-curricular activities, community involvement information, and reference letter. If previously applied, must submit new letter of recommendation and significantly updated essay."
  },
  "1520": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Connecticut",
          "Maine",
          "Massachusetts",
          "New Hampshire",
          "Rhode Island",
          "Vermont"
      ],
      "requiredActivities": [
          "community service"
      ],
      "specialRequirements": "Must be graduating from a public high school in one of the six New England states. Must demonstrate strong commitment to helping their community. Red Sox Scholars and family of Red Sox employees are ineligible to apply. Minimum 100 awards available; winners notified by May 18, 2026."
  },
  "1521": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Jersey",
          "New York",
          "Pennsylvania"
      ],
      "requiredMajors": [
          "healthcare-related fields"
      ],
      "specialRequirements": "Must intend to pursue a degree in a healthcare-related field. Application requires 500-750 word essay responding to prompt about biggest challenges in healthcare. Must attach proof of enrollment (unofficial transcript, acceptance letter, or current class schedule)."
  },
  "1522": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be in academic good standing, registered Democratic voter, possess family Democratic Party background or be an active participant in Democratic Party activities"
  },
  "1523": {
      "targetStates": [
          "New Hampshire"
      ],
      "requiredMajors": [
          "Architecture",
          "Art/Fine Arts",
          "Construction Management",
          "Engineering",
          "Environmental Studies",
          "Historic Preservation",
          "Interior Design",
          "Landscape Architecture",
          "Planning"
      ],
      "specialRequirements": "New Hampshire resident; Major in one of the listed fields or a related field; Apply through the New Hampshire Charitable Foundation universal application"
  },
  "1524": {
      "minGPA": 3.7,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Colorado",
          "Wyoming",
          "Montana",
          "New Mexico",
          "Idaho"
      ],
      "requiredMajors": [
          "engineering",
          "mathematics",
          "physical sciences",
          "biological sciences"
      ],
      "specialRequirements": "Must graduate from high school in eligible states; must enroll in accredited four-year college or university; minimum SAT score of 1200 or ACT score of 28; renewable for up to four years if student remains in good standing"
  },
  "1525": {
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "manufactured housing",
          "recreation vehicle",
          "campground"
      ],
      "specialRequirements": "Must be attending or accepted to an accredited university, college, or vocational institution. Applicants must demonstrate financial need or merit and provide documentation thereof. Must include a personal statement outlining educational and career goals."
  },
  "1526": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "education"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a Virginia resident for the last 2 years; registered to vote in Virginia; currently attending or committed to attend a college/university in Virginia; not in final year of study; submit one letter of recommendation from non-family member; submit 1-page resume; must attend VFRW convention lunch in Harrisonburg, VA and approve use of name/photo for promotions"
  },
  "1527": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "Political Science",
          "Government",
          "Law",
          "Political Communications",
          "Journalism",
          "Public Policy",
          "Public Administration",
          "International Relations",
          "Philosophy",
          "Economics"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a female resident of Virginia for the last two years; registered to vote in Virginia; currently attending or committed to attend a college/university in Virginia; not in final year of study; submit one letter of recommendation from non-family member; submit 1-page resume only; complete application with all essays and documents; must attend VFRW convention lunch in Harrisonburg, VA; must give written approval for VFRW to use name and photo for promotions"
  },
  "1528": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must have high school diploma or GED score of 550. Application reviewed competitively by Adena scholarship committee. Eligibility criteria include GPA, state selection, selected major(s), current year in school, county selection, and age."
  },
  "1529": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "NC"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be current high school senior planning to attend college upon graduation. Must reside in one of 19 specified North Carolina counties (Alamance, Alexander, Alleghany, Ashe, Caldwell, Caswell, Davidson, Davie, Forsyth, Guilford, Iredell, Randolph, Rockingham, Rowan, Stokes, Surry, Watauga, Wilkes, Yadkin). Requires 500-word personal essay on ethical dilemma. AI may not be used for application materials. Must demonstrate academic excellence and record of community service."
  },
  "1530": {
      "minGPA": 3,
      "targetStates": [
          "New Jersey"
      ],
      "requiredMajors": [
          "Horticulture",
          "Landscape Technology"
      ],
      "specialRequirements": "Must be enrolled in the Horticulture or Landscape program at County College of Morris (CCM). Must be a resident of New Jersey."
  },
  "1531": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredActivities": [
          "leadership",
          "extracurricular-involvement"
      ],
      "specialRequirements": "Must be a graduating high school senior in the fall; must attend school within eligible county boundaries; must plan to pursue a 4-year, 2-year, or certificate program at an accredited U.S. community college or university starting in the coming fall; must not defer enrollment to a later date; preference given to renewable energy or STEM majors; selection based on academic achievement, leadership, and extracurricular involvement; requires submission of academic transcript, personal statement, and creative video demonstrating interest in renewable energy or STEM"
  },
  "1532": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Arkansas"
      ],
      "requiredMajors": [
          "Psychology",
          "Sociology",
          "Education",
          "Pediatrics",
          "Coaching"
      ],
      "specialRequirements": "Must be a graduating high school senior in Saline County. Must plan to attend a traditional postsecondary educational institution. Must provide proof of enrollment before funds are distributed. Requires letter of recommendation from teacher, pastor, or non-family reference. Requires official transcript with ACT scores or other applicable test scores. Must provide proof of registration at least ten days before start of classes."
  },
  "1533": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Massachusetts"
      ],
      "requiredActivities": [
          "social-justice"
      ],
      "specialRequirements": "Must be a public high school senior from Hampshire or Hampden County, Massachusetts. Must submit an 800-1200 word typed, double-spaced essay describing experiences working for social justice in school or community and how work relates to Sojourner Truth's life and works. Must plan to attend college or postsecondary school."
  },
  "1534": {
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "Music"
      ],
      "specialRequirements": "Must reside in Sarasota or Manatee County. Must submit an audition tape with a minimum of two pieces of music from different time periods and of contrasting styles. Artistic ability assessment required."
  },
  "1535": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "education",
          "nursing",
          "law enforcement",
          "medical research",
          "social work"
      ],
      "specialRequirements": "Must be a graduating senior from Tussey Mountain School District in Pennsylvania who has completed all four years at the school and plans to enroll full-time in a college or university in the fall"
  },
  "1536": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "engineering",
          "computer-science"
      ],
      "targetGenders": [
          "non-binary"
      ],
      "specialRequirements": "Must live or attend school within Golden Gate Section boundaries. Community college students must plan to transfer to a 4-year accredited university. High school seniors must be pursuing degrees from accredited universities."
  },
  "1537": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "magnetics",
          "electrical transformer design",
          "electrical engineering",
          "mechanical engineering",
          "similar discipline"
      ],
      "specialRequirements": "Must be enrolled full-time for current academic year in North America. Must submit: letter of application, resume, transcript, recommendation letter from department chairperson/faculty advisor/professor confirming interest in transformers, and letter describing interest in transformers field including relevant coursework, papers, research projects, employment, co-ops, or work study programs."
  },
  "1538": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredActivities": [
          "volunteer and community service"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must attend school in Hampshire, Hampden or Franklin County. Must plan to attend a two-year or four-year college and provide written verification of college acceptance. Must complete minimum 20 hours of community service yearly and submit a letter of reference from a current volunteer supervisor. Must submit all 4 parts of the JLGS scholarship application. If eligibility status changes and recipient does not continue education, scholarship money must be returned."
  },
  "1539": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Filipino"
      ],
      "targetStates": [
          "California"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must reside in or attend school within one of the nine San Francisco Bay Area counties. Must demonstrate personal, academic, and/or community success. Must have experienced personal hardship and express pride and connection to Filipino culture, heritage, and identity."
  },
  "1540": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Ohio"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be Twinsburg High School senior accepted at accredited university/post-secondary institution. Must submit transcripts, GPA, class size, two letters of recommendation (from teacher, neighbor, employer - no relatives), essay (300 words max) on community contributions and Twins Days Festival impact, brief self-description, interests, and recent photo. Photo may be used in Twins Day souvenir program, website, social media, and local media."
  },
  "1541": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a graduating high school senior, meet all requirements on Honors Graduation website, plan to attend an accredited college or university in the USA, and complete a community improvement project based on the LAUNCH Cycle. Employees of Honors Graduation and their families are not eligible."
  },
  "1542": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Connecticut"
      ],
      "requiredActivities": [
          "golf"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Personal interviews conducted with finalists. Awarded regardless of race, color, creed or club affiliation."
  },
  "1543": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California",
          "Nevada"
      ],
      "requiredActivities": [
          "japan-interest"
      ],
      "specialRequirements": "Must live in Monterey, Kings, Tulane, Inyo counties or California counties north of them, or any Nevada county. Must demonstrate sincere interest in Japan through at least one year of directed study or related activity. Must be enrolling full-time in an undergraduate program at an accredited 2 or 4-year college or university commencing Fall semester after receiving award."
  },
  "1544": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maryland"
      ],
      "requiredMajors": [
          "hospitality"
      ],
      "specialRequirements": "Applicants must be Maryland residents and either: (1) high school senior or college student with minimum 400 hours of documented industry experience, OR (2) high school/college/corporate instructor or hospitality industry professional with minimum 1,500 hours of documented industry experience"
  },
  "1545": {
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "requiredMajors": [
          "meat science",
          "food science",
          "animal science",
          "agriculture",
          "agribusiness",
          "beef industry related"
      ],
      "specialRequirements": "Must be classified as junior or senior at beginning of spring semester/quarter at 4-year institution, or enrolled full-time in recognized masters or doctorate program conducting applied or basic research. Must demonstrate commitment to beef industry through activities and curriculum."
  },
  "1546": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Pennsylvania",
          "New Jersey",
          "Delaware"
      ],
      "requiredMajors": [
          "Construction Management",
          "Architecture",
          "Engineering"
      ],
      "specialRequirements": "Must be actively enrolled with minimum one full academic year remaining before degree completion. Must reside or attend college in Pennsylvania (zip code >17000), New Jersey (zip code >08000), or Delaware. Must have strong interest in career in Construction Management. Requires typed, double-spaced essay (12 Font, Times New Roman) on future plans and scholarship interest. Winners and one guest invited to June Awards Dinner."
  },
  "1547": {
      "targetStates": [
          "Oklahoma"
      ],
      "specialRequirements": "Must be a graduate of a public or private high school in Choctaw County, Oklahoma. Preference given to graduates of Fort Towson high schools. Must be accepted for enrollment or currently enrolled in an accredited college or university. Applicants planning to study architecture, art, or forestry may receive special consideration."
  },
  "1548": {
      "requiredMajors": [
          "journalism"
      ],
      "specialRequirements": "Entries must have been published, aired, or posted while student was an undergraduate journalism major or minor. Entrants must attend a domestic accredited college or university within ACEJMC. Photo entrants are not required to be journalism majors or minors. Only individual entries accepted except in approved team competitions. Each participating university may enter two separate students per competition."
  },
  "1549": {
      "targetStates": [
          "Texas"
      ],
      "specialRequirements": "Must be accepted for enrollment or enrolled in a two or four-year undergraduate program at an accredited college or university. Must be a graduate of a public or private high school in Choctaw County (preference given to Fort Towson high school graduates). Applicants pursuing architecture, art, or forestry may be given special consideration."
  },
  "1550": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "facility management",
          "construction management",
          "architecture",
          "interior design",
          "engineering"
      ],
      "specialRequirements": "Must be enrolled at an accredited institution in a Facility Management or FM-related program. GPA of 3.2 or higher must be in FM or related coursework (international equivalents accepted). Recipients must attend IFMA World Workplace Conference in Minneapolis, MN and participate in IFMA Foundation activities. Working students and veterans encouraged to apply. Students from all parts of the world invited to apply."
  },
  "1551": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "visual arts",
          "drawing",
          "painting",
          "sculpture",
          "fashion design",
          "set design",
          "photography"
      ],
      "specialRequirements": "Must be a graduating senior attending high school in Nassau County, New York. Must have demonstrated commitment to visual arts."
  },
  "1552": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Massachusetts"
      ],
      "specialRequirements": "Applicant must be the child of a worker killed or seriously injured in a compensable work-related accident or occupational disease with a Massachusetts employer; between 17-22 years old at time of application; accepted or already enrolled at a university, college, or technical school; full-time students preferred, part-time students considered at committee discretion"
  },
  "1553": {
      "targetStates": [
          "Alaska"
      ],
      "requiredActivities": [
          "artistic ability"
      ],
      "specialRequirements": "State selection, County selection, Current year in school, Age criteria (specific details not provided on page). Geographic focus on Skagway and northern Southeast Alaska. Applicants must be attending a tax-exempt non-profit or educational institution."
  },
  "1554": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Texas",
          "California"
      ],
      "specialRequirements": "Must be an active member or active in the life of a Presbyterian church in the Presbyterian Church USA (PCUSA) in North Central Texas or Los Angeles and surrounding communities; must be accepted for enrollment or currently enrolled in a two- or four-year undergraduate program in an accredited college, university, vocational school, or trade school; must have work experience and/or community service experience"
  },
  "1555": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiredMajors": [
          "chemistry",
          "chemical engineering",
          "environmental engineering",
          "metallurgical engineering",
          "materials science engineering",
          "metallurgy",
          "materials science",
          "mechanical engineering"
      ],
      "specialRequirements": "Must be attending an accredited college/university in the United States. Undergraduate applicants must be junior standing or above when applying and must be of senior standing for the next academic year."
  },
  "1556": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "targetStates": [
          "Michigan"
      ],
      "requiredMajors": [
          "visual arts"
      ],
      "specialRequirements": "Must be between 17 and 25 years of age. Must be full-time Michigan resident attending a Michigan college/university. Livingston County high school seniors eligible for additional $1,000. Must submit Artist's Goal Statement (minimum 75 words) as PDF and five artwork samples in digital jpg format (300 dpi, max 4MB each). Scholarship recipients expected to attend formal presentation in summer at Brighton Art Guild's monthly program at Brighton District Library."
  },
  "1557": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "african-american"
      ],
      "targetStates": [
          "texas"
      ],
      "targetGenders": [
          "male"
      ],
      "specialRequirements": "Must be graduating from a high school in Dallas County. Must demonstrate leadership, academic achievement, and community involvement. Personal interviews may be required as part of the selection process."
  },
  "1558": {
      "requiredMajors": [
          "computer technology"
      ],
      "specialRequirements": "Must be from or have attended high school in a rural community. Must demonstrate interest in cyber security. Selection based on essay responses evaluating passion for cyber security career and sense of citizenship/pride in rural community."
  },
  "1559": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Washington"
      ],
      "requiredMajors": [
          "accounting"
      ],
      "specialRequirements": "High school seniors must be planning to attend any Washington state college or university next Fall. Community college students must be attending a Washington state two-year college next Fall. Recipients must participate in an online series to explore accounting career pathways. Interest in becoming a Certified Public Accountant (CPA) is required or preferred."
  },
  "1560": {
      "targetStates": [
          "Washington"
      ],
      "requiredMajors": [
          "viticulture",
          "enology",
          "wine business management",
          "food sciences"
      ],
      "specialRequirements": "Recipients selected without regard to race, sex, color, ethnic origin, religious belief, marital status or physical handicap. Individual scholarship criteria varies by specific award."
  },
  "1561": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "specialRequirements": "Must be at least 23 years old; must be a resident of Elmhurst, Addison, Bensenville, Berkeley, Northlake, Oak Brook, Oakbrook Terrace or Villa Park; must be continuing education after completing at least 12 credit hours at an accredited community or undergraduate college/university. Required documents: resume, official letter of acceptance, letter of recommendation from professional source, transcript, and personal background and goals essay."
  },
  "1562": {
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Washington"
      ],
      "specialRequirements": "Must be at least 24 years old; must be a returning undergraduate student with interrupted education; must have graduated from high school in King County, Washington; must be accepted at a Washington public four-year college/university or B.A.S. program at specified Washington colleges; must not already have a Bachelor's degree; must be enrolled at least half-time (6+ credits) for a full academic year"
  },
  "1563": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "advertising",
          "communications",
          "marketing",
          "graphic arts"
      ],
      "specialRequirements": "Must be a Western Massachusetts senior planning to attend accredited college or technical school in September 2023. Judged on academic performance, extracurricular activities, community service and/or work experience, demonstrated interest in advertising/communications/marketing/graphic design, personal recommendations, and letter of introduction outlining future plans."
  },
  "1564": {
      "requiredActivities": [
          "community service"
      ],
      "specialRequirements": "Must demonstrate high academic achievement. Applicable to study and intern abroad programs. Up to 3 awards available each fall and spring semester."
  },
  "1565": {
      "minGPA": 2,
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "minority students"
      ],
      "targetStates": [
          "Minnesota",
          "Wisconsin"
      ],
      "requiredMajors": [
          "patient-focused healthcare field",
          "medical field",
          "rehabilitation field"
      ],
      "requiredActivities": [
          "volunteer or community service"
      ],
      "specialRequirements": "Must be accepted to or enrolled in a post-secondary program. Must demonstrate interest in rehabilitation. Selection based on stated intentions, past achievements, need, and graduation ranking."
  },
  "1566": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Permanent home address in Campbell, San José, Milpitas, or Santa Clara. Must be enrolled as a junior or senior in a four-year institution. Requires submission of official college transcript, personal statement outlining educational goals and achievements, and one letter of recommendation."
  },
  "1567": {
      "requiredMajors": [
          "interior design"
      ],
      "specialRequirements": "Submission must include: description of publication or visual communication (250 word maximum), copy of publication or visual communication, biographical statement, and headshot. Types of entries can include books, whitepapers, blogs, and videos. Judged on innovation of subject matter, comprehensive and original coverage of topic, organization, graphic presentation, bibliography, and references."
  },
  "1568": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "interior-design"
      ],
      "specialRequirements": "Must be enrolled in at least a three-year accredited program of interior design. Evaluation based on academic record, presentation skills, design and planning competency, and conceptual creativity."
  },
  "1569": {
      "targetStates": [
          "Pennsylvania",
          "West Virginia"
      ],
      "requiredMajors": [
          "environmental science",
          "environmental engineering",
          "environmental law"
      ],
      "specialRequirements": "GPA and state selection criteria apply; awards available to students in the Allegheny Mountain Section region (western Pennsylvania and West Virginia)"
  },
  "1570": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Missouri",
          "Illinois"
      ],
      "specialRequirements": "Must be permanent resident in applicable communities served by BJC Hospitals (St. Louis City, St. Louis, St. Charles, Crawford, and St. Francois Counties in Missouri; Madison County and St. Clair County in Illinois). Must plan to attend an accredited, nonprofit four-year, in-state public institution or any out-of-state school that allows in-state tuition reciprocity."
  },
  "1571": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Hispanic"
      ],
      "targetStates": [
          "Idaho"
      ],
      "specialRequirements": "Must be Idaho resident, of Hispanic origin, pursuing an academic major, enrolling as college freshman in fall of award year, and must submit essay describing educational and career goals including community involvement details"
  },
  "1572": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "interior design"
      ],
      "specialRequirements": "Must demonstrate interest and ability in utilizing classical design elements and traditional materials. All project types accepted including workplace, civic, residential, hospitality, and historical restoration projects."
  },
  "1573": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "agriculture"
      ],
      "specialRequirements": "Must be a resident of New York state. Must be enrolled or planning to enroll in a 2- or 4-year accredited institution. Funds can be used at public and private institutions within or outside of New York state."
  },
  "1574": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "Criminal Justice",
          "Journalism",
          "Nursing",
          "Healthcare"
      ],
      "specialRequirements": "Must be enrolled as a high school senior and must attend a Historically Black College or University (HBCU). Awards available: 2. Winners announced in May."
  },
  "1575": {
      "specialRequirements": "Applicants must be planning to pursue a career in a male-dominated field. Required materials include: transcript, professional photo, original essay detailing career goals and motivation for pursuing a male-dominated field, and at least two letters of recommendation."
  },
  "1576": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredActivities": [
          "collegiate-esports-team-or-club"
      ],
      "specialRequirements": "Must be a woman or member of an under-represented group. Must be enrolled full-time in an undergraduate program at an accredited four-year U.S. college or university. Must be competing on a college esports team or club, or confirmed to compete at the collegiate level in Fall 2025."
  },
  "1577": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresFirstGen": true,
      "targetEthnicities": [
          "hispanic-latinx",
          "racial-minorities",
          "international-students",
          "immigrants"
      ],
      "requiredActivities": [
          "extracurricular-activities"
      ],
      "specialRequirements": "Must be enrolled at Coppin State University during the academic year the scholarship is awarded. Selected winners must attend award ceremony in August at The University of Baltimore. Must submit SAT/ACT scores and essays outlining career goals and aspirations."
  },
  "1578": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresFirstGen": true,
      "targetEthnicities": [
          "underrepresented-communities"
      ],
      "requiredMajors": [
          "any-major",
          "School-of-Global-Journalism-and-Communication"
      ],
      "requiredActivities": [
          "extracurricular-involvement"
      ],
      "specialRequirements": "SAT/ACT scores will be considered. Applicants must complete essays outlining career goals and aspirations. Must be enrolled during the academic year the scholarship is awarded. Award winners are expected to attend an award ceremony. Three awards available for all majors; three awards earmarked for School of Global Journalism and Communication students."
  },
  "1579": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresFirstGen": true,
      "targetEthnicities": [
          "racial-minorities"
      ],
      "specialRequirements": "Open to international students, immigrants, and students from underrepresented communities. Must attend University of Baltimore. Requires submission of academic transcripts, proof of economic need, and personal statement."
  },
  "1580": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Utah"
      ],
      "specialRequirements": "Must be a high school student graduating in the year of application or the following year at an accredited Utah school. Must have successfully completed or currently be enrolled in General Financial Literacy course or equivalent required course. Must not be a direct relative of Utah Jump$tart Coalition Board of Directors or staff. Scholarship may be used for any field of study at an accredited Title IV fund-disbursing post-secondary institution."
  },
  "1581": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "horticulture",
          "floriculture",
          "landscape design",
          "botany",
          "forestry",
          "agronomy",
          "conservation",
          "plant pathology",
          "environmental concerns"
      ],
      "specialRequirements": "Permanent resident of Placer, Sacramento, El Dorado, or Yolo County, or temporarily residing in these counties while attending college. Must be enrolled at an accredited college or university."
  },
  "1582": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Asian",
          "Asian American"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredActivities": [
          "leadership",
          "community involvement"
      ],
      "specialRequirements": "Must reside in or attend school in the Philadelphia region. Must demonstrate strong leadership potential and community involvement. Requires essay, resume, unofficial transcript, and one letter of recommendation."
  },
  "1583": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Applicant must have lost a parent to colorectal cancer. Applicant must be accepted to an eligible post-secondary program. Proof of registration required to receive funds."
  },
  "1584": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior"
      ],
      "targetStates": [
          "New Jersey"
      ],
      "specialRequirements": "Must be ranked in top 5% of high school class at end of junior year. Must reside in eligible communities (see website for list)."
  },
  "1585": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Maryland"
      ],
      "specialRequirements": "Must be eligible for in-state tuition in Maryland. Must attend an eligible Maryland school. Must maintain full-time status and good standing to remain eligible for renewal. Deaf and hearing-impaired students may be eligible to apply to out-of-state institutions in special circumstances if the out-of-state school offers support not provided at any Maryland school."
  },
  "1586": {
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Maryland"
      ],
      "specialRequirements": "Must be eligible for in-state tuition in Maryland; must have high school diploma or GED (minimum passing score of 145 per module); must begin college within six years of high school graduation or obtaining GED; must be under age 26 when first receiving grant (born after July 1, 1999 for coming year); must enroll full-time (minimum 12 credits per semester) in eligible undergraduate program; must file FAFSA or MHEC One-App by March 1st; undocumented students must use MHEC One-App; must submit required documentation by April 15th; must meet income requirements for coming academic year"
  },
  "1587": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Kentucky"
      ],
      "specialRequirements": "Must be an ESL/LEP student with native language other than English; must have been enrolled in ESL class(es) during middle or high school; must be graduating senior from Kentucky high school; must be accepted into a two- or four-year post-secondary institution in Kentucky; must commence course of study during year of high school graduation; cannot be recipient of major academic or sports scholarship or have accepted military academy appointment"
  },
  "1588": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "specialRequirements": "Must be openly self-identified member of LGBTQ+ community. Must provide proof of acceptance to accredited college, university, or vocational school in US or Canada. Must submit 2 personal essays, at least 2 letters of recommendation from non-family members, and detailed list of community involvement (with heavier weight given to LGBTQ+-related activities and leadership roles). High school transcript required showing cumulative GPA of 3.0 or better on 4.0 scale or equivalent (weighted average acceptable). If high school uses non-numerical grading system, complete description of measures of success and graduation requirements required."
  },
  "1589": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a resident and senior at Livonia or Redford High Schools. Must demonstrate passion for helping others and academic excellence. Awards available: 2"
  },
  "1590": {
      "minGPA": 3,
      "requiresFinancialNeed": true,
      "targetStates": [
          "West Virginia",
          "Pennsylvania"
      ],
      "requiredMajors": [
          "healthcare fields",
          "health care professions"
      ],
      "specialRequirements": "Must be a resident of one of the following counties: Braxton, Gilmer, Harrison, Lewis, Marion, Monongalia, Preston, Randolph, Taylor, Tucker, Upshur, or Wetzel in West Virginia; or Fayette and Greene in Pennsylvania. Must have ACT score of 21 or SAT score of 1060. Must submit a letter describing why applicant selected a specific health career."
  },
  "1591": {
      "minGPA": 3,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must have obtained at least second semester freshman status at an accredited four-year college or university in Illinois; must show proof of graduation from a Chicago Metropolitan Area high school; must show proof of acceptance to and enrollment in an accredited four-year college or university in Illinois before scholarship is awarded; must be working toward a first Bachelor's degree. Application requires: work experience, extracurricular activities, awards, two recommendation letters, transcript, personal essay, and media waiver."
  },
  "1592": {
      "requiresMilitaryConnection": true,
      "targetStates": [
          "North Carolina"
      ],
      "specialRequirements": "Applicant must be a dependent child of an NC service member wounded or killed while serving from September 11, 2001 until present (service member can be from any branch of service). Must attend an accredited North Carolina college, vocational or technical institution."
  },
  "1593": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior"
      ],
      "requiredMajors": [
          "Education",
          "Social Media & Communications",
          "Public Relations",
          "Marketing",
          "Food Science",
          "Nutrition (Human)",
          "Journalism"
      ],
      "specialRequirements": "Must be enrolled in a four-year college; focus on dairy product industry or related food industries"
  },
  "1594": {
      "targetGradeLevels": [
          "college-sophomore"
      ],
      "requiredMajors": [
          "Dairy",
          "Animal Science"
      ],
      "specialRequirements": "Must be enrolled in a two-year agricultural college. Selection based on academic standing, leadership ability, interest in dairy industry, and future plans."
  },
  "1595": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiredMajors": [
          "dairy-related-field"
      ],
      "specialRequirements": "Must be in top 25 All-American contestants in past three National Intercollegiate Dairy Cattle Judging Contests OR Platinum winners in past three National Dairy Challenge Contests. Must be applying for graduate study. Selection based on national contest participation, academic standing, leadership ability, student activities, future plans, and interest in dairy industry."
  },
  "1596": {
      "targetGradeLevels": [
          "college-freshman"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "dairy-industry",
          "animal-industry",
          "agricultural-related"
      ],
      "specialRequirements": "Must be attending a four-year college or university in the United States. Selection based on leadership abilities, volunteerism, activities and future plans in the dairy industry."
  },
  "1597": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "college-freshman"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Dairy/Animal Science with Communications emphasis",
          "Agricultural Journalism with Dairy/Animal Science emphasis"
      ],
      "specialRequirements": "Must be a freshman in a four-year college or university. Must aspire to a career in dairy communications or journalism. Scholarship can only be received once per student. Must attend school in the United States."
  },
  "1598": {
      "targetGradeLevels": [
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Dairy Science",
          "Agricultural Economics",
          "Accounting",
          "Dairy Genetics",
          "Dairy Equipment",
          "Dairy Nutrition",
          "Dairy Feed",
          "Pharmaceutical Sales"
      ],
      "specialRequirements": "Must be a current junior student at a four-year college in the United States majoring in dairy or dairy-related agricultural fields. Selection based on leadership, activities, academic ability, and interest in the dairy industry. Must attend school in the United States."
  },
  "1599": {
      "targetGradeLevels": [
          "college-sophomore"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Dairy Science",
          "Agricultural Economics",
          "Accounting",
          "Dairy Genetics",
          "Dairy Equipment",
          "Dairy Nutrition",
          "Dairy Feed",
          "Pharmaceutical Marketing or Sales",
          "Dairy Consultant",
          "Dairy Extension",
          "Dairy Researcher",
          "Dairy Professor"
      ],
      "specialRequirements": "Must be attending a four-year college or university in the United States. Must be majoring in dairy or other agricultural-related fields. Selection based on leadership, activities, academic ability and interests in the dairy industry."
  },
  "1600": {
      "targetGradeLevels": [
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "dairy",
          "agriculture-related"
      ],
      "requiredActivities": [
          "leadership",
          "student activity participation"
      ],
      "specialRequirements": "Must be attending a U.S. school, college or university. Each university can nominate up to two students. Applicants must demonstrate interest in the dairy industry."
  },
  "1601": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "journalism"
      ],
      "specialRequirements": "Must be currently enrolled or have graduated at the end of the most recent calendar year. Must be in tri-state New York area. Application must include: school, division, major and expected graduation date; present and permanent addresses; telephone number; relevant personal information; current resume; essay explaining pursuit of business and financial journalism career; and 3-5 samples of financial writing with links to online work and print clippings in PDF format."
  },
  "1602": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiredMajors": [
          "Business",
          "Food Management",
          "Accounting",
          "Human Resources",
          "IT",
          "other fields leading to a career in the grocery industry"
      ],
      "specialRequirements": "Must be attending a U.S. college or university. Experience in the grocery industry is highly valued. Application requires academic transcripts, proof of enrollment, and resume highlighting grocery industry experience (if applicable)."
  },
  "1603": {
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "Agriculture",
          "Agriculture Education",
          "Agronomy",
          "Botany",
          "Conservation",
          "Environmental Studies",
          "Floriculture",
          "Horticulture",
          "Land Management",
          "Landscape Architecture",
          "Plant Pathology"
      ],
      "specialRequirements": "Applicants must be residents of one of the following Pennsylvania counties: Bucks, Chester, Delaware, Montgomery, or Philadelphia. Must attend an accredited college."
  },
  "1604": {
      "targetGradeLevels": [
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "engineering"
      ],
      "specialRequirements": "Must be enrolled in good standing in a four-year ABET-accredited engineering program. Must be entering or continuing junior year in the fall. Must submit resume/summary of internship/co-op experiences, two faculty recommendations, 500-word max essay on 'The Importance of Ethics in the Practice of Engineering', and official transcript. Upon degree completion, winner must submit report to NSPE Education Foundation Trustees on value of support and objectives regarding professional development, ethical practice, and licensure. Winner must complete the year as agreed or forfeit the scholarship."
  },
  "1605": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "welding",
          "mechanical engineering",
          "electrical engineering",
          "technical engineering",
          "precision engineering",
          "machining",
          "CNC programming",
          "mechatronics",
          "robotics"
      ],
      "specialRequirements": "Must be a graduating senior or have graduated high school or equivalent. Must be unemployed, underemployed, or an incumbent worker. Must reside in Northwestern Pennsylvania. Must attend scholarship presentation ceremony in July or send a representative."
  },
  "1606": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "horticulture",
          "landscape architecture",
          "landscape construction"
      ],
      "specialRequirements": "Must have graduated from an Oregon high school. Preference given to students from Emerald Empire (Eugene) area."
  },
  "1607": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "ornamental horticulture"
      ],
      "specialRequirements": "Must attend Cal Poly San Luis Obispo or Oregon State University. Preference given to Cal Poly applicants."
  },
  "1608": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "ornamental horticulture"
      ],
      "specialRequirements": "Applicants must submit: transcript, two reference letters, and one-page cover letter (including future involvement in horticulture, financial needs, and any OAN affiliation). Preference given to applicants from nursery areas east of Portland. Past recipients encouraged to reapply. Applicants may be awarded more than one scholarship."
  },
  "1609": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "horticulture",
          "floriculture",
          "turf-related studies"
      ],
      "specialRequirements": "Must have graduated from an Oregon high school. Preference given to students who intend to work in horticulture-related industry as an employee or family member of a business."
  },
  "1610": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "environmental sciences",
          "environmental engineering"
      ],
      "specialRequirements": "Must be enrolled at Ohio public or private college/university/community college. Must be entering junior or senior year. Selection based on: academic record (GPA 3.0+), education/employment/internships/honors/awards/professional memberships/publications/presentations/professional meetings/community service, original research/scholarship/employment/internships/unique contributions to environmental science or engineering, extracurricular activities demonstrating leadership/interpersonal skills/social responsibilities, and letters of recommendation from education or environmental professionals."
  },
  "1611": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "ornamental horticulture",
          "related fields"
      ],
      "specialRequirements": "Must submit transcript, two reference letters, and one-page cover letter (including future involvement in horticulture, financial needs, and any OAN affiliation). Evaluated based on career interests, scholastic aptitude, and financial need. Applicants may be awarded multiple scholarships. Past recipients may reapply."
  },
  "1612": {
      "targetStates": [
          "Oregon"
      ],
      "requiredMajors": [
          "Teacher Education"
      ],
      "specialRequirements": "Must be an Oregon resident attending an Oregon public college or university"
  },
  "1613": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must identify as LGBTQ+. Must be between 17 and 28 years old. Must reside in Illinois. Application opens February 1st."
  },
  "1614": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFAFSA": true,
      "targetStates": [
          "Arizona"
      ],
      "specialRequirements": "Must identify as LGBTQ+ or be an ally; must attend FAFSA-accredited postsecondary school in metropolitan Phoenix area"
  },
  "1615": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "noEssayRequired": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be college-bound. Must submit one creative project in one of these categories: poster/billboard, painting/drawing, digital design/illustration, video/audio PSA, or song/dance composition. Essays and poems are not eligible. Project must be original work with no copyrighted materials. Award amounts depend on total entries received and will be paid in one installment."
  },
  "1616": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresDisability": true,
      "requiredActivities": [
          "organized-athletics"
      ],
      "specialRequirements": "Childhood diagnosis of Type 1 Diabetes; successfully managing diabetes with proper medication, exercise and diet; active participation on an organized athletic team; must maintain 3.0 GPA until graduation"
  },
  "1617": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be enrolled in a vocational program or two to five year post-secondary institution and in good overall academic standing"
  },
  "1618": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredActivities": [
          "hindu-dharma-involvement"
      ],
      "specialRequirements": "Must be a graduating high school senior planning to pursue higher education. Must demonstrate active involvement in celebrating and furthering Hindu Dharma. Must maintain minimum 2.75 GPA annually to continue receiving scholarship. Requires 500-1000 word essay on specified topic. Scholarship disbursed over 4 years in $500 annual installments contingent on maintaining GPA and active involvement in Hindu Dharma celebrations and activities on campus."
  },
  "1619": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be a graduating senior within Chester County school district"
  },
  "1620": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Residency in Philadelphia county required. Household income less than $50,000. Must be accepted into an accredited college, university, or trade school. Requires essay on Rev. Leon H. Sullivan's efforts, school transcript, community activities/awards/jobs documentation from last two years, and at least three letters of recommendation."
  },
  "1621": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredActivities": [
          "extracurricular activities",
          "community service"
      ],
      "specialRequirements": "Must be a current graduating senior at Burgettstown Area High School in Pennsylvania"
  },
  "1622": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Iowa"
      ],
      "requiredMajors": [
          "agriculture",
          "automotive/diesel repair",
          "construction",
          "engineering",
          "healthcare/medical/nursing",
          "trade"
      ],
      "specialRequirements": "Must live or have permanent address in Lee County, Iowa, OR be a graduate of Central Lee High School, Fort Madison High School, or Holy Trinity Catholic Schools. Must maintain adequate progress towards degree completion for renewal."
  },
  "1623": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a current high school senior anticipating completion of high school diploma at time of application. Must plan to pursue a degree at an accredited post-secondary institution in the US. Artistic ability considered in selection."
  },
  "1624": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetEthnicities": [
          "Asian Indian"
      ],
      "specialRequirements": "Demonstrated academic and personal excellence. Plan to enroll full-time in an accredited undergraduate or graduate program in the United States for the upcoming academic year. Open to students of all races who identify as being of Asian Indian heritage, or who have demonstrated meaningful engagement with the Asian Indian community."
  },
  "1625": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "selected areas of the United States"
      ],
      "requiredActivities": [
          "volunteer work"
      ],
      "specialRequirements": "High school applicants must be graduating seniors or equivalent. Continuing undergraduate applicants must be former Tzu Chi Scholarship recipients. Full-time enrollment required at accredited U.S. college. Continuing undergraduates must complete 50 volunteer hours with Tzu Chi or another nonprofit organization during the current academic year."
  },
  "1626": {
      "targetGradeLevels": [
          "high-school-freshman",
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "specialRequirements": "Applicants must be at least 15 years old by August 1 of the competition year. Must have conducted a water-related science research project. Applicants must submit a detailed research paper on a water-related topic with supporting documentation and research data."
  },
  "1627": {
      "minGPA": 3.6,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Vietnamese"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be of Vietnamese descent, current high school senior residing in Northern California, attending college in the upcoming summer or fall. Must submit official high school transcript, SAT or ACT scores (optional), two letters of recommendation from teachers/advisors/mentors, and copy of parents' most recent income tax return or proof of family income."
  },
  "1628": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Fine Arts",
          "Visual Arts",
          "Drawing",
          "Graphic Design",
          "Sculpting",
          "Painting",
          "Music",
          "Dance",
          "Theater",
          "Architecture"
      ],
      "specialRequirements": "Must be resident of Winnebago, Boone, or Ogle County in Illinois; enrolled in county public or private high school; ineligible if child or grandchild of Womanspace employees, board members, or scholarship committee members; requires at least two letters of recommendation with at least one from a teacher in relevant discipline; electronic submission preferred"
  },
  "1629": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Maine"
      ],
      "specialRequirements": "Must be a Maine resident; must graduate from a partnered Maine public high school; must plan to enroll full-time at a partnered Maine two-year or four-year college; SAI (Student Aid Index) of 30,000 or less as determined by FAFSA; minimum GPA of C- for community college applicants or B- for four-year college applicants"
  },
  "1630": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "architecture"
      ],
      "specialRequirements": "Enrolled for Fall semester in designated accredited architecture schools. Home residence within AIA NEI Chapter boundaries (Cook, DuPage, Kane, and Kendall Counties, excluding area within city limits of Chicago, south of Interstate 55, and east of the Edens Expressway). Two scholarships available."
  },
  "1631": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "Visual Arts",
          "Art",
          "Media"
      ],
      "specialRequirements": "Must be currently enrolled at a college or university in Southern California. Work must align with exhibition theme 'Now Trending'. All media types accepted including painting, drawing, printmaking, sculpture, glass, ceramics, fiber art, photography, video, film, virtual reality, augmented reality, installation art, and mixed media."
  },
  "1632": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Texas",
          "California",
          "Colorado",
          "Florida"
      ],
      "requiredMajors": [
          "electrical",
          "automation",
          "instrumentation and controls",
          "cybersecurity",
          "related discipline"
      ],
      "specialRequirements": "Must plan to enroll full-time in an eligible Associate Degree or Trade School program at an accredited two-year college or vocational-technical school. Certification programs must be through an accredited institution on a standard academic semester calendar, minimum one semester/term in length, and recipients must be enrolled at time of disbursement. Awards are not renewable but students may reapply annually if eligible."
  },
  "1633": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Connecticut"
      ],
      "requiredMajors": [
          "environmental science",
          "water resources",
          "public health",
          "water industry"
      ],
      "specialRequirements": "Must be a graduating senior from an accredited Connecticut high school or equivalent. Must be planning to pursue an approved course of study at an accredited higher education institution. Preference given to applicants focusing on environmental science, water resources, public health, or the water industry. Must submit high school transcript and proof of acceptance to an accredited higher education institution (if available)."
  },
  "1634": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFirstGen": true,
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "business",
          "public sciences"
      ],
      "specialRequirements": "Must reside in Miami-Dade County for at least one year prior to applying. Must be aged 17-26. Must be full-time student taking at least 12 credits per semester. Must be admitted to or currently enrolled in a Florida four-year college or university with at least 24 credits completed."
  },
  "1635": {
      "minGPA": 3.25,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "communication"
      ],
      "specialRequirements": "Applicants must be attending a Houston-area institution or from the Houston area. Undergraduate students must be enrolled for minimum 12 hours; post-graduate students minimum 9 hours. Must have completed minimum 6 hours of core classes in major. Overall GPA must be 3.0 or higher. One-time award only."
  },
  "1636": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredActivities": [
          "volunteer-experience",
          "leadership-experience"
      ],
      "specialRequirements": "Must be a full-time student currently attending Cheyney University. Must have verifiable volunteer experience within the past two years. Must demonstrate membership or leadership experience in campus or other organizations. Must be committed to mentoring and promoting Cheyney University's mission and values. Requires one-page essay explaining how applicant will mentor a Cheyenne University student and promote the university's mission and values in professional career."
  },
  "1637": {
      "targetStates": [
          "North Carolina"
      ],
      "specialRequirements": "Must be a Type 1 diabetic student. Must be a resident of North Carolina. Must be enrolled in an accredited college or university in North Carolina. Eligibility based on being T1 diabetic and a short essay."
  },
  "1638": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "South Asian descent (Afghanistan, Bangladesh, Bhutan, India, Maldives, Nepal, Pakistan, Sri Lanka, and people of South Asian origin from the Caribbean)"
      ],
      "requiredMajors": [
          "journalism"
      ],
      "specialRequirements": "Must be enrolled at a university in the U.S. or Canada for upcoming Fall. Must show proof of enrollment. Applicants strongly encouraged to be SAJA members. Must be of South Asian descent OR demonstrate interest in covering South Asia and/or the diaspora. Immediate relatives of SAJA Board members and judges are ineligible."
  },
  "1639": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Washington"
      ],
      "requiredMajors": [
          "engineering",
          "science",
          "technology"
      ],
      "specialRequirements": "Must be accepted into full-time Bachelor of Science (BS) degree program at accredited college/university. High school seniors must graduate from private or public high school in Washington counties bordering Puget Sound (Whatcom, Skagit, Snohomish, King, Kitsap, Pierce, Thurston, Mason, Jefferson, Clallam, Island, San Juan) or be home-schooled and reside in one of these counties. HNTB Corporation STEM Scholarship category limited to students graduating from Rainier Beach HS, Franklin HS, or Highline HS."
  },
  "1640": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "Art"
      ],
      "specialRequirements": "Must be a high school senior in San Joaquin County. Must be pursuing post-secondary education in an art-related field."
  },
  "1641": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be a high school senior in San Joaquin County. Open to students pursuing post-secondary education at a four-year college/university or community college."
  },
  "1642": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "Business"
      ],
      "specialRequirements": "Must be a graduating high school senior at Tracy High School. Must be pursuing an undergraduate degree in Business."
  },
  "1643": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Hispanic",
          "Latino"
      ],
      "targetStates": [
          "California"
      ],
      "targetGenders": [
          "male",
          "female"
      ],
      "specialRequirements": "Must be graduating senior at Franklin High School in Stockton, California. Must be pursuing an undergraduate degree at an accredited college or university. Preference given to applicants who have demonstrated leadership in their community. Two awards available: one for Hispanic/Latino male student and one for Hispanic/Latina female student."
  },
  "1644": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "Veterinary Technician",
          "Veterinary Assistant",
          "Doctor of Veterinary Medicine",
          "related veterinary professional"
      ],
      "requiredActivities": [
          "extracurricular activities"
      ],
      "specialRequirements": "Must be from or alumnus of high school in San Joaquin County. Letter of recommendation from teacher required. Essay required explaining interest in veterinary career. Level 2 applicants must be accepted into or currently attending Doctor of Veterinary Medicine degree program. Graduated applicants may be required to provide proof of high school diploma or equivalent. Award given one time only per recipient."
  },
  "1645": {
      "minGPA": 3.8,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "Business Administration"
      ],
      "specialRequirements": "Must attend high school in San Joaquin County; must provide letter of recommendation from teacher, faculty member, or school counselor; must demonstrate significant volunteer experience in San Joaquin County; must submit essay explaining career ambitions and why pursuing Business Administration degree"
  },
  "1646": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredActivities": [
          "collegiate-sports"
      ],
      "specialRequirements": "Must be a high school senior at a school located in the City of Stockton. Must be accepted to play a collegiate-level sport at an accredited college or university. Must provide a letter verifying acceptance to play sports at the college/university level. Must submit a current letter of recommendation from a coach or teacher. Must write and submit an essay explaining why playing college sports is important to career goals."
  },
  "1647": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetEthnicities": [
          "Black",
          "Indigenous",
          "People of Color"
      ],
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "computer programming",
          "creative arts",
          "data/statistics",
          "marketing",
          "business",
          "communications",
          "program/project management"
      ],
      "specialRequirements": "Must be Minnesota resident. Must be enrolled or planning to enroll full-time (12 credits or more) at college/university/accredited arts school in Minnesota or Wisconsin. Must be in good academic standing. Ogilvy and The Lacek Group employees and relatives are excluded."
  },
  "1648": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Indiana",
          "Illinois",
          "Kentucky"
      ],
      "requiredMajors": [
          "Advertising",
          "Marketing",
          "Graphic Design",
          "Public Relations"
      ],
      "specialRequirements": "Applicant must be graduating from high school or currently attending college in Vanderburgh, Warrick, Posey, Gibson, or Pike counties in Indiana; Edwards, White, Wabash, or Wayne counties in Illinois; or Henderson, Union, or Daviess counties in Kentucky."
  },
  "1649": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "High school students in good standing in the United States or its territories; high school seniors who will graduate this year; essays must be written by students themselves in their own words; students under 18 must have parental or legal guardian consent; only one essay per student allowed; essay must be 500 words or fewer and address the provided essay contest prompt regarding the Supreme Court's 2008 Heller decision"
  },
  "1650": {
      "requiredMajors": [
          "oncology"
      ],
      "specialRequirements": "Must be pursuing a degree through a Bismarck college or be an oncology professional pursuing continuing education"
  },
  "1651": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Oregon",
          "Washington"
      ],
      "specialRequirements": "Must have been diagnosed with cancer before age 21. Must be pursuing undergraduate, technical, or vocational education. Must be current resident of Oregon or Southwest Washington, or if attending school elsewhere, must reside in Oregon or Southwest Washington when not actively boarding at school. Scholarship can only be received once per applicant. If awarded but does not attend school, scholarship may be forfeited."
  },
  "1652": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be a legal California resident graduating high school senior. Must be civic-minded and demonstrate commitment to giving back to community. Must exhibit integrity, respect, and dignity. Must demonstrate willingness to persevere and contribute to community during and after graduation. Students living independently or whose parents/guardians struggle financially are encouraged to apply."
  },
  "1653": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "Must have completed freshman year of bachelor's degree program or be enrolled in graduate program. Emerson employees and their relatives are not eligible. Scholarship recipients are not eligible to reapply. Selection based on merit, leadership potential, and capacity to contribute to STEM professions."
  },
  "1654": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "New Hampshire"
      ],
      "requiredActivities": [
          "athletics"
      ],
      "specialRequirements": "Must attend a New Hampshire high school. Must submit Statement of Commitment (Academic) from school counselor. Must provide two references (coaches, teachers, employers, etc. - parents not allowed). Must submit 2-3 minute video (mp4 or .mov format) responding to: 'How has participation in high school athletics shaped your life?'"
  },
  "1655": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "engineering",
          "public policy",
          "construction management",
          "marketing",
          "IT",
          "transportation-related"
      ],
      "specialRequirements": "Must be enrolled full-time at an accredited four-year college or university for the upcoming academic year. Undergraduate students must have at least 24 completed credits. At least one award reserved for student attending verified HBCU. One award may be designated for graduate student. Selection based on academic record, leadership, activities, work experience, personal statement, and two recommendations. Essay question required."
  },
  "1656": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maine"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be currently attending a Mid-Maine Chamber area high school; have an academic average of at least a 'C'; show evidence of community service and involvement; complete a required essay on citizenship; be enrolled in an accredited New England College or University; maintain 2.0 GPA after first college semester; renewable for up to four years"
  },
  "1657": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Ohio",
          "Michigan"
      ],
      "specialRequirements": "Must graduate by Spring; must apply to a participating career college; requires completion of both Student Application and Nomination Form from an eligible sponsor"
  },
  "1658": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "communications",
          "radio and television broadcasting"
      ],
      "specialRequirements": "Must be permanent resident of Massachusetts; must be enrolled or in process of enrolling at accredited institution (vocational school, 2-year or 4-year college/university); must meet school's full-time student status requirement; school does not need to be located in Massachusetts"
  },
  "1659": {
      "minGPA": 2,
      "requiresFinancialNeed": true,
      "targetStates": [
          "Minnesota"
      ],
      "specialRequirements": "Permanent resident of Washington, Ramsey, or Dakota counties in Minnesota. Actively engaged in community service. Enrolled in a two-year, four-year college, or vocational school."
  },
  "1660": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "North Dakota"
      ],
      "specialRequirements": "Applicants must create a 1-3 minute YouTube video on one of the provided Tobacco Free ND topics. Video entry and completed forms must be emailed before the deadline of 11:59 pm on April 18, 2026."
  },
  "1661": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "sports-design-and-construction"
      ],
      "specialRequirements": "Must be enrolled in or planning to enroll in a program supporting the sports design and construction industry. Must have graduated from high school or its equivalent by July 1st of the scholarship year. Requires transcript, letter of intent, and two letters of recommendation (one from employer/professional, one from teacher/professor/education professional)."
  },
  "1662": {
      "requiresDisability": true,
      "specialRequirements": "Established autism diagnosis required. Must attend accredited U.S. post-secondary institution for Fall and Spring semesters. Full-time enrollment (minimum 6 credits) or working toward certification/accreditation required. Not eligible for students with bachelor's degree or pursuing graduate/postgraduate studies. Not eligible for past OAR scholarship recipients or immediate family members of OAR Board of Directors or Scientific Council. Requires written essay, proof of autism diagnosis (if finalist), and two recommendation letters (one from parent/guardian, one from non-relative)."
  },
  "1663": {
      "requiresDisability": true,
      "targetEthnicities": [
          "Black/African American",
          "Indigenous (Native American, Native Alaskan)",
          "Hispanic/Latino",
          "Asian American/Pacific Islander",
          "Middle Eastern/North African",
          "Multiracial"
      ],
      "specialRequirements": "Established autism diagnosis (DSM-IV or later criteria) required. Must be attending an accredited post-secondary institution in the United States. Must be enrolled full-time (minimum 6 credits) or working toward certification/accreditation. Cannot have already earned a bachelor's degree or be pursuing graduate/postgraduate studies. Not eligible if past recipient of OAR scholarship or immediate family member of OAR Board of Directors or Scientific Council."
  },
  "1664": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "specialRequirements": "Must reside in Fresno, Kern, Kings, San Luis Obispo, Santa Barbara, Ventura, or Tulare counties. Must plan to attend a U.S. accredited 4-year college/university or community college as a full-time freshman in the fall. Household income must be at or below Low to Moderate Income Level (tax return verification required if selected). Employees of Bank of the Sierra and their immediate family members are ineligible. Scholarship funds cover tuition costs only."
  },
  "1665": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California",
          "Illinois",
          "Maryland",
          "Massachusetts",
          "Nevada",
          "New Jersey",
          "New York",
          "Texas",
          "Washington"
      ],
      "specialRequirements": "Must be a high school senior planning to attend a U.S. accredited 4-year college/university or community college as a 1st-year student in Fall 2024. Must provide college acceptance letter if selected. Household income must be at or below the Low Income Level (must provide tax return if selected). Employees of Cathay Bank and their immediate family members are NOT eligible."
  },
  "1666": {
      "minGPA": 2.8,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Hmong American"
      ],
      "specialRequirements": "Blood descendants of Hmong race or ethnically identified as Hmong American; residing in the United States; planning to enroll as 1st-year student in Fall; household income at or below Federal/State/County Low Income Level (tax return required); college acceptance letter required if selected as finalist"
  },
  "1667": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must reside in Los Angeles or Orange County, California. Must plan to enroll as first-year student at UC or CSU in the coming fall (verification required). Household income must be at or below the County Low Income Level (verification required). College acceptance letter required for verification if selected."
  },
  "1668": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "agriculture",
          "dairy-technology",
          "robotics",
          "automation",
          "precision-agriculture"
      ],
      "specialRequirements": "High school applicants must plan to pursue an agriculture-related degree at a two- or four-year college during the coming academic year. College applicants must be enrolled at an accredited institution during the academic year. Applicants must submit a one to two page resume, letter of recommendation, and required essay."
  },
  "1669": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California",
          "Nevada"
      ],
      "requiredMajors": [
          "chemistry",
          "physics",
          "biology",
          "mathematics",
          "engineering"
      ],
      "requiredActivities": [
          "participation in NCCAVS events"
      ],
      "specialRequirements": "Must be enrolled in a 4-year college or university within NCCAVS geographic bounds (California zip codes 93700–96099 and Nevada). Must have a declared major in an AVS-related field. Requires one letter of recommendation and one-page statement of purpose."
  },
  "1670": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California",
          "New York",
          "New Jersey",
          "Texas"
      ],
      "specialRequirements": "Must reside in specific counties (CA: Alameda, Contra Costa, Los Angeles, Marin, Orange, Riverside, San Bernardino, San Francisco, San Mateo; NY: Bronx, Kings, Nassau, New York, Putnam, Queens, Richmond, Rockland, Suffolk, Westchester; NJ: Passaic, Bergen, Hudson; TX: Harris, Fort Bend, Brazoria, Montgomery, Galveston). Household income at or below Low Income Level (tax return required). Planning to attend U.S. Accredited 4-Year College/University or Community College as 1st-year student in coming fall. College acceptance letter required if selected. Employees of Preferred Bank and immediate family members are NOT eligible."
  },
  "1671": {
      "minGPA": 3.3,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be current graduating senior or graduate of a public or private high school in Santa Clara County. Must be currently enrolled or planning to enroll full-time at a four-year California public college (Cal State) or university (UC). Must reside in Santa Clara County."
  },
  "1672": {
      "minGPA": 2.7,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "African American"
      ],
      "requiredActivities": [
          "community service"
      ],
      "targetGenders": [
          "male"
      ],
      "specialRequirements": "Must be accepted into or currently enrolled full-time at an HBCU. High school seniors require minimum 2.7 GPA; current college students require minimum 3.0 GPA. Requires three essays on passion, life-changing moment, and scholarship significance. Requires proof of acceptance or enrollment at HBCU and current academic transcript."
  },
  "1673": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "accounting",
          "business",
          "carpentry",
          "communications",
          "electricity",
          "environmental science",
          "exercise sports science",
          "forestry",
          "graphic design",
          "horticulture",
          "human resources",
          "landscape architecture",
          "marketing",
          "mechanics",
          "occupational safety",
          "therapeutic recreation",
          "tourism development and management"
      ],
      "specialRequirements": "Applicants must live within the boundaries of Waukegan Park District. Must be pursuing a park and recreation related field. Current or former employees or volunteers with the District are highly encouraged to apply."
  },
  "1674": {
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "photography",
          "illustration",
          "graphic design",
          "visual communication"
      ],
      "specialRequirements": "Must be enrolled in a U.S. college or university. Must demonstrate commitment to social change, environmental responsibility, and cultural awareness. Portfolio required demonstrating commitment to social change, environmental responsibility, and cultural awareness."
  },
  "1675": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Connecticut"
      ],
      "requiredMajors": [
          "landscape architecture"
      ],
      "specialRequirements": "Must be a legal resident of Connecticut. Must be enrolled in an accredited landscape architecture program (undergraduate or graduate). Graduating high school seniors may apply if accepted into a qualifying graduate program for the following Fall. Prior award recipients may reapply. Requires transcript, signed statement explaining desire for financial aid and choice of landscape architecture, and one signed recommendation letter."
  },
  "1676": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "DC"
      ],
      "requiredMajors": [
          "IT",
          "Education",
          "Hospitality & Culinary Arts",
          "Health Sciences",
          "Construction & Trades",
          "Public Service",
          "Business"
      ],
      "specialRequirements": "Age 17-29; High school diploma or GED required; Must reside in Washington, DC metropolitan region; Household income at or below 80% of area median income; Must be pursuing an associate degree or professional certification in one of New Futures' Career Pathways; Interview required if selected as finalist"
  },
  "1677": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "New Mexico"
      ],
      "requiredMajors": [
          "engineering",
          "math",
          "science"
      ],
      "specialRequirements": "Individual scholarship criteria vary. Must attend a New Mexico college/university (for university scholarships) or New Mexico high school (for high school scholarships)."
  },
  "1678": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be a high school senior who attends a Coral Springs or Parkland high school, or lives in Coral Springs. Must demonstrate artistic ability. Does not need to be associated with an art class. Application and artwork submissions completed online."
  },
  "1679": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresMilitaryConnection": true,
      "requiredMajors": [
          "Computer Science",
          "Computer Engineering",
          "related technical fields"
      ],
      "specialRequirements": "Must be enrolled or planning to enroll as full-time undergraduate student in the U.S. for the coming academic year. Must maintain strong academic performance. Must be a current student veteran (including National Guard or Reserve members) or on Active Duty with honorable discharge or good standing. Requires DD 214 for veterans, or Active Duty orders and Memorandum of Understanding for those currently serving. Application requires resume/CV, unofficial transcripts, two letters of reference, and essay responses (500 words each)."
  },
  "1680": {
      "targetStates": [
          "Rocky Mountain region"
      ],
      "specialRequirements": "Applicants must live in the Rocky Mountain region. Applicants under the age of 18 at the time of application submission must have their application co-signed by their parent or legal guardian. Association with the mission critical support industry preferred."
  },
  "1681": {
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "architecture"
      ],
      "specialRequirements": "Must be a current resident of Santa Clara County and legal resident of the United States. Must be enrolled in a college or university program leading to a degree in architecture."
  },
  "1682": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "architecture"
      ],
      "specialRequirements": "Legal resident of Santa Clara County; Currently enrolled in undergraduate or graduate program leading to career in architecture on full-time or part-time basis; Undergraduate students must have completed minimum of two years of college work in required major at end of current academic year; Previous recipients are eligible"
  },
  "1683": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Ohio",
          "Kentucky",
          "Indiana"
      ],
      "specialRequirements": "Must attend high school in Foundation's Area of Impact (Greater Cincinnati region); planning to enroll as freshman at eligible Tri-State college or university; must demonstrate strong desire to overcome adversity; acceptance letter from intended college/university required if available; high school transcript required; current family financial information and FAFSA Student Aid Report (SAR) required"
  },
  "1684": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetEthnicities": [
          "minority"
      ],
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "Accounting",
          "Architecture",
          "Business Administration",
          "Communications",
          "Construction Science",
          "Criminal Justice",
          "Education",
          "Engineering",
          "Environmental Science",
          "Finance",
          "Information Technology",
          "Law",
          "Logistics",
          "Management",
          "Marketing",
          "Political Science",
          "Public Administration",
          "Social Work",
          "Sociology",
          "Supply Chain Management",
          "Transportation Management",
          "Urban Planning"
      ],
      "specialRequirements": "Applicant must be from Dallas/Fort Worth region. College students are not eligible. Must be pursuing a career in transportation-related field."
  },
  "1685": {
      "targetGradeLevels": [
          "graduate"
      ],
      "specialRequirements": "Provisional acceptance into accredited undergraduate or graduate program; residency in states within WSRCA service area; affiliation with the roofing industry; must submit academic transcripts and letter of recommendation from non-family member; recipients expected to attend Western States Roofing Contractors Association Annual Convention to accept award"
  },
  "1686": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must be a resident of Kendall or Grundy County; possess a high school diploma or GED; be accepted into an Illinois college or university, or occupational training program on at least a half-time basis"
  },  "1688": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "political science",
          "international relations",
          "economics",
          "international business"
      ],
      "requiredActivities": [
          "demonstrated interest or experience in international trade"
      ],
      "specialRequirements": "Currently enrolled at accredited U.S. college or university. Undergraduates must have junior status or higher. Open to both U.S. and non-U.S. students studying in the U.S. Requires submission of NCITD Scholarship Application Form, resume/CV, unofficial transcript, narrative (up to 2,000 words), and at least one letter of recommendation."
  },
  "1689": {
      "minGPA": 3,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Civil Engineering",
          "Transportation Systems Engineering"
      ],
      "specialRequirements": "Must be a returning undergraduate student at Morgan State University. Must be a first-time undergraduate degree candidate. Must be enrolled full-time in at least 12 credit hours. Must submit essay demonstrating aspirations, commitment to society, and desire to contribute to the transportation field."
  },
  "1690": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Colorado",
          "Wyoming"
      ],
      "specialRequirements": "Must have lost a parent or family member to Parkinson's Disease, or be experiencing financial hardship due to a family member living with Parkinson's Disease. Must maintain 3.0 GPA after receiving scholarship. Requires submission of transcript, confirmation of eligibility (obituary, death certificate, or doctor's note), and two essays on the impact of Parkinson's Disease and educational/long-term goals."
  },
  "1691": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Texas"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Applicants must be female legal residents of Texas in their final year of high school, current college undergraduate, or graduate students"
  },
  "1692": {
      "minGPA": 2,
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must have been a resident of Ventura County at one time. Must have completed high school. Preference given to students under 30. Open to all regardless of sex, age, race, national origin, religion, or political affiliation. Renewable yearly upon reapplication and approval."
  },
  "1693": {
      "targetStates": [
          "Alaska",
          "American Samoa",
          "Arizona",
          "California",
          "Colorado",
          "Guam",
          "Hawaii",
          "Idaho",
          "Kansas",
          "Montana",
          "Nevada",
          "New Mexico",
          "North Dakota",
          "Northern Mariana Islands",
          "Oklahoma",
          "Oregon",
          "South Dakota",
          "Utah",
          "Washington",
          "Wyoming"
      ],
      "requiredActivities": [
          "art"
      ],
      "specialRequirements": "Must be a high school student or home-schooled student in eligible state/territory. Must create original artwork inspired by their state. Selection based on artistic ability. One finalist selected from each state/territory to compete at regional level for First, Second, Third Place, and People's Choice awards."
  },
  "1694": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Hispanic/Latino"
      ],
      "specialRequirements": "Must be high school senior enrolled in a York County high school or non-traditional student with proof of high school or GED completion; must be of Hispanic/Latino heritage; must attach letter of acceptance from college/university; must attach transcript and letters of recommendation; must attach two essays in response to provided questions"
  },
  "1695": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania",
          "Ohio",
          "West Virginia"
      ],
      "requiredMajors": [
          "petroleum engineering",
          "chemical engineering",
          "mechanical engineering",
          "environmental engineering",
          "civil engineering",
          "energy industry-related fields"
      ],
      "specialRequirements": "Must score at least composite 27 on ACT or minimum 600 in Math and 600 in Critical Reading on SAT. Must be enrolled in an accredited college in Pennsylvania, Ohio, or West Virginia. Must submit fully completed and signed AADE Scholarship Application."
  },
  "1696": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "American Indian",
          "Alaska Native",
          "Native Hawaiian"
      ],
      "requiredMajors": [
          "hospitality",
          "tourism",
          "recreation",
          "culinary arts",
          "related fields"
      ],
      "specialRequirements": "Tribal Enrollment, Certificate of Indian Blood, or Tribal ID required (Native Hawaiians may use birth certificates); recent transcript (unofficial acceptable); high school diploma or GED documentation (if applicable); proof of admission to college/university/technical school; high resolution headshot; essay of at least 500 words. Scholarships must be used for books and/or tuition. PhD degrees not eligible. Online colleges applicable."
  },
  "1697": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "environmentally-related field"
      ],
      "specialRequirements": "Must be from service area counties (Allegheny, Armstrong, Butler, Beaver, Fayette, Washington, or Westmoreland). Must submit resume, 500-word personal statement, 500-1,000 word essay on critical environmental issue, official transcripts, and letter of recommendation from person with whom applicant has interacted in environmentally-related activities/courses."
  },
  "1698": {
      "targetStates": [
          "New Jersey"
      ],
      "requiredMajors": [
          "Air Conditioning, Plumbing and Heating Technology",
          "Electrician Training",
          "Masonry",
          "Carpentry",
          "Construction Materials Handling",
          "Job-Site Supervision",
          "Construction Planning",
          "Surveying",
          "Construction Information Management",
          "Construction Business Management",
          "Construction Management",
          "Construction Technology"
      ],
      "specialRequirements": "Must live in or attend school in Atlantic, Burlington, Camden, Cape May, Cumberland, Gloucester, or Salem counties. Must be matriculating in an accredited post-secondary school. Eligible for trade school, junior college, four-year university, and part-time enrollment programs."
  },
  "1699": {
      "targetEthnicities": [
          "Native American"
      ],
      "requiredMajors": [
          "Anthropology"
      ],
      "specialRequirements": "Must be enrolled in an accredited Anthropology program. Field school should be through a university or college."
  },
  "1700": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Pennsylvania",
          "New Jersey",
          "Delaware"
      ],
      "requiredMajors": [
          "STEM",
          "business",
          "technical trades"
      ],
      "specialRequirements": "Must reside in Pennsylvania, New Jersey, or Delaware. Must be a high school senior or enrolled full-time at an accredited college, university, or trade school. Must provide proof of full-time enrollment for the coming academic year. Must submit essay response, letters of recommendation, and proof of GPA. Selected recipients must submit headshot and short acceptance video by May 24th."
  },
  "1701": {
      "targetGradeLevels": [
          "college-freshman"
      ],
      "targetStates": [
          "NC"
      ],
      "specialRequirements": "Must be a resident of one of these North Carolina counties: Alamance, Caswell, Chatham, Durham, Franklin, Granville, Harnett, Johnston, Lee, Moore, Nash, Orange, Person, Vance, Wake, or Wilson. Must be accepted to and registered as a first-year college student (four-year or community college) for the coming academic year. Must be no more than 25 years of age at the time of scholarship presentation. Proof of acceptance and registration required."
  },
  "1702": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredActivities": [
          "citizenship-demonstration",
          "community-involvement"
      ],
      "specialRequirements": "Must be a high school senior in Portsmouth or Norfolk (including home schooled students). Proof of enrollment in a post-secondary institution required each year. Funds dispersed in $1,500 annual increments over 4 years. One award per public high school in Portsmouth and Norfolk, plus one home schooled senior from each city (9 awards total)."
  },
  "1703": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be a resident of Richton Park. Must submit two recommendation letters, transcript, two documents providing proof of residency (including driver's license or State ID plus one additional form of ID showing address), and an essay stating qualifications and educational and career goals."
  },
  "1704": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Nebraska"
      ],
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "Must be a Nebraska high school senior accepted at a Bio Nebraska approved Nebraska college, community college, or university; must be planning to enroll in an undergraduate STEM-related course of study; must plan to pursue a career with a STEM-related organization. Up to 2 awards available."
  },
  "1705": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "students of color"
      ],
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "Aviation",
          "Maritime",
          "Real Estate",
          "Business Administration",
          "Accounting",
          "Architecture",
          "Engineering",
          "Finance",
          "Diversity",
          "Human Resources"
      ],
      "requiredActivities": [
          "community service or employment outside of school"
      ],
      "specialRequirements": "Must be a resident or school attendee in City of Boston or Massport's Neighboring Community (East Boston, South Boston, Chelsea, Charlestown, Winthrop, Revere, Worcester, Lexington, Lincoln, Concord, Bedford). Must be accepted to an accredited college or university. Requires 1000-word essay, community service/employment description, proof of residency, high school transcript with official seal, college acceptance letter, and 2 letters of recommendation (one from community service agency or employment supervisor)."
  },
  "1706": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "CT",
          "MA",
          "ME",
          "NH",
          "RI"
      ],
      "requiredMajors": [
          "Drinking Water",
          "Water Engineering",
          "Environmental Studies",
          "Waste Water"
      ],
      "specialRequirements": "Must be a graduating high school senior from an accredited school in CT, MA, ME, NH, or RI. Preference given to students pursuing studies in Drinking Water, Water Engineering, Environmental Studies, or Waste Water. Relevance and rigor of high school courses considered. Application requires completed application form, official transcript including first half of senior year, and typed and signed autobiographical sketch highlighting accomplishments, interests, hobbies, future plans, chosen field of study, its environmental or public health impact in the water industry, and the scholarship's importance/impact."
  },
  "1707": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "NH"
      ],
      "requiredMajors": [
          "Civil Engineering",
          "Structural Engineering",
          "Mechanical Engineering",
          "Electrical Engineering"
      ],
      "specialRequirements": "Must be enrolled in or planning to enroll in an ABET-EAC accredited engineering program. In-state (NH) residency required. Preference given to students planning to attend a New Hampshire university or college. Applicants must submit a recommendation letter and a statement (maximum 200 words, double-spaced) about interest in engineering and intended occupation after graduation."
  },
  "1708": {
      "targetGradeLevels": [
          "college-sophomore"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Engineering"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be currently enrolled at one of the following institutions: Bradley University (Peoria), Illinois Central College (Peoria), Kaskaskia Community College (Centralia), Rend Lake Community College (Centralia), Southern Illinois University (Carbondale), Southern Illinois University (Edwardsville), or University of Illinois at Urbana-Champaign. Must attend one of the following institutions for engineering upon receipt of award: Bradley University (Peoria), Southern Illinois University (Carbondale), Southern Illinois University (Edwardsville), University of Illinois at Chicago, or University of Illinois at Urbana-Champaign. Must confirm attendance in an approved engineering program upon receipt of award."
  },
  "1709": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Chinese"
      ],
      "targetStates": [
          "Oregon"
      ],
      "requiredActivities": [
          "community-service",
          "leadership"
      ],
      "specialRequirements": "Must be at least 25% Chinese in ethnicity. Must be a graduating senior from an Oregon high school with at least two years of attendance in the state. Must plan to attend an accredited U.S. college or university. Community service and leadership activities must be verifiable by organizations. Scholarships awarded based on academic performance, community service, leadership activities, cultural activities, financial need, and/or athletic participation."
  },
  "1710": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Connecticut",
          "Maine",
          "Massachusetts",
          "New Hampshire",
          "Rhode Island",
          "Vermont"
      ],
      "requiredMajors": [
          "Science",
          "Technology",
          "Engineering",
          "Mathematics"
      ],
      "specialRequirements": "Must be a resident of New England. Must attend a school in the US. Must submit transcript, resume (indicating STEM employment where applicable, civic/volunteer work, honors/awards), and essay describing interest in STEM-related career within defense sector. Student must submit application directly and be willing to connect with Scholarship Committee if necessary."
  },
  "1711": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "New York"
      ],
      "specialRequirements": "Must be a NYC resident. Must be entering college in the coming Fall. Must demonstrate commitment to personal growth, leadership, and resilience. Must submit 500-750 word essay. Optional: 2-3 minute video and recommendation letter."
  },  "1713": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "Hispanic/Latino"
      ],
      "specialRequirements": "Must be enrolled in a college at least 200 miles from designated home; must be in good academic standing as determined by college; must be 18 years old or older at time of application; must identify direct or parental ties to a specific country to determine Hispanic/Latino origin"
  },
  "1714": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Texas"
      ],
      "requiredActivities": [
          "cross-country-running"
      ],
      "specialRequirements": "Must be a high school cross country runner attending a high school in Austin, Brazoria, Chambers, Fort Bend, Galveston, Harris, Liberty, Montgomery, or Waller County. Must plan to enroll at a Texas college or university. Award distributed over 4 years ($2,500 per year). Three awards available annually."
  },
  "1715": {
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "music"
      ],
      "requiredActivities": [
          "music performance"
      ],
      "specialRequirements": "Must be from Sarasota-Bradenton area (includes local students pursuing music degrees out-of-town and music students at SWFL colleges/universities). In-person audition required at St. Boniface Episcopal Church. Artistic ability and current year in school are selection criteria. Ensembles welcome; scholarship divided evenly among members."
  },
  "1716": {
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "journalism",
          "photojournalism",
          "public relations",
          "communications"
      ],
      "specialRequirements": "Applicant must be a Virginia college student or Virginia resident attending an out-of-state college. Must be planning a career in journalism, photojournalism, public relations or another related communications field."
  },
  "1717": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "college-sophomore"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "underrepresented-communities"
      ],
      "requiredMajors": [
          "Economics",
          "Business",
          "STEM"
      ],
      "requiredActivities": [
          "leadership",
          "community-service"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be attending an accredited university on a full-time basis; completing sophomore year; have declared major in Economics, Business, or STEM; demonstrated commitment to diversity, inclusion, and equity; scholarships must be applied to junior year expenses; CRA employees and their dependents are ineligible"
  },
  "1718": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "hispanic",
          "latinx",
          "chicanx"
      ],
      "targetStates": [
          "colorado"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be between ages 18-22 as of the specified award date. Must not be married (including common law), divorced, or have had an annulment. Must not have or be expecting a child. Must be a Colorado resident for at least 6 months prior to application deadline. Must be enrolled/accepted to and attend an institution of higher learning for the coming academic year. Must submit complete Fiesta Pageant application, official high school or college transcript, resume, and minimum of 2 signed letters of recommendation."
  },
  "1719": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must be 19 years of age or older; must live and attend school in Illinois; must be enrolled full-time (12 hours); must be in good standing with the Secretary of State; must identify as low-income; must receive TANF and/or SNAP benefits; must have a minor child under age 18"
  },
  "1720": {
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "specialRequirements": "Must be aged 17 or older. Must have a rare disease (affecting fewer than 200,000 people in the U.S.), either diagnosed by a physician or undiagnosed. Must plan to enroll in an accredited college, university, or trade school in the coming academic year. Requires Diagnosis Verification Form from a licensed physician. Essay required describing personal journey and educational goals, including information about leadership, extracurricular activities, work experience, academic performance, and financial need."
  },
  "1721": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresMilitaryConnection": true,
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "ROTC"
      ],
      "specialRequirements": "Must be enrolled in accredited public or private high school or homeschool program in Virginia; must plan to pursue ROTC program at Virginia college or university leading to US Military Service career; unweighted minimum GPA of 2.75 required"
  },
  "1722": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "African descent",
          "Latino/Hispanic",
          "Native North American",
          "Pacific Islander"
      ],
      "requiredMajors": [
          "actuarial science",
          "data science",
          "computer science",
          "economics",
          "programming"
      ],
      "specialRequirements": "At least one birth parent must be a member of one of the specified ethnic groups. Must be a high academically achieving student. Must plan to enroll in full-time undergraduate study at an accredited or bona fide college or university. Awards are not automatically renewed but students may reapply each year if eligible. 15-25 awards available."
  },
  "1723": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be incoming freshman from Duval, Nassau, St. Johns, Clay, or Baker counties in Florida. Must attend University of Georgia. Scholarship is renewable if student maintains accepted academic criteria."
  },
  "1724": {
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior"
      ],
      "targetStates": [
          "Texas"
      ],
      "specialRequirements": "Must be enrolled in a public or private high school in Texas; essay must be original work; only one entry per student per year; winners must provide documentation of enrollment status; winners must agree to submit biography for publication; winners must create a UT EID and provide payment address; essay must not exceed 4,000 characters (approximately 750-800 words)"
  },
  "1725": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be on track to graduate from one of D91's four high schools or be a former D91 graduate currently pursuing post-secondary education. Must submit resume and participate in a short 5-question in-person interview (tentatively scheduled late April/early May). Award must be used within four years or funds are forfeited."
  },
  "1726": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Idaho"
      ],
      "specialRequirements": "Must be a senior at one of Idaho Falls School District 91's high schools. Must be pursuing higher education at eligible Idaho colleges or universities. Evaluation based on GPA, financial need, school involvement, community engagement, and future promise."
  },
  "1727": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-sophomore",
          "college-junior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Idaho"
      ],
      "specialRequirements": "Must be graduating senior from or have graduated from Idaho Falls School District 91 school, OR be current sophomore/junior at approved Idaho post-secondary institution/training program and never previously awarded this scholarship. At least one award annually goes to a graduating D91 high school senior."
  },
  "1728": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "targetStates": [
          "Hawaii"
      ],
      "requiredMajors": [
          "hotel management"
      ],
      "specialRequirements": "Must be accepted into a hotel management program at an accredited university or college. Must submit transcript, recommendation letter (from professor, counselor, or dean), and personal statement (500 words maximum) addressing an assigned topic. Renewable upon maintaining minimum 3.0 GPA."
  },
  "1729": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Colorado"
      ],
      "specialRequirements": "Must be a resident of Aurora, Colorado. Must be enrolled in at least 6 credits per semester. Must be currently enrolled or planning to enroll at an accredited Colorado college or university."
  },
  "1730": {
      "minGPA": 3.4,
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiredMajors": [
          "transportation",
          "travel",
          "tourism"
      ],
      "specialRequirements": "Must attend an accredited four-year university/college or junior college. Must have a declared major or course of study related to transportation, travel, or tourism. Open to both ABA members and non-members. Requires submission of official transcript and short essay explaining relevance of major to the transportation, travel, and tourism industries."
  },
  "1731": {
      "targetEthnicities": [
          "traditionally underrepresented groups"
      ],
      "requiredMajors": [
          "transportation",
          "travel",
          "tourism"
      ],
      "specialRequirements": "Applicants must submit a 500-word essay discussing the role they hope to play in advancing the future of the transportation, motorcoach, travel, and tourism/hospitality industry. Eligible candidates must have a declared major or course of study relevant to the transportation, travel, and tourism industry."
  },
  "1732": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "American Indian",
          "Alaska Native",
          "Native Hawaiian",
          "Pacific Islander",
          "Indigenous Canadian"
      ],
      "specialRequirements": "Must be enrolled citizen or decedent of enrolled citizen of federal or state recognized American Indian Tribe, Alaska Native Village, Native Hawaiian, Pacific Islander, or Indigenous person of Canada. Must maintain 2.75 GPA freshman/sophomore years and 3.0 GPA junior/senior years to receive all four years of funding."
  },
  "1733": {
      "minGPA": 3,
      "targetStates": [
          "Maryland"
      ],
      "requiredMajors": [
          "Nursing",
          "Allied Health"
      ],
      "specialRequirements": "Must be a full-time student accepted at an accredited school of nursing or other allied health curriculum. Preference given to residents of specific Maryland counties. Must reapply each year. Recipients not required to repay or accept employment."
  },
  "1734": {
      "minGPA": 3,
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "marketing",
          "advertising",
          "graphic arts",
          "media"
      ],
      "specialRequirements": "Must be attending college/university in greater Houston area or have graduated from high school in greater Houston area. Must be enrolled full-time at accredited 2-year or 4-year institution. Essay required (750+ words) on career goals and impact of scholarship. Minimum 2 recommendations from qualified non-family adults required. Proof of enrollment and official transcript required. Marketing coursework samples required."
  },
  "1735": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "For Veterans Scholarship: Must have served in active military, naval, or air service with Honorable Discharge or General Discharge Under Honorable Conditions. For High School Graduate Scholarship: Must be high school senior graduating from or have graduated from a school within the Lehigh Valley and intend to major in STEM. Both scholarships require enrollment or acceptance to a two or four-year post-secondary institution in the Greater Lehigh Valley Area."
  },
  "1736": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New Hampshire"
      ],
      "requiredMajors": [
          "engineering"
      ],
      "specialRequirements": "Must be a resident of New Hampshire, current senior in a New Hampshire high school, and have applied to and been accepted by a four-year engineering program. Must submit transcript, letter of reference from teacher or civil engineer, and two-page maximum double-spaced essay with 12-point font including student name, address, email, and high school on first page."
  },
  "1737": {
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "construction"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must identify as female. Must be a Minnesota resident or enrolled in a postsecondary school in Minnesota. Must be pursuing a career in the construction industry. Three scholarship categories available: Apprentice, Academic – Trades Diploma, and Academic – Bachelor's Degree. Scholarships are non-renewable but eligible students may reapply each year."
  },
  "1738": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be diagnosed with cancer. Must be a California resident. Must be a high school senior entering college/university or currently enrolled in college/university. Must submit personal essay explaining how cancer has affected applicant and/or community impact. Must submit completed application form, official or unofficial transcript, one letter of recommendation, proof of enrollment, and letter of diagnosis from doctor."
  },
  "1739": {
      "minGPA": 3,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Automotive",
          "Aviation",
          "Carpentry",
          "Construction",
          "Electrical",
          "Heavy Equipment",
          "HVAC",
          "Machinery",
          "Manufacturing",
          "Plumbing",
          "Welding"
      ],
      "specialRequirements": "Must be enrolled or plan to enroll full-time in vocational/technical school or 2-year college for fall semester. Must be pursuing certification or degree in skilled trade program. Proof of enrollment in accredited school required."
  },
  "1740": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "Community/Urban Forestry",
          "Arboriculture",
          "related fields"
      ],
      "specialRequirements": "Must reside in or attend school in Bradford, Lackawanna, Luzerne, Pike, Sullivan, Susquehanna, Tioga, Wayne, or Wyoming counties, OR be an NTHA member. Must provide three references (including one from outside school). Must submit proof of acceptance to a technical school, college, or university."
  },
  "1741": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Black/African American",
          "Native American/American Indian",
          "Hispanic/Latin American",
          "Asian or Pacific Islander"
      ],
      "specialRequirements": "Must be entering a four-year college or university. Family income must be at or below the national poverty level based on family size (verified through Department of Health and Human Services website). Requires three letters of recommendation from teachers, guidance counselors, principals, employers, or community service representatives (not family members). Application must be completed in black or blue ink with official high school transcript and college transcript if applicable."
  },
  "1742": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Washington"
      ],
      "specialRequirements": "One $2,424 scholarship for Fife HS seniors. Two $1,024 scholarships for high school seniors at any school in Washington State. One $1,024 scholarship for college/technical school students who previously received a CTS scholarship."
  },
  "1743": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Alabama",
          "Georgia",
          "Tennessee"
      ],
      "requiredMajors": [
          "architecture",
          "engineering",
          "construction management"
      ],
      "specialRequirements": "Must have completed at least one full academic year of studies. Must have at least one full academic year remaining before completing the degree. Must be enrolled in an A/E/C degree program or related field in Alabama, Georgia, or Tennessee. Eligible engineering fields include civil, mechanical, and structural engineering."
  },
  "1744": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "construction management",
          "program management"
      ],
      "specialRequirements": "Must be full-time student taking at least 12 credits. Program must be accredited by ABET or ACCE."
  },
  "1745": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Colorado"
      ],
      "specialRequirements": "Must be at least 25 years old by April 30th. Colorado resident for at least 12 months. Must reside in Colorado while earning degree. Must be enrolled in or attending an accredited college or university. Can be earning a certification or any type of degree. Must provide transcript with GPA. Must demonstrate academic ability, leadership skills, career goals, and community involvement."
  },
  "1746": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maine",
          "New Hampshire",
          "Massachusetts"
      ],
      "requiredMajors": [
          "healthcare-related"
      ],
      "specialRequirements": "Must be a resident of Maine, New Hampshire, or Massachusetts. Must be a high school senior pursuing post-secondary education in a healthcare major."
  },
  "1747": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Delaware"
      ],
      "requiredMajors": [
          "Environmental Studies",
          "Engineering",
          "Environmental Education",
          "Sustainability",
          "Environmental Science"
      ],
      "specialRequirements": "Must be a Delaware resident; must be a senior in a Delaware high school, homeschool, or veteran of the U.S. armed services; must attend an accredited university or college; renewable based on maintaining 3.0 GPA and completing DSWA renewal form"
  },
  "1748": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "pennsylvania"
      ],
      "specialRequirements": "Current resident of Franklin Regional School District with minimum 1 year residency. Minimum GPA varies by level: high school senior 2.5, college freshman 2.75, college sophomore/junior 3.0. Must be enrolled in accredited higher education program (college, university, junior college, trade, or technical school). Must demonstrate record of extracurricular, volunteer, or work involvement. Both full-time and part-time students eligible. Traditional and non-traditional students welcome. Graduate students ineligible. AI assistance in application strictly prohibited."
  },
  "1749": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Applicant must be a survivor of a life-threatening illness (cancer, heart disease, or other life-threatening disease). Applicants cannot have received this scholarship previously. Applications open March 1 and close April 30 of the year applicant graduates high school."
  },
  "1750": {
      "targetGradeLevels": [
          "high-school-freshman",
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "targetStates": [
          "Georgia",
          "North Carolina"
      ],
      "requiredActivities": [
          "comics",
          "graphic novels"
      ],
      "specialRequirements": "Must be in grades 9-12. Must demonstrate interest in comics or graphic novels. Must submit original work verified by sponsoring school staff member. Application requires: short essay (up to 500 words), 3-6 pieces of original comic-related artwork, 3-6 page comic script with story synopsis, panel descriptions, dialogue, and visual direction, and contact information for sponsoring teacher/staff member/media specialist/librarian."
  },
  "1751": {
      "minGPA": 2.5,
      "targetStates": [
          "Maryland"
      ],
      "requiredMajors": [
          "Medicine"
      ],
      "specialRequirements": "Must be a graduate of a Calvert County high school. Must be admitted to an accredited medical school at the time of application. Requires three references with completed online reference questionnaires. Must submit official high school and/or college transcripts and proof of acceptance to an accredited medical school. Applicants selected without regard to race, creed, color, religion, or gender."
  },
  "1752": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "African-American"
      ],
      "targetStates": [
          "New York"
      ],
      "specialRequirements": "Must reside in East Kings County Alumnae Chapter service areas of eastern Brooklyn, New York City. Must plan to enroll in a four-year college or university."
  },
  "1753": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "specialRequirements": "Must reside within 300-mile radius of St. Louis; must be enrolled or planning to enroll at an accredited college, university, vocational, or technical school in the U.S.; must be enrolled in minimum of 12 credit hours per semester; must demonstrate impact of MS on life; preference given to those within 300 miles of St. Louis; requires proof of registration and residency before fund distribution; requires personal essay (max 500 words), two letters of reference, and official transcript"
  },
  "1754": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetEthnicities": [
          "Black",
          "African American",
          "Caribbean American"
      ],
      "specialRequirements": "Must be a direct descendant of African people who were enslaved in the United States or the Caribbean. Must reside within the Episcopal Diocese of Long Island (Brooklyn, Queens, Nassau, or Suffolk). Applicants do not have to be Episcopalian to apply. Recipients may qualify for a second-semester award upon maintaining a minimum 3.0 GPA."
  },
  "1755": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "computer and video game arts",
          "computer and video game sciences"
      ],
      "specialRequirements": "Must be enrolled full-time in an undergraduate program at an accredited four-year U.S. college or university in the upcoming Fall. Must be a woman or member of an under-represented group."
  },
  "1756": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "green-building",
          "sustainable-design",
          "sustainability-related-disciplines"
      ],
      "specialRequirements": "Must be a Florida resident attending a Florida public or private college/university. Must be entering junior or senior year of undergraduate study, or enrolled in graduate or qualifying trade school program. Must submit narrative (max 500 words), two letters of reference (one academic, one character), and official transcript."
  },
  "1757": {
      "minGPA": 3.05,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "environmental studies",
          "natural science"
      ],
      "specialRequirements": "Must reside in Boone, Lake, McHenry or Kane counties in Illinois. Must plan to attend an accredited college or university. Must submit at least one signed letter of recommendation from a non-relative, a 300-400 word typed essay (12-point font), and sealed official transcripts from high school registrar."
  },
  "1758": {
      "minGPA": 3,
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "health-sciences"
      ],
      "specialRequirements": "Must be a member of a traditionally underrepresented group in the health sciences. Must be pursuing a health-related undergraduate degree from an accredited U.S. or Puerto Rican institution. Additional preference given to students pursuing mental health, rehabilitative, geriatric specialties, or supporting individuals with disabilities."
  },
  "1759": {
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "targetStates": [
          "Illinois",
          "Indiana",
          "Kentucky",
          "Ohio"
      ],
      "requiredMajors": [
          "engineering",
          "data analysis",
          "smart traffic systems",
          "ITS-related disciplines"
      ],
      "specialRequirements": "Must attend college or university in Illinois, Indiana, Kentucky, or Ohio. Must submit essay (maximum 3 pages), up to three letters of reference from professors or industry professionals, and demonstrate academic achievement and ITS-related work or research. Winner must provide post-award testimonial on use of funds."
  },
  "1760": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "Hispanic/Latino"
      ],
      "targetStates": [
          "Texas"
      ],
      "specialRequirements": "U.S. citizenship is not required. Open to all degree levels including doctorates. Must reside in Texas."
  },
  "1761": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must be enrolled full-time with at least 12 credit hours if in postsecondary education. Must submit an original essay of 800-1,600 words addressing the assigned topic about government and private sector partnerships improving sanitation access and infrastructure. International students are eligible. Essay must be original and may be subject to AI detection and plagiarism scanning."
  },
  "1762": {
      "minGPA": 3.1,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be accepted to and planning to attend UCF as a full-time student; graduated from any high school in Orange, Osceola, or Seminole County in Florida; minimum SAT score of 1210 (Reading + Math) or ACT composite score of 25; demonstrate Jewish and other community involvement during high school"
  },
  "1763": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "Medicine",
          "Mental Health",
          "Teaching",
          "caregiving professions"
      ],
      "specialRequirements": "Must be 18 years of age or older at date of application submission. Must be accepted to or enrolled as a full-time student in an accredited U.S. program. Personal statement required detailing goals and reasons for pursuing a career in a caregiving profession. Only online applications accepted."
  },
  "1764": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresMilitaryConnection": true,
      "targetEthnicities": [
          "jewish"
      ],
      "targetStates": [
          "michigan"
      ],
      "specialRequirements": "Must identify as Jewish. Must be currently serving in U.S. Armed Forces (active duty, active duty for training, National Guard, Reserve Component, or ROTC contracted), honorably discharged veteran of any U.S. uniformed service, or lineal descendant of a Jewish veteran. Must be accepted by and committed to attend an eligible four-year college or accredited trade/vocational program. Trade or vocational programs must be accredited by the Council on Occupational Education."
  },
  "1765": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Washington, D.C."
      ],
      "specialRequirements": "Must be graduating from a Washington, D.C. public or charter high school; must be accepted and enrolled full-time at an accredited four-year institution for the coming Fall; participation in school and community activities required; two letters of recommendation required (one must be from teacher, counselor, or administrator); official high school transcript required"
  },
  "1766": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must reside within Long Beach Unified School District boundaries. Must have valid social security number. Must plan to attend Long Beach City College or California State University, Long Beach. Must maintain enrollment of at least 12 credits per semester."
  },
  "1767": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "targetStates": [
          "TX"
      ],
      "specialRequirements": "Must have epilepsy, be under physician's care, and currently undergoing treatment and/or taking anticonvulsant medications. Must reside in one of 79 Central & South Texas counties. Must be in good standing. Must submit: transcript, physician's statement, letter of reference, and verification of college/university acceptance. Must demonstrate struggle to overcome adversity due to epilepsy and have a vision for career pursued through higher education."
  },
  "1768": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "specialRequirements": "Must be enrolled or accepted to an accredited college or university. Must be diagnosed with a qualifying disability or special need. Scholarship funds sent directly to college/school account, not to student. Ineligible: Fund members/administrators/selectors and past recipients."
  },
  "1769": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Chinese"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must be enrolled full-time (minimum 12 units/semester for undergraduate or 8 units/semester for graduate students) at an accredited 4-year college, university, or community college in the United States. Graduate students must maintain a 3.7 GPA. Must reside in eligible Southern California counties."
  },
  "1770": {
      "minGPA": 2.7,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "minority",
          "person-of-color"
      ],
      "targetStates": [
          "DC",
          "Maryland",
          "Virginia"
      ],
      "specialRequirements": "Must be a minority or person of color; resident of Washington D.C., Maryland or Virginia; demonstrate extracurricular activity at school, community or church; submit official sealed transcript; provide proof of acceptance to an accredited HBCU, Community College, Vocational, Technical or Trade School; submit two letters of recommendation highlighting outstanding leadership qualities; submit typed 250-500-word essay on topic: 'How does the determination of the Montford Point Marines help impact your decision to further pursue your education?'; if awarded, copy of registration or class schedule required to verify enrollment"
  },
  "1771": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiresDisability": true,
      "targetStates": [
          "Illinois"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be legally blind; must be at least 18 by the beginning of July; must demonstrate academic excellence and leadership; must be enrolled full-time in accredited institution; must submit proof of legal blindness, academic records, and letters of recommendation; finalists must attend entire NFBI state convention (may be virtual)"
  },
  "1772": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Nebraska"
      ],
      "specialRequirements": "Must be graduating high school senior from Nebraska high school; must submit proof of high school senior status (transcript); must submit proof of full-time enrollment in college or university for Fall Semester (acceptance letter); must submit résumé; must submit two letters of reference; must submit 300-500 word essay on why applicant aspires to pursue career in pet industry or animal health"
  },
  "1773": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "daca"
      ],
      "targetStates": [
          "New Mexico"
      ],
      "requiredMajors": [
          "social-work",
          "counseling",
          "psychology",
          "psychiatry",
          "substance-abuse",
          "mental-health"
      ],
      "specialRequirements": "Must be enrolled full-time in a behavioral health degree program. Must be accepted and enrolled full-time for the coming academic year. Recipients must commit to working in behavioral health in New Mexico for two years after graduation. Recipients must provide 20 voluntary service hours to NLBHA for every $1,000 awarded."
  },
  "1774": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "targetEthnicities": [
          "Black/African American",
          "Hispanic",
          "Native American",
          "Native Hawaiian",
          "Pacific Islander"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "Must be accepted to a four-year college or university. Must reside or attend school in Bucks, Chester, Delaware, Montgomery, or Philadelphia counties. Priority given to applicants from underrepresented groups. Must attend Scholarship Banquet on May 14. Must submit official transcript/report card and college acceptance letter. Must submit 300-500 word essay."
  },
  "1775": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "forest management",
          "forest products",
          "closely related field"
      ],
      "specialRequirements": "Must be graduating or have graduated from high school or lived in one of the following Pennsylvania counties: Bradford, Sullivan, Susquehanna, Tioga, Wyoming, Pike, Wayne, Lackawanna, or Luzerne. Must be incoming or current student at a two or four year college or university."
  },
  "1776": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Kansas"
      ],
      "requiredMajors": [
          "wildlife",
          "nature-based curriculum",
          "outdoors journalism"
      ],
      "specialRequirements": "Must attend a Kansas college. Must show proof of full-time enrollment (minimum 12 credit hours) to receive funds. High school seniors must be enrolled in a Kansas high school and plan to attend a Kansas college."
  },
  "1777": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "targetStates": [
          "Nebraska"
      ],
      "requiredMajors": [
          "veterinary-medicine",
          "veterinary-technology",
          "animal-health"
      ],
      "specialRequirements": "Four separate scholarships available: Nebraska High School Scholarship, Undergraduate Scholarship, Veterinary Technology Scholarship, and Veterinary Medicine Scholarship. Open to veterinary students, vet techs, and other future animal health professionals."
  },
  "1778": {
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "specialRequirements": "Must be enrolled in an accredited U.S. undergraduate program for the coming academic year. Open to students regardless of major. AT&T employees and their family members may apply. Application window: February 1 - April 30. Incomplete applications will not be considered."
  },
  "1779": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Colorado"
      ],
      "specialRequirements": "Must be permanent resident of Colorado; must primarily reside in Colorado while attending school; must be between 17 and 40 years of age; must carry course load of at least 9 credit hours; must maintain satisfactory academic progress; minimum award of $1,000 per recipient per year; renewal opportunities available for students meeting qualification guidelines"
  },
  "1780": {
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "cosmetology",
          "hair design",
          "barbering"
      ],
      "specialRequirements": "Must be 18 years or older by program start date. Must be newly accepted or currently enrolled in an accredited cosmetology, hair design, or barbering program leading to licensure in the U.S. Must submit proof of enrollment/acceptance letter and a 3-minute maximum YouTube video answering specified questions about obstacles faced, career motivation, and financial constraints."
  },
  "1781": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "Land Surveying",
          "Surveying Technology"
      ],
      "specialRequirements": "Enrolled in or accepted to a two-year Surveying Technology Program or a four-year Bachelor of Science Program in Land Surveying. Must submit SAT scores and high school or college transcripts with completed transcript release."
  },
  "1782": {
      "minGPA": 3,
      "targetEthnicities": [
          "Hispanic/Latino"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be attending, enrolled in, or accepted into an accredited post-high school institution. Must be a resident or planning to reside in specified counties within Pennsylvania. Full-time enrollment required. Essay submission required (maximum 500 words). Open for re-application annually for qualifying candidates, including past recipients."
  },
  "1783": {
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "public relations"
      ],
      "requiredActivities": [
          "volunteer",
          "internship",
          "employment"
      ],
      "specialRequirements": "Must be in good academic standing at an accredited university. Previous PR experience through volunteering, employment, or internship is required. Must be dedicated to professional ethics and standards."
  },
  "1784": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maryland",
          "Virginia",
          "District of Columbia"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be a graduating high school senior in the year of award; demonstrate community involvement and academic improvement; have at least 50 hours of community service with signed verification; be a Christian; not be related to Board of Directors or staff; willing to attend scholarship interview via Zoom with Executive Committee; located in DMV area (Washington DC, Maryland, Virginia); willing to attend annual fundraiser event or Scholarship Brunch; respond within 24-48 hours if selected"
  },
  "1785": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiredMajors": [
          "airline-industry-related"
      ],
      "specialRequirements": "Enrolled in accredited college or university program leading to airline industry career. Applicants from other majors considered if airline career goals demonstrated through work experience or personal essay. Must submit transcript, résumé, career essay (up to 350 words), and faculty recommendation. Applications accepted December/January each year."
  },
  "1786": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "North Carolina",
          "South Carolina"
      ],
      "specialRequirements": "Must have at least one deceased parent or primary legal guardian with proof of death required. Must be a current high school senior or enrolled in college/university/trade school with at least one full academic year remaining. If already in college, a parent or legal guardian must still reside in North Carolina or South Carolina. Must submit a Student Reflection essay and one Letter of Recommendation."
  },
  "1787": {
      "targetStates": [
          "Washington"
      ],
      "requiredMajors": [
          "agricultural sustainability",
          "organic farming",
          "ranching",
          "sustainable ecosystems"
      ],
      "specialRequirements": "Must be current resident of Thurston, Lewis, or Mason counties in Washington OR live in or attend high school in Elma or Montesano. Must intend to enroll in an educational institution or educational opportunity that will benefit the South Puget Sound region of Western Washington."
  },
  "1788": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "Political Science",
          "related fields"
      ],
      "requiredActivities": [
          "promoting Republican principles"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Resident of Preble County, Ohio for 2 years; registered to vote in Ohio if 18 or older; attending or committed to attend an accredited college or university; not in final year of study; must attend RPW meeting to receive award; must give written approval for name and photo use in RPW promotions"
  },
  "1789": {
      "targetEthnicities": [
          "Black",
          "Indigenous",
          "persons of color"
      ],
      "requiredMajors": [
          "esthetics"
      ],
      "specialRequirements": "Must be 18 years or older by program start date; must be new or currently enrolled in an accredited esthetics program leading to licensure in the U.S. or Canada; must provide proof of enrollment and/or attendance; must submit a three-minute maximum YouTube video answering required questions"
  },
  "1790": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Kansas"
      ],
      "specialRequirements": "Family income must not exceed 250% of poverty levels. Students must have an exceptional academic and community service record. Must attend a Kansas public university, community college, trade or vocational school."
  },
  "1791": {
      "minGPA": 2,
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresFinancialNeed": true,
      "specialRequirements": "Must be pursuing first undergraduate degree; household income must not exceed $75,000; must be 25 years old or younger; must provide proof of enrollment or acceptance at accredited institution; applicants do not need to be currently enrolled but must show evidence of future enrollment"
  },
  "1792": {
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "requiredMajors": [
          "Sports Venue Management",
          "Sports Administration"
      ],
      "requiredActivities": [
          "community service",
          "stadium-related work experience"
      ],
      "specialRequirements": "Must have completed minimum of two years of study or be classified as junior; must be classified as full-time student for entire scholarship year; must have actively performed worthy community service and have stadium-related work experience. Applications reviewed on: GPA, essay, educational and career goals, school & community activities, references, and industry activities."
  },
  "1793": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Washington Metropolitan Area"
      ],
      "specialRequirements": "Public high school students should be recommended by members. Must submit: typed/computer-generated essay (200-250 words), transcript, recommendation letter from at least one faculty member, three references (one from a counselor), and acceptance letter."
  },
  "1794": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "North Carolina"
      ],
      "specialRequirements": "Must be a high school senior at time of application attending school in Stanly, Cabarrus, Iredell, Mecklenburg, or Union counties in North Carolina. Must be in good standing with school. Must have acceptance to an accredited college or university for upcoming Fall with enrollment of minimum 12 hours. Requires written essay (less than 600 words), official transcript, and one letter of recommendation."
  },
  "1795": {
      "minGPA": 2.5,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "maine"
      ],
      "requiredMajors": [
          "electrical occupation"
      ],
      "specialRequirements": "Must be enrolled or accepted into a Maine technical school program for the Fall of the academic year the scholarship is awarded. Scholarship payment made directly to school."
  },
  "1796": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "sealant-industry",
          "waterproofing-industry",
          "restoration-industry"
      ],
      "specialRequirements": "Must be enrolled full-time in an accredited trade school, community college, or university. Program of study must be relevant to sealant, waterproofing, or restoration industry. Application requires 500-word statement, course of study outline, official transcripts, and two typed letters of recommendation (preferably one from an industry professional)."
  },
  "1797": {
      "targetGradeLevels": [
          "college-freshman"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania",
          "Ohio",
          "West Virginia"
      ],
      "specialRequirements": "Must be a member of the Presbyterian Church; must reside in the western half of the Synod of the Trinity (presbyteries of Beaver-Butler, Kiskiminetas, Lake Erie, Pittsburgh, Redstone, Shenango, Upper Ohio Valley, and Washington); must be accepted to a full-course of study at a participating college (College of Wooster, Davis and Elkins, Grove City, Muskingum, Washington and Jefferson, Waynesburg, or Westminster); scholarship is renewable if student meets school's requirements for continued eligibility"
  },
  "1798": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresDisability": true,
      "specialRequirements": "Must be legally blind as defined by the Social Security Act (central visual acuity of 20/200 or less in the better eye with correction, or a visual field limited to 20 degrees or less). Includes mandatory participation in mentorship program starting in fall semester."
  },
  "1799": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Michigan"
      ],
      "specialRequirements": "Must be a graduating senior from Belleville High School or another accredited Michigan high school. Must be enrolled in a 2-4 year college or university for a minimum of 12 credit hours. Must submit personal essay on how you plan to continue Jeremy's legacy of faith, hope, love, and uplifting others. Must provide transcripts to verify GPA and enrollment."
  },
  "1800": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "New York"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must be graduating in 2025, must reside in New York City, must plan to enroll in Fall 2025, must demonstrate commitment to community service and creating positive change"
  },
  "1801": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "specialRequirements": "Must have a diagnosed mental illness. Must be accepted into a four-year college or full-length trade school. Requires one letter of recommendation and a 250-500 word essay describing long-term personal and professional goals and how applicant maintains high achievement while managing a mental illness."
  },
  "1802": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "South Dakota",
          "North Dakota"
      ],
      "requiredMajors": [
          "health professions",
          "science",
          "social services",
          "research",
          "philanthropy",
          "nonprofit organizations"
      ],
      "requiredActivities": [
          "community involvement",
          "community service"
      ],
      "specialRequirements": "Must be attending a post-secondary institution (university, college, or technical school) in South Dakota or North Dakota. Application requires documentation of enrollment, field of study, academic performance, and community service activities. Winners invited to tour Dakota Lions Sight & Health headquarters in Sioux Falls."
  },
  "1803": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "medicine",
          "arts"
      ],
      "specialRequirements": "Must be a resident of one of Ohio's 32 Appalachian Counties or Geauga County. Must be enrolling in or continuing education at an accredited college or university. Requires personal essay responding to designated prompt based on major, two letters of recommendation, and resume highlighting academic achievements, volunteer work, and extracurricular activities. Scholarship is renewable annually if eligibility criteria are met."
  },
  "1804": {
      "specialRequirements": "Must submit 600-800 word essay responding to one of five provided prompts about free speech, open-mindedness, and intellectual curiosity"
  },
  "1805": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "architecture",
          "architectural engineering",
          "electrical engineering",
          "interior design",
          "landscape lighting",
          "theater",
          "broadcasting"
      ],
      "specialRequirements": "Must be enrolled in accredited institution in Northern California (Alameda, Contra Costa, Marin, Napa, San Francisco, San Mateo, Santa Cruz, Solano, or Sonoma counties). Program must be accredited by ABET, ACSA, or FIDER. Open to full-time and part-time students. Requires academic transcripts, recommendation letters, and personal statement."
  },
  "1806": {
      "specialRequirements": "Must be currently enrolled in college or university for Fall Semester (full-time enrollment required). Minimum 12 undergraduate credit hours completed. Must submit: online application, résumé, two letters of reference, proof of full-time enrollment, transcript with current GPA, and 300-500 word essay on why applicant aspires to pursue a career in the companion animal industry."
  },
  "1807": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "New Hampshire",
          "Maine",
          "Massachusetts"
      ],
      "requiredMajors": [
          "science",
          "technology",
          "engineering",
          "math"
      ],
      "specialRequirements": "Applicants must be from Unitil service territories. Selection based on academic merit, financial need, other scholarships awarded, outside student activities, and hours worked outside of class during school year."
  },
  "1808": {
      "minGPA": 3.6,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Indian-American"
      ],
      "specialRequirements": "Must be born in the Republic of India or have at least one parent born there. Must be currently residing in the U.S. Must plan to enroll full-time at an accredited, not-for-profit 4-year university or 2-year community college. Scholarships are renewable annually if GPA and full-time enrollment requirements are met."
  },
  "1809": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "requiresMilitaryConnection": true,
      "specialRequirements": "Must be one of: (1) Veteran with 100% service-connected disability, (2) Surviving spouse of a deceased service member from a service-related death, or (3) Surviving child of a deceased service member from a service-related death. Must be currently enrolled or planning to enroll in an accredited college or university. Must be willing to share personal stories and provide required documentation within three business days."
  },
  "1810": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "Veterinary Technology"
      ],
      "specialRequirements": "Must be enrolled full-time in an accredited veterinary technology program at a U.S.-based institution for Fall Semester (or acceptance letter for high school seniors). Must submit: completed online application, résumé, one letter of reference, proof of enrollment, transcript with current GPA, and 300-500 word essay explaining interest in exotic animal medicine."
  },
  "1811": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiresMilitaryConnection": true,
      "specialRequirements": "Must be retired, honorably discharged, active duty, or a member of the National Guard or Reserve. Must have completed Basic Training and follow-on training (Advanced Individual Training, technical school, etc.). Must be separated with or currently hold a military rank of E-5 or below. Scholarships limited to one per family per semester. Must use scholarship for tuition and fees at accredited institutions."
  },
  "1812": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Virginia"
      ],
      "specialRequirements": "Enrolled full-time or part-time and in good standing at an academic institution located in the Commonwealth of Virginia. Demonstrated interest in conflict resolution or Alternative Dispute Resolution (ADR). Must submit essay (max 600 words) and one reference letter."
  },
  "1813": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetEthnicities": [
          "BIPOC"
      ],
      "targetStates": [
          "DC",
          "MD",
          "VA"
      ],
      "requiredMajors": [
          "Visual Arts"
      ],
      "specialRequirements": "High school seniors must be enrolled in a public school in DC, MD, or VA for the past two years. College applicants must be freshman or sophomore originally from DMV area. Must not be a member of WCADC or family member of WCA member. Must not have previously received the WCADC scholarship. Must submit original artwork created in last three years, process folio, and reflection statement."
  },
  "1814": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "CA"
      ],
      "specialRequirements": "Must be a San Diego County, CA resident. Must be enrolled in or planning to attend an accredited college or university on a full-time basis beginning in the coming fall. Badge of Honor scholarship is for students of first-responders. Sustainability scholarship is for students with vision and desire to support the environment with eco-friendly initiatives."
  },
  "1815": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "DC"
      ],
      "specialRequirements": "Must reside within WMCCAI service area (Washington, DC Metropolitan Area). Must submit either a 500-700 word essay or 90-second media presentation. Must submit transcript and fully completed application form. Additional points awarded if essay/presentation is submitted to a community leader with written feedback included."
  },
  "1816": {
      "targetStates": [
          "California"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a high school graduate or GED holder without a bachelor's degree; enrolled or accepted in a degree program at community college, 4-year college, or university; currently taking courses toward stated goal; at least 23 years of age with life/education challenges differing from traditional four-year path; completed at least 20 college-level credits (excluding physical education and remedial classes); lives in or attends school in San Diego County; has not previously received an AAUW Poway-Penasquitos scholarship"
  },
  "1817": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior"
      ],
      "requiresMilitaryConnection": true,
      "requiredMajors": [
          "Astronomy",
          "Biometry/Biometrics",
          "Computer Engineering",
          "Computer Forensics Science",
          "Computer Programming",
          "Computer Science",
          "Computer Systems",
          "Cybersecurity",
          "Electrical Engineering",
          "Electronics Engineering",
          "Geospatial Science",
          "Industrial Engineering",
          "Information Science",
          "Information Technology",
          "Information Resource Management",
          "Intelligence",
          "Mathematics",
          "Mechanical Engineering",
          "Network Engineering",
          "Network Security",
          "Operations Research",
          "Physics",
          "Robotics Engineering",
          "Robotics Technology",
          "Statistics",
          "Strategic Intelligence",
          "Telecommunications Engineering"
      ],
      "specialRequirements": "Must be enrolled as full-time ROTC student in Army, Navy (including Marine Corps option), or Air Force ROTC program"
  },
  "1818": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresMilitaryConnection": true,
      "requiredMajors": [
          "astronomy",
          "biometry",
          "biometrics",
          "computer-science",
          "cybersecurity",
          "telecommunications-engineering",
          "C4I-related-fields"
      ],
      "specialRequirements": "Must be on active duty in uniformed military services OR honorably discharged U.S. military veteran (including Reservists and National Guard) who deployed abroad in support of Overseas Contingency Operations from 2003 to present. Documentation such as DD214 or Certificate of Service verifying deployment required. Must be enrolled part-time or full-time at accredited four-year college or university in the United States (including distance learning/online programs affiliated with major U.S. institutions). Freshmen and seniors ineligible."
  },
  "1819": {
      "minGPA": 2,
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "floriculture",
          "horticulture"
      ],
      "specialRequirements": "Must be pursuing a career in or related to floriculture or horticulture. Must be enrolled in an accredited educational institution in the U.S. or Canada. Some scholarships may have higher GPA requirements than the minimum 2.0."
  },
  "1820": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "fine-arts",
          "music",
          "theatre",
          "art",
          "chorus"
      ],
      "requiredActivities": [
          "artistic-ability"
      ],
      "specialRequirements": "Must submit: (1) short video (3 minutes) or sample of performances/artwork, (2) resume of musical, theatre, art, or chorus background, (3) up to three letters of reference from teachers or mentors, (4) copy of college acceptance letter for fall enrollment or listing of applications with plans to attend"
  },
  "1821": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Texas",
          "Arkansas",
          "Louisiana",
          "Oklahoma",
          "New Mexico",
          "Canada"
      ],
      "requiredMajors": [
          "records management",
          "governance",
          "archiving",
          "academic library studies"
      ],
      "specialRequirements": "Must reside in Texas, Arkansas, Louisiana, Oklahoma, New Mexico, or Canada. Requires 200-300 word essay and three letters of recommendation from employers, instructors, or qualified individuals."
  },
  "1822": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "agriculture"
      ],
      "specialRequirements": "Must major in agriculture with emphasis on floriculture. Must submit two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school."
  },
  "1823": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetEthnicities": [
          "African American/Black",
          "Hispanic/Latino",
          "Native American/Alaska Native"
      ],
      "requiredMajors": [
          "optometry"
      ],
      "specialRequirements": "Must be enrolled at a four-year, accredited US institution carrying minimum requirements per semester/quarter, or have completed an undergraduate degree with optometry prerequisites. Not open to current optometry students. Member of underrepresented ethnic group in optometry profession."
  },
  "1824": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "Civil Engineering"
      ],
      "specialRequirements": "Must attend school in Dallas Branch region (Collin, Cooke, Dallas, Denton, Ellis, Kaufman, Navarro, and Rockwall Counties). Must plan to attend institution of higher learning in Fall 2026 semester. Must submit reference form and complete official 2026 scholarship application form by 5:00 p.m. Central Time on May 1st."
  },
  "1825": {
      "targetStates": [
          "MA"
      ],
      "requiredMajors": [
          "construction",
          "building-trades"
      ],
      "specialRequirements": "Must be enrolled in a non-profit, registered trade school or vocational high school in Massachusetts. Open to non-members of Associated Subcontractors of MA."
  },
  "1826": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "requiredMajors": [
          "commercial-floriculture"
      ],
      "specialRequirements": "Must submit two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school. Must be legal resident of US or Canada."
  },
  "1827": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "DC"
      ],
      "requiredMajors": [
          "architecture"
      ],
      "specialRequirements": "Must be a resident of the District of Columbia. Must be completing high school in a public, charter, or private school in DC or surrounding region and entering a NAAB-accredited architecture degree program as a college freshman in Fall, OR attending a technical school or community college and will transfer to an architecture program in Fall. Selection based on demonstrated interest in architecture, academic performance, extracurricular activities, drawing ability, and financial need. Renewable if student maintains good GPA and remains in architecture program until graduation."
  },
  "1828": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Arizona"
      ],
      "specialRequirements": "Must be an Arizona high school senior accepted to attend an in-state university or community college by the time of award. Funds paid directly to college in August upon confirmation of Fall semester enrollment with Student ID and Financial Aid Office address. Spring disbursement requires minimum 12 credit hours enrollment."
  },
  "1829": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "floriculture"
      ],
      "specialRequirements": "Two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school required. Preference given to students interested in furthering the use of IPM or sustainable practices."
  },
  "1830": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredActivities": [
          "hockey"
      ],
      "specialRequirements": "Must demonstrate intense love for hockey, on-ice hustle, achievement beyond talent level, leadership, sportsmanship and teamwork. Must be from Western Pennsylvania."
  },
  "1831": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "daca"
      ],
      "targetEthnicities": [
          "women-of-color"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "engineering",
          "computer-science"
      ],
      "specialRequirements": "Must be a graduating high school student intending to major in engineering or related discipline in college. Must reside in Chicago metropolitan area. Applicants must submit high school transcript, one letter of recommendation from teacher/guidance counselor/community supporter, and college admissions letter. Recipients may be required to mentor summer camp scholars and attend Calculated Genius Showcase event. Selection based on essay content, academic achievements, and community involvement/volunteerism."
  },
  "1832": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must demonstrate commitment to seeking employment in floriculture industry after graduation. Work history or meaningful internship experience in floriculture required if not obtaining an agricultural degree. Must submit two letters of recommendation (preferably one from teacher and one from employer), resume, and transcripts."
  },
  "1833": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Connecticut"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Applicant must reside or attend high school within New London and Windham Counties, Connecticut; must demonstrate academic persistence and dedicated service to local community; must plan to attend two- or four-year college or technical, vocational, or apprenticeship program; parent/guardians' combined AGI must be below specified amount; ineligible if applicant or family member is officer, director, manager, trustee, or substantial contributor to the Foundation or Chamber"
  },
  "1834": {
      "minGPA": 2.3,
      "targetGradeLevels": [
          "high-school-sophomore"
      ],
      "targetStates": [
          "Illinois"
      ],
      "specialRequirements": "Must be a resident of Chicago; attendance rate of at least 90%; valid school ID, state ID, or valid driver's license with good driving record; physical examination completed within 12 months; completed background check including fingerprinting with no felony arrests, convictions, or gang affiliations; submit two recommendation letters; complete online application"
  },
  "1835": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "cuban"
      ],
      "requiredMajors": [
          "music-composition"
      ],
      "specialRequirements": "Must be a composer (not a performing artist). Must have Cuban citizenship or direct lineage (Cuban parent or grandparent). May be enrolled in graduate program in music composition. Maximum of two CINTAS Fellowships per recipient. Must have U.S. taxpayer identification number if living outside U.S. Must submit three to five recordings (at least two completed in past five years) with links and PDF scores. Must agree to submit signed scores for archival purposes."
  },
  "1836": {
      "targetEthnicities": [
          "cuban"
      ],
      "requiredMajors": [
          "visual-arts",
          "media-arts"
      ],
      "specialRequirements": "Must be a creative artist in visual or media arts (performing artists not eligible). Must have Cuban citizenship or direct lineage (Cuban parent or grandparent). Must submit up to 10 digital images or work samples depending on discipline. Maximum of two fellowships may be awarded to an individual. Fellows living abroad must provide a U.S. taxpayer identification number. Award is taxable under U.S. law and may be subject to limitations for Cuban Nationals."
  },
  "1837": {
      "minGPA": 2.8,
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiresMilitaryConnection": true,
      "requiredMajors": [
          "STEM"
      ],
      "specialRequirements": "Must be enrolled full-time at an accredited institution. Must be one of the following: member of U.S. armed forces, enrolled in ROTC program, honorably discharged U.S. military veteran, or direct descendant of an AFCEA member or honorably discharged service member. Undergraduate students must be sophomores or juniors; graduate students must have completed at least two courses. Requires two letters of recommendation (one from a professor in applicant's STEM field) and statement verifying military affiliation or AFCEA membership."
  },
  "1838": {
      "minGPA": 2,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "architecture",
          "arts",
          "engineering",
          "medicine",
          "nursing",
          "piano",
          "environment",
          "wildlife"
      ],
      "specialRequirements": "Must be permanent resident of one of eight counties in Western New York. Must be admitted to nonprofit, accredited school in the United States for full-time undergraduate study. Graduate scholarships limited to specialized fields only. Pell-eligible applicants attending school within the eight counties of Western New York given strong preference."
  },
  "1839": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "graduate"
      ],
      "targetEthnicities": [
          "Black",
          "Indigenous"
      ],
      "specialRequirements": "Must self-identify as Black and/or Indigenous; PhD students not eligible; must be in good academic standing; must demonstrate interest in grassroots organizing, movement building, or agricultural policy; must show commitment to racial equity in food and farming systems"
  },
  "1840": {
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "requiredMajors": [
          "German Studies"
      ],
      "specialRequirements": "Must be nominated by department/program chair or professor supervising research project. Undergraduates must have at least junior (third-year) standing and pursue German Studies track or minor. Master's students must be in humanities/social sciences earning certificate or working on German Studies project. PhD students must be in humanities/social sciences preparing dissertation proposals on modern German topics and cannot have had proposals formally accepted one year or more before deadline."
  },
  "1841": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "African American"
      ],
      "targetStates": [
          "California"
      ],
      "requiredActivities": [
          "community or school activities"
      ],
      "targetGenders": [
          "male"
      ],
      "specialRequirements": "Must be graduating from Contra Costa or Alameda County high school in current academic year or have graduated high school/received GED but never attended college as full-time student. Requires letters of recommendation from school teachers, counselors, church or community organizations."
  },
  "1842": {
      "targetGradeLevels": [
          "high-school-senior",
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresFirstGen": true,
      "requiredMajors": [
          "science",
          "engineering"
      ],
      "specialRequirements": "Applicants must be first or second generation immigrants currently residing in the United States, or be in their final year of high school, or enrolled in an undergraduate or graduate degree program within the past six months. Awards considers GPA, ACT/SAT test scores, family financial situation, community/extracurricular involvement, personal statement, and academic course load."
  },
  "1843": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "environmental horticulture"
      ],
      "specialRequirements": "Must be enrolled in an accredited educational institution in the United States or Canada. Applicants must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from their most recent school."
  },
  "1844": {
      "targetStates": [
          "Mississippi"
      ],
      "targetGenders": [
          "female",
          "male"
      ],
      "specialRequirements": "Must be of Greek Orthodox or Episcopal faith. Applications must be mailed to the Diocesan office. High-resolution headshot (300 dpi) required with application. Awards available: 4 (1 girl, 3 boys)."
  },
  "1845": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresDisability": true,
      "targetStates": [
          "NJ"
      ],
      "requiredMajors": [
          "trade-school",
          "STEM"
      ],
      "specialRequirements": "Diagnosed with congenital heart disease; Resident of Salem or Cumberland Counties, NJ; Must submit 100-word essay on future plans and CHD journey (optional); Must include confirmation of CHD diagnosis; Must submit recommendation letter from non-related adult"
  },
  "1846": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "floriculture",
          "horticulture"
      ],
      "specialRequirements": "Must be attending an accredited college or university. Open to U.S. and international students. Requires two letters of recommendation (preferably one from a teacher and one from an employer), resume, and unofficial transcripts. Funds issued jointly to student and educational institution."
  },
  "1847": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "floriculture"
      ],
      "specialRequirements": "Must be enrolled at Michigan State University. Must submit two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school."
  },
  "1848": {
      "minGPA": 3,
      "requiresFinancialNeed": true,
      "requiresDisability": true,
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "health",
          "social-science"
      ],
      "specialRequirements": "Applicants must be permanent residents of San Diego County, Imperial County, or Southern Riverside County. Must be currently treated for epilepsy/seizure disorder (verified by doctor's letter) OR involved in epilepsy research project (verified by professor's letter with project details). Must demonstrate satisfactory academic performance. Requires completed application, statement of eligibility, statement of financial need, current transcript, doctor's or professor's letter, and two letters of recommendation."
  },
  "1849": {
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "BIPOC"
      ],
      "targetStates": [
          "Idaho"
      ],
      "requiredActivities": [
          "human rights advancement"
      ],
      "specialRequirements": "Strong record of advancing human rights. Preference given to LGBTQ+ and BIPOC students with financial need. Funds can be used for college, trade school, or gap year expenses. Up to 2 awards available annually."
  },
  "1850": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiredMajors": [
          "agriculture",
          "equine",
          "livestock"
      ],
      "requiredActivities": [
          "volunteerism in community non-school sponsored activities",
          "extracurricular school activities"
      ],
      "specialRequirements": "Must be accepted to and enrolled in a two-year community college or four-year college/university. Must have endorsement from Guidance Counselor. Must provide certificate of enrollment for fall semester including Student ID number and Financial Aid Office address."
  },
  "1851": {
      "minGPA": 2.5,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Florida"
      ],
      "requiredMajors": [
          "Medicine",
          "Physician Assistant",
          "Nursing",
          "Medical Technology",
          "Health Sciences",
          "Theology"
      ],
      "specialRequirements": "Must be resident of Escambia, Santa Rosa, Okaloosa, or Walton County, Florida. Must be of good moral character. Must be accepted by or pursuing training at accredited college. Full-time enrollment (12+ credits) or part-time enrollment (3-11 credits) required. Requires acceptance letter, official transcript, two recommendation letters, cost of attendance documentation, and 500-word statement of need."
  },
  "1852": {
      "minGPA": 2.6,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "horticulture",
          "plant sciences"
      ],
      "specialRequirements": "Preference given to students with demonstrated interest in commercial greenhouse production of herbaceous ornamental or floriculture crops, research related to production/physiology/breeding of herbaceous ornamental and floriculture crops, or sales and marketing of such crops. Must submit two letters of recommendation (preferably one from teacher and one from employer), resume, and transcripts."
  },
  "1853": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiresMilitaryConnection": true,
      "specialRequirements": "Applicant must be spouse (any age) or child (under age 26) of a U.S. military member or U.S. government employee who died as a result of hostile action or combat-related accident. Summer scholarship applicants limited to maximum three in-person activities (not virtual). Summer applications due mid-April; fall/spring applications due in May."
  },
  "1854": {
      "minGPA": 2,
      "targetGradeLevels": [
          "college-freshman",
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "floral-marketing",
          "floral-distribution",
          "floral-business"
      ],
      "specialRequirements": "Applicants must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from their most recent school. Must be enrolled in an accredited educational institution in the US or Canada."
  },
  "1855": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Michigan"
      ],
      "targetGenders": [
          "non-binary"
      ],
      "specialRequirements": "Must identify as transgender (including non-binary, two-spirit, third gender, transsexual, and/or any other non-cis-gender identity). Must attend accredited college, university, or technical/vocational program with satellite campus or permanent presence in Kent County, MI. Must submit 500-word maximum essay responding to specified prompts about goals and barriers related to trans identity. Students of color and students with disabilities are encouraged to apply. No GPA requirement."
  },
  "1856": {
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must be enrolled at Pennsylvania State University (any campus) and in at least sophomore year"
  },
  "1857": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "horticulture"
      ],
      "specialRequirements": "Must have a major or minor in business and/or marketing. Must be enrolled in an accredited educational institution in the US or Canada. Must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from most recent school."
  },
  "1858": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "entertainment",
          "technology"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be enrolled at an accredited U.S.-based academic institution. Must submit completed application, GPA verification, and U.S. citizenship documentation by the application deadline of March 28."
  },
  "1859": {
      "targetGradeLevels": [
          "graduate"
      ],
      "specialRequirements": "Must be impacted in some way by Alzheimer's disease or related dementia. Must be attending a recognized educational institution in the U.S. or Canada. Submission must be either written (750 words or less) or photo format (up to three images). Submissions should focus on the person and their story before the impact of Alzheimer's or dementia."
  },
  "1860": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "diverse-backgrounds"
      ],
      "requiredMajors": [
          "exhibition-management",
          "event-management",
          "hospitality-management"
      ],
      "specialRequirements": "Combined family income less than $120,000; must be from diverse, under-served, or economically/socially disadvantaged background; must be accepted into full-time undergraduate program at accredited institution; other majors considered only if career intent in exhibition, event, or hospitality industry is clearly demonstrated"
  },
  "1861": {
      "minGPA": 3.25,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "exhibition management",
          "event management"
      ],
      "specialRequirements": "Must be a full-time student at an accredited institution. Must be enrolled in a degree program focusing on exhibition or event management. Graduate students with fully funded assistantships are not eligible. Other majors may qualify if application demonstrates clear intent to enter the exhibition/event industry. Requires resume, two letters of recommendation from faculty or industry professionals, official transcript or admission letter, and 500-1,000 word essay on goals in the exhibition/events industry."
  },
  "1862": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen",
          "permanent-resident"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "hospitality management",
          "hotel management"
      ],
      "specialRequirements": "Must be a permanent resident of Illinois. Current undergraduate student enrolled full-time or high school senior enrolling in an accredited college or university in the coming fall. Must submit extracurricular activities list, recent transcript, recommendation letter from education professional/employer/industry professional, and typed essay outlining career goals in hospitality industry."
  },
  "1863": {
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "Culinary Arts",
          "Hospitality Management",
          "Restaurant Management",
          "Food Service"
      ],
      "specialRequirements": "Must be a permanent resident of Illinois, under age 30, accepted and planning to enroll in an accredited culinary school, college, or university, enrolled as full-time or substantial part-time student taking minimum of 9 credit hours each term"
  },
  "1864": {
      "minGPA": 3,
      "requiresDisability": true,
      "specialRequirements": "Must be a high school or GED graduate of any age; must be diagnosed with essential tremor; must be attending a licensed, accredited institution of higher learning; must submit doctor's letter confirming ET diagnosis; must submit letter of acceptance from educational program director; must submit essay (500 words max) on 'How has ET affected my life?'"
  },
  "1865": {
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior",
          "graduate"
      ],
      "requiredMajors": [
          "floriculture",
          "horticulture"
      ],
      "specialRequirements": "Must have career interest in agribusiness marketing and floral product distribution. Must provide current email address, permanent address, and current mailing address. Must submit two letters of recommendation (preferably one from teacher and one from employer), unofficial transcripts, and current resume."
  },
  "1866": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "floral design"
      ],
      "specialRequirements": "Must submit two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school. Must be enrolled in an accredited educational institution in the United States or Canada."
  },
  "1867": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman"
      ],
      "targetStates": [
          "Florida"
      ],
      "specialRequirements": "Must be a permanent resident of the United States and Florida resident. Must be enrolled full-time at an accredited four-year college or university. Must have completed at least 75 hours of community service. Must submit letter of recommendation from teacher, school administrator, counselor, employer, or church leader (not relative or friend). Must submit professional headshot and official high school transcript. Must submit college acceptance letter if applicable. One undergraduate and one graduate scholarship awarded annually."
  },
  "1868": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maryland"
      ],
      "requiredActivities": [
          "leadership",
          "volunteer-service"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must reside in Maryland and attend a public, charter, private, or parochial high school in Baltimore City, Baltimore County, Howard County, Anne Arundel County, Carroll County, or Harford County. Must have plans to enroll in an accredited two- or four-year post-secondary institution in the coming Fall. Must provide verification of college enrollment. Priority consideration given to first-generation college students."
  },
  "1869": {
      "targetEthnicities": [
          "Italian (50% or more ancestry)"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "journalism",
          "media communications"
      ],
      "specialRequirements": "Must be admitted to or enrolled at an accredited institution of higher education. Must submit 500-word essay, self-photo, high school and/or college transcripts, proof of college acceptance/admittance or current college transcript, two recommendation letters, and any published writings (print or digital). All materials must be submitted as one digital PDF file by the deadline."
  },
  "1870": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California",
          "Illinois"
      ],
      "requiredMajors": [
          "healthcare-related fields",
          "medical assistant",
          "nurse",
          "physician",
          "allied health professions"
      ],
      "specialRequirements": "Must reside in California and attend accredited college/university in California, or attend University of Illinois, Champaign. Minimum GPA: 2.5 for community college, 3.0 for undergraduate, 3.25 for graduate students. Requires financial documentation, academic transcripts, and letters of recommendation."
  },
  "1871": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "horticulture",
          "floriculture"
      ],
      "specialRequirements": "Must be enrolled in an accredited educational institution in the United States or Canada. Applicants must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from their most recent school."
  },
  "1872": {
      "minGPA": 2,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "marketing",
          "floral-distribution"
      ],
      "specialRequirements": "Must submit two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school. Must be enrolled in an accredited educational institution in the U.S. or Canada."
  },
  "1873": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Kentucky"
      ],
      "requiredMajors": [
          "teacher-education",
          "teacher-certification"
      ],
      "specialRequirements": "Must be admitted to a teacher education program pursuing initial teacher certification at a participating Kentucky college, or be a certified teacher (primary through grade 12) pursuing additional credentialing for classroom teaching. Must teach one semester at a Kentucky public or certified non-public school for each semester the scholarship is received. Must repay the scholarship plus interest if the teacher education program or service requirement is not completed."
  },
  "1874": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "California"
      ],
      "specialRequirements": "Must reside in San Francisco Bay Area; must attend accredited California college or university; must demonstrate strong commitment to community service, education, or social justice; must submit original essay and academic transcripts"
  },  "1876": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "Texas"
      ],
      "requiredMajors": [
          "trade",
          "vocational"
      ],
      "specialRequirements": "Must be a graduating high school senior or past graduate with a diploma or GED equivalent. Must reside in Texas. Must be in good academic standing. Must intend to pursue a trade or vocational degree at an accredited institution in Texas. Requires submission of proof of residency, academic transcripts, essay detailing aspirations and career goals, and two letters of recommendation."
  },
  "1877": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-sophomore",
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "New York"
      ],
      "requiredMajors": [
          "ornamental-horticulture"
      ],
      "specialRequirements": "Must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from most recent school. Applicants must be enrolled in an accredited educational institution in the United States or Canada."
  },
  "1878": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Massachusetts"
      ],
      "specialRequirements": "Must have physically resided in Massachusetts for at least one year with intent to remain in the state. Must not be in default on federal or state student loans or owe a refund for prior financial aid. Must be enrolled in at least three undergraduate credits per semester in an eligible program at a Massachusetts public institution. Must not have previously earned a bachelor's degree or professional degree. Must maintain satisfactory academic progress according to institutional and federal standards."
  },
  "1879": {
      "targetStates": [
          "Michigan"
      ],
      "requiredMajors": [
          "nursing"
      ],
      "specialRequirements": "Must be currently enrolled in a Michigan college/school of nursing that grants a certificate for practical nursing or an associate, baccalaureate or higher degree in nursing. Must be in good academic standing. Must submit: one-page personal vision of future nursing practice with name and contact information, most recent transcript, and letter of reference from a nursing faculty member."
  },
  "1880": {
      "minGPA": 2.5,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "horticulture"
      ],
      "specialRequirements": "Applicants must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from most recent school. Must be enrolled in an accredited educational institution in the US or Canada. Priority given to married students working to put themselves through college."
  },
  "1881": {
      "minGPA": 3.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresMilitaryConnection": true,
      "specialRequirements": "Must be dependent child of active duty, reserve, National Guard, or retired U.S. military personnel with valid Exchange & Commissary privileges. Must not have attended college yet. Must plan full-time undergraduate enrollment at accredited two- or four-year institution. Must provide proof of parent's military service (DD214, Statement of Service, or equivalent). Only first 100 completed applications processed. Scholarship is one-time only and not renewable."
  },
  "1882": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore"
      ],
      "targetStates": [
          "Montana"
      ],
      "requiredMajors": [
          "Agriculture Education",
          "Horticulture",
          "Floriculture",
          "Landscape Design",
          "Botany",
          "Biology",
          "Plant Pathology",
          "Plant Science",
          "Forestry",
          "Agronomy",
          "Environmental Conservation",
          "Habitat Ecology",
          "Forest Systems Ecology",
          "Land Management"
      ],
      "specialRequirements": "Must have completed required credits to be considered a college sophomore. Must submit transcript, two letters of reference from instructors, and letter of application including short autobiography and future plans."
  },
  "1883": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "horticulture",
          "bioengineering"
      ],
      "specialRequirements": "Must be enrolled at an accredited four-year college. Must submit two letters of recommendation (preferably one from a teacher and one from an employer), resume, and transcripts from most recent school."
  },
  "1884": {
      "minGPA": 2.5,
      "requiresFinancialNeed": true,
      "targetStates": [
          "Delaware"
      ],
      "requiredMajors": [
          "construction-related fields"
      ],
      "specialRequirements": "Must be at least 17 years old; can be enrolled full-time or part-time; must submit letter of recommendation, academic advisor rating form, and transcript for three most recent quarters/semesters; must maintain 2.5 GPA for reimbursement; not automatically renewed but may re-apply"
  },
  "1885": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must be a current high school senior or graduate of Robbinsdale School District 281 (Armstrong, Cooper, or Highview). Previous recipients are eligible to reapply two years after their initial award."
  },
  "1886": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "agricultural",
          "agri-business",
          "science"
      ],
      "specialRequirements": "Must be from or attending a university in specified states. Undergraduate students must attend accredited 4-year college or university. Graduate students must be actively enrolled in thesis-based graduate program at accredited university."
  },
  "1887": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "nursing",
          "medicine",
          "paramedicine",
          "respiratory therapy",
          "physical therapy",
          "physician assistant",
          "dietetics",
          "nutrition",
          "pharmacy",
          "allied health"
      ],
      "specialRequirements": "Must be enrolled in accredited healthcare or medical-related program. Students studying outside Northern California's North Valley must demonstrate clear intention to return to practice in the region. Preference for students connected to Butte College, California State University Chico, University of California Davis, or Enloe Medical Center, though students from other accredited institutions may qualify. Interviews required in mid to late May for selected applicants."
  },
  "1888": {
      "targetStates": [
          "Ohio"
      ],
      "specialRequirements": "Must be attending a university, community college, training program, or vocational school in Ohio. Must plan a career in public service within Ohio. Award is payable upon confirmation of attendance. If selected, applicant must participate in a brief presentation with their Board of County Commissioners. One scholarship per CCAO District (Central, Southwest, Northwest, Northeast, Southeast)."
  },
  "1889": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Oregon"
      ],
      "specialRequirements": "Applicants must be 25 or younger. Must meet one of the following: currently in child welfare foster care; in foster care for at least 180 days after 13th birthday and exited at age 14 or older; former foster youth adopted or entered guardianship on or after 13th birthday with finalization after 9/1/2015. Final disbursement must be received before turning age 26."
  },  "1891": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "Illinois",
          "Wisconsin",
          "Michigan",
          "Arizona",
          "Colorado"
      ],
      "requiredMajors": [
          "environment",
          "conservation",
          "forestry",
          "primary education",
          "secondary education"
      ],
      "specialRequirements": "Primary/secondary education applicants must attend Christian colleges. Applicants must submit high school transcript (unofficial acceptable), ACT or SAT scores, and one writing sample. Selected applicants may be required to attend an interview."
  },
  "1892": {
      "specialRequirements": "Must be currently enrolled as a full-time student at Rensselaer Polytechnic Institute. Must have completed at least one cumulative year of study at any college or university."
  },
  "1893": {
      "minGPA": 3.2,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredActivities": [
          "hockey"
      ],
      "specialRequirements": "Must be a Western Pennsylvania high school senior with demonstrated good citizenship and school/community involvement"
  },
  "1894": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Must have attended a Pittsburgh Public School or select high schools within Allegheny County. Renewable upon maintaining 3.0 GPA and earning minimum 24 credit hours."
  },
  "1895": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresPellGrant": true,
      "targetStates": [
          "Pennsylvania"
      ],
      "specialRequirements": "Continuous residency in City of Pittsburgh since 9th grade; continuous enrollment in Pittsburgh Public Schools or charter schools since 9th grade; 90% attendance required; must graduate from eligible high school; must apply to post-secondary institution within five years of high school graduation; students from Wilkinsburg who graduate from Pittsburgh Public Schools also eligible (starting with class of 2017); Promise Extension Program available for students with GPA 2.0-2.49 who meet all other requirements"
  },
  "1896": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "Project Management",
          "related fields"
      ],
      "specialRequirements": "Essay required. Letters of recommendation required. Applicants scored on essay quality, academic performance, letters of recommendation, and alignment of coursework to project management field."
  },
  "1897": {
      "requiredMajors": [
          "project management",
          "program management",
          "portfolio management"
      ],
      "specialRequirements": "Must be enrolled in a GAC-accredited, academic, degree-granting program in project/program/portfolio management or a project management related field of study"
  },
  "1898": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Arizona"
      ],
      "requiredMajors": [
          "project management",
          "related field benefiting from project management"
      ],
      "specialRequirements": "Must be enrolled in or applying for an accredited academic degree program in project management or related field. Applicants evaluated on essay quality, academic performance, letters of recommendation, and alignment of coursework to project management field."
  },
  "1899": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "Minnesota"
      ],
      "requiredMajors": [
          "Project Management",
          "related fields"
      ],
      "specialRequirements": "Applicants must reside in Minnesota. Evaluation based on essay quality, academic performance, letters of recommendation, and alignment of coursework to project management field. Applicants who attempt to lobby or persuade the review committee will be disqualified."
  },
  "1900": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "printing-technology",
          "printing-management",
          "graphic-communication",
          "packaging",
          "publishing"
      ],
      "specialRequirements": "Must be enrolled or planning to enroll in a printing or graphics program at an accredited institution. Full-time enrollment required. Two recommender contacts required. Official transcripts required."
  },
  "1901": {
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "chemistry",
          "chemistry-related science"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Applicant must be a woman in junior or senior undergraduate year majoring in chemistry or chemistry-related science"
  },
  "1902": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "performing-arts"
      ],
      "specialRequirements": "Must be a Virginia resident residing in Fairfax County. Must be enrolled at an accredited institution for fall of the award year. For Bruce Marson Memorial Scholarship specifically, applicants must demonstrate interest and ability in Lighting Design, Stage Management, Scenic Design, Set Construction, Sound, Property Management, Production Management, or Costume Design."
  },
  "1903": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Massachusetts"
      ],
      "requiredMajors": [
          "music"
      ],
      "requiredActivities": [
          "high-school-performing-arts-program"
      ],
      "specialRequirements": "Must reside in Rockport Music–served district (Rockport, Gloucester, Manchester/Essex, Beverly, or Ipswich) OR have attended Cape Ann Jazz Workshop. Must be accepted to accredited college, university, or conservatory with plans to major or minor in music. Requires 500-word essay and letter of recommendation from recommender."
  },
  "1904": {
      "minGPA": 2,
      "targetGradeLevels": [
          "high-school-junior",
          "high-school-senior",
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "seed-industry-related"
      ],
      "specialRequirements": "Must have a career goal within the seed industry. Must be enrolled in an accredited educational institution in the United States or Canada. Must submit two letters of recommendation (preferably one from a teacher and one from an employer), a resume, and transcripts from most recent school."
  },
  "1905": {
      "requiresFinancialNeed": true,
      "targetStates": [
          "Michigan"
      ],
      "requiredActivities": [
          "community service"
      ],
      "specialRequirements": "Must be Michigan resident; must be enrolled at accredited college/university in Michigan; must demonstrate history of community service; must submit essay, most recent 1040 tax forms for all parents (or personal 1040 if no longer dependent), letter from non-relative documenting community service, copy of Michigan driver's license or state ID, and acceptance letter or transcript"
  },
  "1906": {
      "requiresMilitaryConnection": true,
      "requiredMajors": [
          "STEM - aerospace engineering",
          "STEM - cybersecurity",
          "STEM - mechanical engineering"
      ],
      "specialRequirements": "Must have served as an enlisted soldier at Fort Bragg; must be currently attending Campbell University; must submit official transcript including Spring semester grades; must provide one letter of recommendation from a faculty member in major"
  },
  "1907": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetStates": [
          "New Jersey"
      ],
      "requiredActivities": [
          "community-involvement",
          "extracurricular-activities"
      ],
      "specialRequirements": "Must reside in Bergen or Passaic County, New Jersey. Must submit SAT/ACT scores. Interest in Italian heritage, art, music, or culture is preferred. Must demonstrate academic achievement and active community involvement."
  },
  "1908": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiredMajors": [
          "architecture",
          "interior design"
      ],
      "specialRequirements": "Demonstrated passion for and commitment to biophilic design and the use of hardwoods in architectural projects. Enrollment in an accredited college or university. Strong academic record and dedication to academic excellence. Leadership potential and commitment to making a positive impact on the field of architecture and design. Requires a 300–500-word essay discussing the importance of integrating biophilic design theories in architectural and/or interior design projects."
  },
  "1909": {
      "minGPA": 2.5,
      "targetEthnicities": [
          "Native American"
      ],
      "specialRequirements": "Must be enrolled in an approved post-secondary educational institution; must provide proof of enrollment in a federally recognized tribe or proof of ancestry; applicants must be located in UAIC's six county service area"
  },
  "1910": {
      "specialRequirements": "Must be adopted at or after age 13, or have exited foster care to permanent guardianship. One award available annually. Eligible for four-year institutions only."
  },
  "1911": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Virginia"
      ],
      "requiredMajors": [
          "aviation",
          "pilot",
          "aviation-maintenance-technician",
          "aviation-manager",
          "air-traffic-control",
          "aerospace-engineering",
          "aviation-management"
      ],
      "specialRequirements": "Completed essay (250-500 words) on 'Why I Wish to Pursue a Career in Aviation' or 'Why Aviation is Important to the Commonwealth of Virginia'; Two letters of recommendation (preferably at least one from someone in the aviation industry); Proof of acceptance into or good standing in an aviation-related post-secondary education program; Must attend an accredited Virginia institution; Additional consideration given to VABA members or family members of VABA, but membership not required"
  },
  "1912": {
      "minGPA": 2,
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "floriculture",
          "horticulture"
      ],
      "specialRequirements": "Must be enrolled in one or two-year vocational program. Must submit two letters of recommendation (preferably one from teacher and one from employer), resume, and transcripts from most recent school. Must be citizen or permanent resident of US or Canada, or enrolled in accredited educational institution in US or Canada."
  },
  "1913": {
      "minGPA": 3,
      "targetGradeLevels": [
          "graduate"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Criminal Justice",
          "social sciences",
          "public administration",
          "computer science",
          "finance",
          "linguistic arts",
          "chemistry",
          "physics"
      ],
      "specialRequirements": "Must be full-time student at accredited four-year college/university or fully accredited community college with intention to transfer; must have completed at least one full academic year; must submit 500-word essay on community involvement or law enforcement internship experience; must have at least one written recommendation letter from community leader or police official; must physically attend institution"
  },
  "1914": {
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Connecticut"
      ],
      "requiredMajors": [
          "forestry",
          "wildlife management"
      ],
      "specialRequirements": "Must be a Windham County resident. Must have high school diploma or be a high school senior. Must be enrolled or planning to enroll in a two- or four-year program in forestry or allied field with coursework and goals directly related to forest management. General programs (agriculture, botany, turf management, environmental science) not considered unless applicant demonstrates focus on forest management."
  },
  "1915": {
      "minGPA": 3,
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "business",
          "engineering",
          "healthcare",
          "education",
          "technology",
          "mathematics",
          "social sciences",
          "basic sciences"
      ],
      "specialRequirements": "Must have completed at least 12 credit hours at time of application submission. Must have completed at least 25 credit hours at start of coming academic year. AP credits from high school do not count toward credit hour requirements. Must be enrolled at one of these institutions: American University, The Catholic University of America, Gallaudet University, Georgetown University, The George Washington University, Howard University, Trinity Washington University, or University of the District of Columbia. Previous awardees encouraged to apply."
  },
  "1916": {
      "minGPA": 3,
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "parks/law enforcement",
          "recreation",
          "parks and leisure studies"
      ],
      "specialRequirements": "Applicant must have a declared major in a relevant degree program at a college or university in Ohio and/or be a resident of Ohio. Must have completed or be enrolled in courses totaling minimum 30 credit hours with at least 12 credit hours in major (graduate students must have at least 9 credit hours in major). Evaluation based on resume, professional references, and essay. Funds applied to tuition only; checks sent directly to University Bursar."
  },
  "1917": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Maine"
      ],
      "requiredMajors": [
          "trades",
          "trade-school"
      ],
      "specialRequirements": "Must reside in Maine. Must demonstrate proven passion for the trades and enthusiasm to pursue a career in skilled work. Applicants should be resilient and eager learners. Application must be submitted on Horch Roofing's website."
  },
  "1918": {
      "minGPA": 3,
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "Parks and Recreation"
      ],
      "specialRequirements": "Resident of or college student in Ohio; minimum GPA of 3.0 within the major; minimum 2.5 overall GPA; requires essay; requires resume and professional references; funds may only be applied to tuition costs"
  },
  "1919": {
      "minGPA": 3,
      "targetStates": [
          "Ohio"
      ],
      "requiredMajors": [
          "recreation",
          "parks and leisure studies",
          "park operations",
          "natural resource management",
          "therapeutic recreation",
          "commercial recreation",
          "outdoor recreation",
          "tourism",
          "community recreation",
          "recreation management",
          "aquatic management",
          "non-profit recreation management",
          "sports management",
          "leisure studies"
      ],
      "specialRequirements": "Applicant must have a declared major in a relevant degree program at a college or university in Ohio and/or be a resident of Ohio. Must have completed or be enrolled in courses totaling minimum 30 credit hours with at least 12 credit hours in major (graduate students must have at least 9 credit hours in major). Overall cumulative GPA of 2.5 required. Evaluation based on resume, professional references, and essay."
  },
  "1920": {
      "targetGradeLevels": [
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "History",
          "History-related fields"
      ],
      "specialRequirements": "Must be a current Pennsylvania resident. Must be enrolled full-time at a Pennsylvania two- or four-year college or university in the coming fall. Must submit proof of full-time enrollment or acceptance letter. Must submit 250-word personal statement and well-researched essay (maximum 1,500 words) with appropriate citations and sources."
  },
  "1921": {
      "targetStates": [
          "Pennsylvania"
      ],
      "requiredMajors": [
          "computing",
          "engineering",
          "life sciences"
      ],
      "specialRequirements": "Must be enrolled full-time at a 2-year or 4-year institution in Central Pennsylvania. Must demonstrate commitment to technology-related disciplines. Must articulate vision for becoming an active leader/role model for women in technology. Letter of recommendation from a professor is required. Award criteria include academic performance, student leadership, and future impact on the women in technology community."
  },
  "1922": {
      "minGPA": 2.8,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Georgia"
      ],
      "specialRequirements": "Must be from metro-Atlanta area. Must be accepted to an accredited business college, college/university, or vocational school. Must demonstrate commitment and motivation toward academic success. Requires typed essay of at least 500 words, letter of intent, official high school transcript, two recommendation letters (one from teacher/counselor/administrator and one from relative/friend/employer/clergy), and copy of college/certification/trade school acceptance letter."
  },
  "1923": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresDisability": true,
      "targetStates": [
          "New Jersey"
      ],
      "requiredActivities": [
          "community-service",
          "extracurricular-activities",
          "sports"
      ],
      "specialRequirements": "Must have type 1 diabetes; must be seeking enrollment at accredited four-year university, college, technical or trade school; must have physician or CDE endorsement demonstrating diabetes management; must submit proof of citizenship, transcript, extracurricular activities documentation, teacher/coach/counselor letter of recommendation, and 500-word essay"
  },
  "1924": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "NJ",
          "NY",
          "CT",
          "PA"
      ],
      "specialRequirements": "Must reside in or be enrolled in college in one of 29 specified counties in NJ, NY, CT, and PA. Must plan to enroll in part-time or full-time undergraduate study at accredited two- or four-year college, university, or vocational-technical school. Selection based on positive academic record, demonstrated leadership, commitment to school and community activities, and work experience."
  },
  "1925": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior",
          "college-freshman",
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiredActivities": [
          "community-service"
      ],
      "specialRequirements": "Must have residence status in 48111 zip code; must have permanent residence status in the United States; must have completed minimum 20 hours of community service in past 12 months; must be accepted as full-time student at college, university, or trade school program for upcoming school year"
  },
  "1926": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "vocal-music",
          "instrumental-music"
      ],
      "specialRequirements": "Applicant must currently reside or have resided in the greater South Bay area of Southern California. Scholarship winners are determined by competitive audition."
  },
  "1927": {
      "minGPA": 2.5,
      "targetStates": [
          "Michigan"
      ],
      "requiredActivities": [
          "volunteer or community service"
      ],
      "specialRequirements": "Enrolled in accredited Michigan-based college or trade school. Minimum 4 hours of local volunteer or community service in the last 12 months. Must be sponsored by an Academic Advisor or Program Dean. Essay required on topics related to information technology (grammar, spelling, articulation, and relevance to IT are evaluated)."
  },
  "1928": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiresFinancialNeed": true,
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "A member of the household must have been diagnosed with cancer; household must include at least one female; applicant must reside in the United States or a U.S. Territory; applicant must not have received a Bessie Mathew Foundation EAP payment in the past 12 months"
  },
  "1929": {
      "minGPA": 2.75,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "citizenshipRequired": [
          "us-citizen"
      ],
      "targetStates": [
          "Michigan"
      ],
      "specialRequirements": "Must attend high school located in Metro-Detroit; must be accepted into an accredited post-secondary educational institution in the United States for the upcoming fall semester; top candidates will be interviewed via telephone or Zoom; proof of acceptance/enrollment required from top candidates; teacher/counselor recommendation letters favorable but not required; essays must meet minimum word count requirement; incomplete applications will not be reviewed"
  },
  "1930": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Texas"
      ],
      "specialRequirements": "Must be enrolled in a two-year or four-year undergraduate program at a college, university, or technical school in Texas. Submission must be a creative entry (video) addressing one of six specified topics, submitted via TikTok, Instagram, or YouTube. Artistic ability required."
  },
  "1931": {
      "targetGradeLevels": [
          "high-school-junior"
      ],
      "requiresFinancialNeed": true,
      "specialRequirements": "Must be a current high school junior; Total household income (including custodial and non-custodial parents) must be $125,000 or less; Must attend a public or parochial high school; Open to students of all genders and backgrounds; Must develop an innovative social enterprise business idea, create a professional website, and submit a complete business plan"
  },
  "1932": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Michigan"
      ],
      "requiredActivities": [
          "school-club",
          "sport",
          "enrichment-program",
          "job",
          "caregiving-role",
          "community-service"
      ],
      "specialRequirements": "Must be enrolled in Kalamazoo Public Schools (Kalamazoo Central High School, Loy Norrix High School, Phoenix High School, or Kalamazoo Innovative Learning Program). Must demonstrate participation in at least one structured activity. Students with cumulative GPA under 2.0 must submit academic explanation and growth plan. Application requires 500-750 word personal statement, up to five personal accomplishments, and minimum 250 word post-graduation plan."
  },
  "1933": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-sophomore",
          "college-junior",
          "college-senior"
      ],
      "requiredMajors": [
          "golf-related"
      ],
      "specialRequirements": "Must be a student at PGM University, a PGA Associate, or a full-time college student. Must be a rising Sophomore, Junior, or Senior. Must be in good academic standing. Renewable each year until graduation with maintenance of 3.0 GPA and good academic standing."
  },
  "1934": {
      "targetGradeLevels": [
          "graduate"
      ],
      "targetStates": [
          "California"
      ],
      "requiredMajors": [
          "architecture",
          "interior design",
          "architectural engineering",
          "electrical engineering",
          "industrial engineering",
          "theater"
      ],
      "specialRequirements": "Must be enrolled full-time in accredited program at accredited institution studying accredited curricula (ACSA, CIDA, ABET, or NAST). Must be high school graduate or currently attending program in Southern California counties: Los Angeles, Orange, Ventura, San Bernardino, or Riverside. Graduate students must have specific lighting project as part of advanced degree program."
  },
  "1935": {
      "minGPA": 2.5,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "targetEthnicities": [
          "Black or African American",
          "American Indian or Alaska Native",
          "Hispanic or Latino",
          "Asian American",
          "Native Hawaiian or other Pacific Islander"
      ],
      "requiredMajors": [
          "Business/International Business",
          "Marketing",
          "Information Systems",
          "Accounting",
          "Finance",
          "Human Resources",
          "Hospitality/Entertainment/Sports Management",
          "Culinary Arts",
          "Communications/Public Relations/Digital Media",
          "Information Technology",
          "Graphic Design"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must reside in an eligible city in the United States. Must self-identify as female (any race/ethnicity) OR as a member of a traditionally underserved racial or ethnic background. Must plan to enroll in part-time or full-time undergraduate study at an accredited two-year or four-year college, university, or vocational-technical school for the entire upcoming academic year."
  },
  "1936": {
      "citizenshipRequired": [
          "us-citizen"
      ],
      "requiredMajors": [
          "Plumbing",
          "Electrician",
          "HVAC",
          "Welding",
          "Masonry",
          "Appliance Repair",
          "Tool Manufacturing",
          "Auto Repair & Manufacturing",
          "Airplane Repair & Manufacturing",
          "Industrial Mechanical Systems",
          "Diesel Technology",
          "Machine Operator",
          "Metal Coating and Molding",
          "Construction Management",
          "Elevator Technician",
          "Carpentry",
          "Culinary Arts",
          "Agriculture & Horticulture",
          "Dental Technician",
          "Veterinarian Technician",
          "EMT",
          "Radiology Technician"
      ],
      "specialRequirements": "Ages 17-25 during application period; proof of foster care experience required; must be high school graduate or GED holder; must plan to attend accredited vocational-technical school, trade school, or two-year college; must be pursuing trade certification or vocational degree"
  },
  "1937": {
      "minGPA": 3,
      "targetGradeLevels": [
          "college-junior",
          "college-senior"
      ],
      "targetStates": [
          "Illinois"
      ],
      "requiredMajors": [
          "mathematics education",
          "mathematics with education minor",
          "early childhood education",
          "elementary education"
      ],
      "specialRequirements": "Must be working on first bachelor's degree; graduation scheduled for May or later; must intend to teach in Illinois upon graduation; must be enrolled in a teacher education program; requires two 200-300 word essays, lesson planning form, transcripts from all colleges attended, and two letters of recommendation from mathematics or mathematics methods teachers"
  },
  "1938": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetStates": [
          "Montana"
      ],
      "requiredMajors": [
          "conservation",
          "natural resources",
          "agriculture",
          "STEAM"
      ],
      "specialRequirements": "Must be a high school graduate of the current academic year from a Gallatin County High School or equivalent. Must enroll full-time in a post-secondary school. STEAM majors must show emphasis on natural resource studies (Forestry, wildlife management, ecology, etc.). Selection based on academic achievement, educational goals, and extracurricular activities."
  },
  "1939": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresPellGrant": true,
      "targetEthnicities": [
          "Black",
          "Indigenous",
          "Person of Color"
      ],
      "requiredMajors": [
          "statistics",
          "data science",
          "quantitative fields",
          "math",
          "engineering",
          "computer science"
      ],
      "specialRequirements": "Must be enrolled in a U.S. college or university for the upcoming academic year. Must demonstrate genuine interest in statistics and data science. Priority given to those eligible for Federal Pell Grant Program."
  },
  "1940": {
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "requiresFinancialNeed": true,
      "requiresFAFSA": true,
      "targetStates": [
          "California",
          "Kentucky",
          "New York",
          "Washington"
      ],
      "specialRequirements": "Must be a high school senior graduating this year or current undergraduate student planning to attend a college or university in the upcoming academic year. Signed letters of recommendation (optional). Current official transcript (optional, but may be requested later). Financial aid award letters and documentation of any other scholarships if applicable."
  },
  "1941": {
      "minGPA": 2.85,
      "requiresFinancialNeed": true,
      "targetStates": [
          "California",
          "New York"
      ],
      "specialRequirements": "Must be 24 years old or younger as of September 1st; family must be employed in the Thoroughbred industry; annual household income must be less than $75,000 or be financially independent from parents. Must submit: current official transcript, resume, Student Aid Report, and two signed letters of recommendation. If Student Aid Report not received, must submit either parent/guardian's previous year's tax return and current year's W2 form or current year's tax return. Application must be completed online only."
  },
  "1942": {
      "targetGradeLevels": [
          "graduate"
      ],
      "requiresFinancialNeed": true,
      "requiredMajors": [
          "commercial explosives industries related fields"
      ],
      "specialRequirements": "Must be attending a university with a degree program in a field related to commercial explosives industries. Open to students from any country. Assessment based on academic and professional achievements, industry goals, personal challenges narrative, and brief statement of financial need."
  },
  "1943": {
      "minGPA": 2.85,
      "requiresFinancialNeed": true,
      "targetStates": [
          "Washington"
      ],
      "requiredMajors": [
          "pre-veterinary medicine (equine emphasis)",
          "equine science",
          "racetrack management",
          "equine business",
          "pasture management",
          "equine marketing and communications"
      ],
      "specialRequirements": "Annual household income less than $75,000 OR financially independent from parents"
  },
  "1944": {
      "minGPA": 3,
      "targetGradeLevels": [
          "high-school-senior"
      ],
      "targetEthnicities": [
          "african-american"
      ],
      "targetStates": [
          "texas"
      ],
      "requiredMajors": [
          "stem",
          "healthcare",
          "nursing"
      ],
      "targetGenders": [
          "female"
      ],
      "specialRequirements": "Must reside in Dallas or Tarrant counties in Texas. High school seniors must be entering college/university in the fall. College students must be currently enrolled. Nursing scholarship applicants must be pursuing a degree in nursing. All applicants must submit resume, transcript, and essay (1500 words or less)."
  },

  // Restored entries (IDs 1100-1158)
  "1100": {
    minGPA: 3.5,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1101": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1102": {
    minGPA: 3.7,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1103": {
    minGPA: 3.7,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1104": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1105": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1106": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1107": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1108": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1109": {
    minGPA: 3.5,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1110": {
    minGPA: 3.5,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1111": {
    minGPA: 3.6,
    targetGradeLevels: ["high-school-senior"],
    requiresFinancialNeed: true,
  },
  "1112": {
    minGPA: 3.5,
    targetGradeLevels: ["high-school-senior"],
  },
  "1113": {
    minGPA: 3.4,
    targetGradeLevels: ["high-school-senior"],
  },
  "1114": {
    minGPA: 3.4,
    targetGradeLevels: ["high-school-senior"],
  },
  "1115": {
    minGPA: 3.3,
    targetGradeLevels: ["high-school-senior"],
  },
  "1116": {
    minGPA: 3.5,
    targetGradeLevels: ["high-school-senior"],
  },
  "1117": {
    minGPA: 3.3,
    targetGradeLevels: ["high-school-senior"],
  },
  "1118": {
    minGPA: 3.4,
    targetGradeLevels: ["high-school-senior"],
  },
  "1119": {
    minGPA: 3,
    targetGradeLevels: ["high-school-senior"],
  },
  "1120": {
    targetGradeLevels: ["high-school-senior","college-freshman"],
    requiresFinancialNeed: true,
  },
  "1121": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1122": {
    targetGradeLevels: ["high-school-senior","college-freshman"],
    requiresFinancialNeed: true,
  },
  "1123": {
    minGPA: 3,
    targetGradeLevels: ["high-school-senior"],
  },  "1125": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1126": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1127": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1128": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1129": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1130": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1131": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1132": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1133": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1134": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1135": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1136": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    requiresFinancialNeed: true,
  },
  "1137": {
    minGPA: 2.5,
    targetGradeLevels: ["high-school-senior","college-freshman"],
  },
  "1138": {
    minGPA: 3,
    targetGradeLevels: ["high-school-senior","college-freshman"],
  },
  "1139": {
    minGPA: 3,
    targetGradeLevels: ["high-school-senior"],
  },
  "1140": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1141": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1142": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1143": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1144": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1145": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },  "1147": {
    targetGradeLevels: ["college-freshman","college-sophomore","college-junior","college-senior"],
  },  "1149": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1150": {
    minGPA: 2.5,
    targetGradeLevels: ["high-school-senior","college-freshman"],
  },
  "1151": {
    minGPA: 2,
    targetGradeLevels: ["high-school-senior","college-freshman"],
  },
  "1152": {
    minGPA: 3,
    targetGradeLevels: ["high-school-senior","college-freshman"],
  },
  "1153": {
    minGPA: 2.5,
    targetGradeLevels: ["high-school-senior","college-freshman"],
  },
  "1154": {
    minGPA: 2,
    targetGradeLevels: ["high-school-senior","college-freshman"],
    requiresFinancialNeed: true,
  },
  "1155": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiredActivities: ["leadership","community-service"],
  },
  "1156": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },
  "1157": {
    targetGradeLevels: ["high-school-junior","high-school-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiredActivities: ["creativity","fashion"],
  },
  "1158": {
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
  },

  // Added missing eligibility entries
  "618": {
    minGPA: 0,
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore"],
    citizenshipRequired: ["us-citizen","permanent-resident","international"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: ["entrepreneurship","leadership"],
  },
  "730": {
    minGPA: 0,
    targetGradeLevels: ["high-school-sophomore","high-school-junior","high-school-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: ["arts"],
  },
  "837": {
    minGPA: 3,
    targetGradeLevels: ["high-school-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: true,
    requiredActivities: [],
  },
  "920": {
    minGPA: 3,
    targetGradeLevels: ["college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident","international"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: ["research"],
  },
  "961": {
    minGPA: 0,
    targetGradeLevels: ["high-school-senior"],
    citizenshipRequired: ["us-citizen"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: [],
  },

  // Fix: remaining missing eligibility entries
  "1125": {
    minGPA: 0,
    targetGradeLevels: ["college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: true,
    requiresFAFSA: true,
    requiredActivities: [],
  },
  "1147": {
    minGPA: 0,
    targetGradeLevels: ["college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: [],
  },
  "1149": {
    minGPA: 0,
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: ["leadership","community-service"],
  },
  "1488": {
    minGPA: 0,
    targetGradeLevels: ["college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: ["environmental"],
  },
  "1688": {
    minGPA: 0,
    targetGradeLevels: ["college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident","international"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: [],
  },
  "1713": {
    minGPA: 0,
    targetGradeLevels: ["college-freshman","college-sophomore","college-junior","college-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: [],
    targetEthnicities: ["hispanic-latino"],
  },
  "1876": {
    minGPA: 0,
    targetGradeLevels: ["high-school-senior","college-freshman","college-sophomore"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: [],
  },
  "1891": {
    minGPA: 0,
    targetGradeLevels: ["high-school-senior"],
    citizenshipRequired: ["us-citizen","permanent-resident"],
    requiresPellGrant: false,
    requiresFinancialNeed: false,
    requiresFAFSA: false,
    requiredActivities: ["environmental"],
  },
};
